/* MDS Focus Quiz (theme build). Split from the prototype's single file (mds-focus-quiz.html):
   - content (questions, focus types, explainers, results copy, insert guides) is JSON in <script id="mds-quiz-data">
     (snippets/mds-quiz-data.liquid); product data (variants, prices, availability, images) is JSON in
     <script id="mds-quiz-products">, built by sections/mds-focus-quiz.liquid from Liquid, in the visitor's market.
   - the shared pieces come from the theme: window.BDS (bds-sale-core.js), BDSBuilder (bds-builder.js), BDSProductModal
     (mds-product-modal.js), BDSAddons (bds-addons.js). Each is feature-checked: without it the quiz still runs at full price,
     with no add-on row and with Customize revealing the in-page extras.
   - cart: BDS.cart.add (fallback /cart/add.js), then the theme's drawer (MDS_openCartDrawer, mds:cart:added, <cart-drawer>, /cart).
   - Klaviyo: on email submit buildKlaviyoPayload(email) -> window.MDS_KLAVIYO_SEND(payload) when defined (nothing otherwise).
   Everything renders inside #mds-quiz; overlays are appended there too, never to <body>. */
(function () {
  "use strict";
  var QROOT = document.getElementById("mds-quiz");
  if (!QROOT) return;
  function J(id) { var el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var C = J("mds-quiz-data"), L = J("mds-quiz-products");
  if (!C || !L) { QROOT.setAttribute("data-quiz-error", "data"); return; }
  var quiz = C.quiz, products = (L.products || []).filter(function (p) { return p && p.variants && p.variants.length; });
  var have = {};
  products.forEach(function (p) { have[p.handle] = true; });
  // an item whose product is not sold in this market (or is unpublished) cannot be recommended
  Object.keys(quiz.items).forEach(function (k) { if (!have[quiz.items[k].product]) delete quiz.items[k]; });
  var email = quiz.results.offer.email;
  if (L.cfg && L.cfg.klaviyoListId) email.klaviyoListId = L.cfg.klaviyoListId;
  var ratings = {};
  products.forEach(function (p) { if (p.rating) ratings[p.handle] = { rating: p.rating }; });
  window.MDSQuiz = {
    quiz: quiz, guides: C.guides, discountsEveryday: C.discountsEveryday || [],
    cfg: L.cfg || {}, market: L.market || {}, ratings: ratings,
    catalog: { store: L.store || "", currency: (L.market && L.market.currency) || "USD", products: products, discounts: [] },
  };
})();

// ---- engine ----
// Recommendation engine. Pure functions: answers + quiz rules + catalog in, a recommended setup out.
// Holds no product knowledge of its own; every rule comes from data/quiz.js.
(function (root) {
  function byId(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }

  function resolveVariant(itemId, item, product, answers, quiz) {
    var available = product.variants.filter(function (v) { return v.available; });
    if (!available.length) return null;
    var matches = function (v, needle) { return v.title.toLowerCase().indexOf(needle.toLowerCase()) !== -1; };

    if (item.variant) {
      return available.filter(function (v) { return matches(v, item.variant); })[0] || null;
    }
    var prefs = quiz.variantPrefs[item.product];
    var wanted = prefs ? prefs[answers[prefs.by]] || [] : [];
    for (var i = 0; i < wanted.length; i++) {
      for (var j = 0; j < available.length; j++) if (matches(available[j], wanted[i])) return available[j];
    }
    return available[0];
  }

  // Shopify cart permalink. Lines are { variant, quantity }; quantity defaults to 1.
  function cartUrl(store, lines) {
    return store + "/cart/" + lines.map(function (l) { return l.variant.id + ":" + qty(l); }).join(",");
  }

  function qty(line) {
    return line.quantity || 1;
  }

  // Handles that are never suggested (theme setting bds_no_suggest + the section's own list). Still sold everywhere else.
  function noSuggestList() {
    var b = (root.BDS && root.BDS.noSuggest) || [], c = (root.MDSQuiz && root.MDSQuiz.cfg && root.MDSQuiz.cfg.noSuggest) || [];
    return b.concat(c);
  }

  function recommend(answers, quiz, catalog) {
    var products = {};
    catalog.products.forEach(function (p) { products[p.handle] = p; });

    var problems = answers.problems.map(function (id) { return byId(quiz.problems, id); });
    var primary = problems[0];
    var drill = byId(primary.drill.options, answers.drill) || { boosts: {} };
    var planning = byId(quiz.planning.options, answers.planning) || { boosts: {} };
    var owned = planning.owns || [];
    var excluded = owned.concat(planning.excludes || []);
    var severity = answers.severity;
    var setSize = quiz.severity.setSize[severity];

    var boosts = {};
    [drill.boosts, planning.boosts].forEach(function (b) {
      Object.keys(b || {}).forEach(function (k) { boosts[k] = (boosts[k] || 0) + b[k]; });
    });

    function baseScore(id) {
      var item = quiz.items[id];
      var score = 0;
      problems.forEach(function (p, rank) { score += quiz.problemWeights[rank] * ((item.problems || {})[p.id] || 0); });
      score += (item.places || {})[answers.place] || 0;
      score += boosts[id] || 0;
      if (item.role === "system") score += quiz.severity.systemBias[severity];
      return score;
    }

    // Two systems, never mixed in one setup: desk cards on a stand (cards + tray + pencil) or the Modular Planner
    // (binder + inserts). Their planning answer picks the system; carrying it around picks the planner; otherwise
    // the system that scores higher for their problems wins (see the rebuild below).
    var CARD_IDS = ["task-time", "weeks-habits", "card-pencil-tray"];
    var isPlannerId = function (id) { return id === "a5-binder-cover" || id === "modular-planner-system" || id.indexOf("insert:") === 0; };
    // Their stated planning style wins; location only decides when they have no preference.
    var system = answers.planning === "planner" || answers.planning === "own" ? "planner"
      : answers.planning === "desk" ? "cards"
      : answers.place === "onthego" ? "planner" : null;
    var offSystem = function (id) { return (system === "planner" && (CARD_IDS.indexOf(id) !== -1 || id === "pencil")) || (system === "cards" && isPlannerId(id)); };

    var candidates = Object.keys(quiz.items)
      .filter(function (id) { return excluded.indexOf(id) === -1 && (quiz.items[id].notFor || []).indexOf(answers.place) === -1 && noSuggestList().indexOf(quiz.items[id].product) === -1; })
      .map(function (id) {
        var item = quiz.items[id];
        var product = products[item.product];
        var variant = product && resolveVariant(id, item, product, answers, quiz);
        return variant ? { id: id, item: item, product: product, variant: variant, base: baseScore(id) } : null;
      })
      .filter(Boolean);

    // Greedy build: repeatedly add the best-scoring item that fits, so pairing bonuses
    // (a tray once there are cards, inserts once there is a binder) reflect what is already chosen.
    var inSet, slotCount, sizeUsed, picked;
    function build() {
    inSet = {};
    owned.forEach(function (id) { inSet[id] = true; });
    slotCount = {};
    sizeUsed = 0;
    picked = [];

    function fits(c) {
      if (inSet[c.id]) return false;
      if ((c.item.requires || []).some(function (r) { return !inSet[r]; })) return false;
      if ((slotCount[c.item.slot] || 0) >= ((quiz.slotLimits || {})[c.item.slot] || 1)) return false;
      if (c.item.countsTowardSize !== false && sizeUsed >= setSize) return false;
      return true;
    }

    for (;;) {
      var best = null;
      candidates.forEach(function (c) {
        if (offSystem(c.id) || !fits(c)) return;
        var score = c.base + scorePairs(c.id, inSet, quiz);
        if (score < quiz.threshold) return;
        if (!best || score > best.score) best = { c: c, score: score };
      });
      if (!best) break;
      var chosen = best.c;
      picked.push({ id: chosen.id, item: chosen.item, product: chosen.product, variant: chosen.variant, score: best.score });
      inSet[chosen.id] = true;
      slotCount[chosen.item.slot] = (slotCount[chosen.item.slot] || 0) + 1;
      if (chosen.item.countsTowardSize !== false) sizeUsed++;
    }
    }
    build();
    // Never an empty setup: if the system rule leaves nothing, rebuild without it.
    if (!picked.length && system) { system = null; build(); }
    // No stated preference and the build reached into both systems: keep the one carrying more score and rebuild.
    if (!system) {
      var sum = function (f) { return picked.filter(function (e) { return f(e.id); }).reduce(function (a, e) { return a + e.score; }, 0); };
      var cardScore = sum(function (id) { return CARD_IDS.indexOf(id) !== -1; });
      var plannerScore = sum(isPlannerId);
      if (cardScore && plannerScore) { system = cardScore >= plannerScore ? "cards" : "planner"; build(); }
      else if (plannerScore && inSet.pencil) { system = "planner"; build(); }
    }
    // Cards always come as a kit: the stand and the pencil go in with them.
    if (picked.some(function (e) { return e.id === "task-time" || e.id === "weeks-habits"; })) {
      ["card-pencil-tray", "pencil"].forEach(function (id) {
        if (inSet[id]) return;
        var c = candidates.filter(function (x) { return x.id === id; })[0];
        if (!c) return;
        picked.push({ id: c.id, item: c.item, product: c.product, variant: c.variant, score: c.base + scorePairs(c.id, inSet, quiz) });
        inSet[c.id] = true;
      });
    }

    picked.forEach(function (entry, index) {
      entry.isHero = index === 0;
      entry.reason = reasonFor(entry.id, problems, answers, quiz, inSet);
      entry.alsoHelps = problems
        .filter(function (p) { return p.id !== entry.reason.problem && ((entry.item.problems || {})[p.id] || 0) >= 2; })
        .map(function (p) { return p.name; });
      entry.evidence = quiz.evidence[entry.id] || null;
    });

    var planner = buildPlanner(picked, owned, problems, quiz);
    var kit = findKit(picked, candidates, inSet, products, quiz, catalog.discounts);

    return {
      problems: problems,
      primary: primary,
      drill: drill,
      planning: planning,
      severity: quiz.severity.options.filter(function (o) { return o.value === severity; })[0],
      items: picked,
      planner: planner,
      kit: kit,
      pricing: priceCart(picked.map(lineFor), catalog.discounts),
      makeItStick: severity >= 3 ? quiz.makeItStick : null,
    };
  }

  function reasonFor(id, problems, answers, quiz, inSet) {
    var r = quiz.reasons[id] || {};
    var fit = quiz.items[id].problems || {};
    var problemText = r.problems || {};
    var primary = problems[0].id;
    if (problemText[primary] && fit[primary]) return { text: problemText[primary], problem: primary };
    var withKeys = Object.keys(r.with || {});
    for (var i = 0; i < withKeys.length; i++) {
      if (inSet[withKeys[i]]) return { text: r.with[withKeys[i]], problem: null };
    }
    for (var j = 1; j < problems.length; j++) {
      var p = problems[j].id;
      if (problemText[p] && fit[p]) return { text: problemText[p], problem: p };
    }
    if (r.place && r.place[answers.place]) return { text: r.place[answers.place], problem: null };
    return { text: r.default || "", problem: null };
  }

  function buildPlanner(picked, owned, problems, quiz) {
    if (!quiz.planner) return null;
    var binder = picked.filter(function (e) { return e.id === quiz.planner.binder; })[0] || null;
    var inserts = picked.filter(function (e) { return e.item.role === "insert"; });
    var ownsBinder = owned.indexOf(quiz.planner.binder) !== -1;
    if (!inserts.length || (!binder && !ownsBinder)) return null;

    var recipeProblem = problems.filter(function (p) { return quiz.planner.recipes[p.id]; })[0];
    var recipe = recipeProblem ? quiz.planner.recipes[recipeProblem.id] : null;
    var keys = inserts.map(function (e) { return e.id.replace("insert:", ""); });
    return {
      ownsBinder: ownsBinder,
      binder: binder,
      inserts: inserts,
      title: recipe ? recipe.title : "Your planner",
      problem: recipeProblem || null,
      routine: recipe ? recipe.routine.filter(function (step) { return keys.indexOf(step[2]) !== -1; }) : [],
    };
  }

  // Offer a kit when it bundles at least two recommended items, everything else in it is relevant to this
  // person (never a kit that duplicates a slot they already have, e.g. a second timer), and it is cheaper
  // after automatic discounts than buying those pieces separately.
  function findKit(picked, candidates, inSet, products, quiz, discounts) {
    var pickedIds = picked.map(function (e) { return e.id; });
    var bySlot = {};
    picked.forEach(function (e) { bySlot[e.item.slot] = e.id; });
    var candidateById = {};
    candidates.forEach(function (c) { candidateById[c.id] = c; });

    var best = null;
    Object.keys(products).forEach(function (handle) {
      var kit = products[handle];
      if (!kit.contains) return;
      // Match the kit's variant to the finishes already picked (e.g. "Frost White / Birch"), else the first in stock.
      var pickedTitles = picked.map(function (e) { return e.variant ? e.variant.title : ""; }).filter(Boolean);
      var variant = kit.variants.filter(function (v) { return v.available; }).sort(function (a, b) {
        var fit = function (v) { return pickedTitles.filter(function (t) { return v.title.indexOf(t) !== -1; }).length; };
        return fit(b) - fit(a);
      })[0];
      if (!variant) return;
      var covers = [];
      var extras = [];
      var ok = kit.contains.every(function (id) {
        if (pickedIds.indexOf(id) !== -1) { covers.push(id); return true; }
        var item = quiz.items[id];
        var c = candidateById[id];
        if (!item || !c || bySlot[item.slot] || inSet[id]) return false;
        if (!kit.promote && c.base + scorePairs(id, inSet, quiz) < quiz.threshold) return false;
        extras.push(id);
        return true;
      });
      // Most of the kit must be things we recommended; it should not be an upsell in disguise.
      if (!ok || covers.length < 2 || extras.length >= covers.length) return;
      var separate = covers.concat(extras).map(function (id) { return lineFor(candidateById[id]); });
      var saving = round(priceCart(separate, discounts).total - priceCart([{ handle: kit.handle, variant: variant }], discounts).total);
      if (saving <= 0) return;
      if (best && best.product.promote && !kit.promote) return;
      if (
        !best ||
        (kit.promote && !best.product.promote) ||
        covers.length > best.covers.length ||
        (covers.length === best.covers.length && (saving > best.saving || (saving === best.saving && extras.length < best.extras.length)))
      ) {
        best = { product: kit, variant: variant, covers: covers, extras: extras, saving: saving };
      }
    });
    if (!best) return null;

    return {
      product: best.product,
      variant: best.variant,
      covers: best.covers,
      extras: best.extras.map(function (id) { return candidateById[id].product.title; }),
      coverTitles: best.covers.map(function (id) { return candidateById[id].product.title; }),
      saving: best.saving,
    };
  }

  function lineFor(entry) {
    return { handle: entry.product.handle, variant: entry.variant };
  }

  // Prices a cart the way Shopify's automatic discounts would: each line gets the single best product discount
  // whose targets and minimum quantity it meets. Lines are { handle, variant, quantity }; quantity defaults to 1,
  // and minimum quantities count units across every line a rule targets, as Shopify does.
  // Same rule as BDS.priceOf (full = compare_at when set, else the price; sale = full x (1 - Birthday %), to the cent), computed
  // from the quiz's own Liquid variant so it never depends on window.BDS_PRODUCTS (the builder owns that global).
  function bdsPrice(line) {
    var B = root.BDS, v = line.variant;
    if (!B || !B.pctFor || !B.salePrice || !v) return null;
    var full = Math.max(+v.price || 0, +v.compareAt || 0);
    if (!full) return null;
    return { variantId: v.id, full: full, sale: B.salePrice(full, line.handle, v.title, v.id), pct: B.pctFor(line.handle, v.title, v.id) };
  }

  function priceCart(lines, discounts) {
    function targets(rule, line) {
      return (rule.products || []).indexOf(line.handle) !== -1 || (rule.variants || []).indexOf(line.variant.id) !== -1;
    }
    function count(rule) {
      return lines.reduce(function (sum, l) { return sum + (targets(rule, l) ? qty(l) : 0); }, 0);
    }

    // Planner insert tiers (Sam, 16 Oct): the inserts are the one exception to the per-product discount. The cart prices the
    // binder cover and every insert at the tier for the number of inserts (REFILL15/20/30 loose, PLANNER n% OFF as a pack:
    // 2 / 4 / 6 -> 15 / 20 / 30%, nothing under 2), not at the product's own %. One source for the tiers and the handles:
    // window.BDS_BUILDER_CFG.planner (snippets/bds-planner-customize.liquid, the builder's "Insert tiers" setting), which the
    // theme layout emits on every page and the builder and its Customize popup read too. No copy of the table lives here.
    var PC = (root.BDS_BUILDER_CFG && root.BDS_BUILDER_CFG.planner) || {};
    var insTiers = PC.tiers || [], insH = PC.inserts || "a5-planner-inserts", coverH = PC.cover || "a5-binder-cover";
    var insN = lines.reduce(function (n, l) { return n + (l.handle === insH ? qty(l) : 0); }, 0);
    var insPct = insTiers.reduce(function (p, t) { return insN >= t[0] ? Math.max(p, t[1]) : p; }, 0);
    var tierCut = function (full, pct) { var c = Math.round(full * 100); return (c - Math.floor(c * pct / 100 + 1e-7)) / 100; };
    var priced = lines.map(function (line) {
      var best = null;
      (discounts || []).forEach(function (rule) {
        if (!targets(rule, line) || count(rule) < (rule.minQuantity || 1)) return;
        if (!best || rule.percent > best.percent) best = rule;
      });
      // The same numbers the rest of the theme shows (BDS.pctFor / BDS.salePrice, settings.bds_pct) on the full price the store
      // gives this market. Without BDS (sale layer off) the quiz prices at the variant price.
      var P = bdsPrice(line);
      var base = P ? P.full : (line.variant.compareAt > line.variant.price ? line.variant.compareAt : line.variant.price);
      // Not in the shared catalog but on the Birthday list (the Pencil): same rounding rule via BDS.salePrice.
      // (or not on it but with its own LTA discount rate, BDS.rates: the timer + planner kits)
      var B = window.BDS, bp = !P && B && B.pct && (B.pct[line.handle] != null || (B.rates && B.rates[line.handle])) ? B.pctFor(line.handle, line.variant.title) : null;
      var final = P ? P.sale : bp != null ? B.salePrice(base, line.handle, line.variant.title) : (best ? discounted(base, best.percent) : line.variant.price);
      var pct = P ? P.pct : bp;
      if (P && insTiers.length && (line.handle === insH || line.handle === coverH)) { final = tierCut(base, insPct); pct = insPct; }
      var disc = pct != null ? (pct ? Object.assign({}, best || {}, { percent: pct }) : null) : best;
      // price/final are per unit; listTotal/total are for the whole line.
      return { line: line, quantity: qty(line), price: base, final: final, listTotal: round(base * qty(line)), total: round(final * qty(line)), discount: disc };
    });

    // Tiered rules worth telling the customer about ("add 1 more insert for 15% off"). Only rules with a
    // `label` are surfaced, and only the nearest better tier for each label.
    var nudges = {};
    (discounts || []).forEach(function (rule) {
      if (!rule.label) return;
      var have = count(rule);
      if (!have || have >= rule.minQuantity) return;
      var current = priced
        .filter(function (p) { return targets(rule, p.line); })
        .reduce(function (max, p) { return Math.max(max, p.discount ? p.discount.percent : 0); }, 0);
      if (rule.percent <= current) return;
      var needed = rule.minQuantity - have;
      if (!nudges[rule.label] || needed < nudges[rule.label].needed) nudges[rule.label] = { label: rule.label, needed: needed, percent: rule.percent };
    });

    var subtotal = round(priced.reduce(function (sum, p) { return sum + p.listTotal; }, 0));
    var total = round(priced.reduce(function (sum, p) { return sum + p.total; }, 0));
    return {
      lines: priced,
      subtotal: subtotal,
      total: total,
      savings: round(subtotal - total),
      nudges: Object.keys(nudges).map(function (k) { return nudges[k]; }),
    };
  }

  function scorePairs(id, inSet, quiz) {
    var pairs = quiz.items[id].pairs || {};
    return Object.keys(pairs).reduce(function (sum, k) { return sum + (inSet[k] ? pairs[k] : 0); }, 0);
  }

  function round(n) { return Math.round(n * 100) / 100; }

  // Works in whole cents and rounds the discount amount (not the result), so 50% off $19.99 is $9.99.
  function discounted(price, percent) {
    var cents = Math.round(price * 100);
    return (cents - Math.round((cents * percent) / 100)) / 100;
  }

  var engine = { recommend: recommend, resolveVariant: resolveVariant, cartUrl: cartUrl, priceCart: priceCart, lineFor: lineFor };
  if (typeof module !== "undefined" && module.exports) module.exports = engine;
  else (root.MDSQuiz = root.MDSQuiz || {}).engine = engine;
})(typeof window !== "undefined" ? window : globalThis);


// ---- app ----
// Quiz UI: a small step machine that renders each screen into #app.
(function () {
  var M = window.MDSQuiz;
  var quiz = M.quiz;
  var catalog = M.catalog;
  var engine = M.engine;
  var CFGQ = M.cfg || {};
  var QROOT = document.getElementById("mds-quiz") || document.body;
  var BDSNAV = function () { return (window.BDS && window.BDS.routes) || {}; };
  var CART_URL = function () { return BDSNAV().cart || "/cart"; };
  function noSuggest() { return ((window.BDS && window.BDS.noSuggest) || []).concat(CFGQ.noSuggest || []); }
  // the builder (Bear) may not be on the page; when it is, it only carries products in its own catalogue
  function builderKnown(h) {
    var b = window.BDSBuilder; if (!b || !b.slideout) return true;
    var k = typeof b.byH === "function" ? b.byH() : b.byH;
    return !k || !!k[h];
  }

  // Desktop setup card: the colour line opens its swatches (item 36).
  document.addEventListener("click", function (e) {
    var p = e.target.closest && e.target.closest(".res-setup .picker");
    if (!p || p.classList.contains("is-open") || !window.matchMedia("(min-width: 1024px)").matches) return;
    if (e.target.closest("button")) return;
    p.classList.add("is-open");
  });
  document.addEventListener("keydown", function (e) {
    var p = e.target.closest && e.target.closest(".res-setup .picker");
    if (p && (e.key === "Enter" || e.key === " ") && e.target === p) { e.preventDefault(); p.classList.add("is-open"); }
  });

  // Focus Report interactions: tilt with the pointer, count-up once, one-tap easter eggs. None of it blocks buying.
  (function () {
    var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var pop = function (el, text) {
      var r = el.getBoundingClientRect(), b = document.createElement("div");
      b.className = "egg-pop"; b.textContent = text; QROOT.appendChild(b);
      b.style.left = Math.max(16, Math.min(window.innerWidth - b.offsetWidth - 16, r.left)) + "px";
      b.style.top = Math.min(window.innerHeight - b.offsetHeight - 16, r.bottom + 8) + "px";
      setTimeout(function () { b.remove(); }, 2700);
    };
    var timer = null;
    document.addEventListener("click", function (e) {
      var el = e.target.closest && e.target.closest("[data-egg]");
      if (!el) return;
      var kind = el.getAttribute("data-egg"), p = primary(), t = TYPES[p.id] || [];
      if (kind === "seal") {
        // Each tap flips the seal between the tick and the vibe's icon; the hint goes after the first.
        var rc = el.closest(".report"); if (rc) { rc.classList.add("seal-tapped"); rc.classList.toggle("seal-on"); }
        el.classList.remove("is-spin"); void el.offsetWidth; if (!still) el.classList.add("is-spin");
        pop(el, "Yes, it's official.");
      } else if (kind === "type") pop(el, t[3] || "");
      else if (kind === "score") pop(el, SCORE_NOTES[el.getAttribute("data-dim")] || "");
    });
    document.addEventListener("click", function (e) {
      var tg = e.target.closest && e.target.closest("[data-report]");
      if (!tg) return;
      var card = document.getElementById("report"), more = document.getElementById("report-more");
      var open = tg.getAttribute("data-report") === "more";
      more.hidden = !open; card.classList.toggle("is-open", open);
      var moreBtn = card.querySelector(".report__toggle--more");
      moreBtn.setAttribute("aria-expanded", String(open));
      moreBtn.hidden = open;
      if (!open) window.scrollTo({ top: card.getBoundingClientRect().top + window.scrollY - 120, behavior: "smooth" });
    });
    document.addEventListener("click", function (e) {
      var tl = e.target.closest && e.target.closest("[data-tool]");
      if (tl && window.BDSProductModal) window.BDSProductModal.open(tl.getAttribute("data-tool"), { context: "quiz", backLabel: "Back to my results", variantId: +tl.getAttribute("data-tool-variant") || undefined });
    });
    document.addEventListener("keydown", function (e) { if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches("[data-egg][tabindex]")) { e.preventDefault(); e.target.click(); } });
    if (!still && window.matchMedia && window.matchMedia("(pointer: fine)").matches) {
      document.addEventListener("pointermove", function (e) {
        var c = document.querySelector(".report"); if (!c) return;
        var r = c.getBoundingClientRect(), inside = e.clientX > r.left && e.clientX < r.right && e.clientY > r.top && e.clientY < r.bottom;
        c.style.setProperty("--tilt", inside ? "perspective(900px) rotateX(" + (-((e.clientY - r.top) / r.height - 0.5) * 4).toFixed(2) + "deg) rotateY(" + (((e.clientX - r.left) / r.width - 0.5) * 4).toFixed(2) + "deg)" : "none");
      }, { passive: true });
    }
    new MutationObserver(function () {
      var nums = document.querySelectorAll(".profile--table .count:not([data-done])");
      if (!nums.length) return;
      nums.forEach(function (n) {
        n.setAttribute("data-done", "1");
        if (still) return;
        var to = +n.getAttribute("data-to"), t0 = performance.now();
        var step = function (now) { var k = Math.min(1, (now - t0) / 300); n.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      });
    }).observe(document.getElementById("app"), { childList: true, subtree: true });
  })();

  // Shared steppers inside the quiz's setup step the quiz's own state: rows (− at 1 unticks the row) and add-ons (− at 1 removes).
  window.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-qs]");
    if (!b) return;
    var g = b.closest("[data-qs-row], [data-qs-extra]");
    if (!g) return;
    e.stopPropagation(); e.preventDefault();
    var d = +b.getAttribute("data-qs");
    window.dispatchEvent(new CustomEvent("quiz-qs", { detail: { row: g.getAttribute("data-qs-row"), extra: g.getAttribute("data-qs-extra"), d: d } }));
  }, true);
  // Quiz adds go to the store cart (one request, so a partial add can't happen) and open the theme's cart drawer.
  var builderOn = false, builderBase = null, builderUnsub = null;
  function cartQtyMap() {
    var B = window.BDS;
    var p = B && B.cart && B.cart.get ? B.cart.get() : fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
    return p.then(function (c) {
      var m = {};
      ((c && c.items) || []).forEach(function (it) { if (it.properties && it.properties._bds_gift) return; m[it.variant_id] = (m[it.variant_id] || 0) + it.quantity; });
      return m;
    });
  }
  function openCartDrawer(items) {
    var R = BDSNAV(), root = R.root || "/";
    if (typeof window.MDS_openCartDrawer === "function") { window.MDS_openCartDrawer(); return; }
    var ev = new CustomEvent("mds:cart:added", { detail: { items: items, source: "quiz" }, cancelable: true });
    document.dispatchEvent(ev);
    if (ev.defaultPrevented) return;
    var cd = document.querySelector("cart-drawer");
    if (cd && typeof cd.open === "function") {
      var sid = cd.sectionId || (cd.dataset && cd.dataset.sectionId) || "cart-drawer";
      fetch(root + "?sections=" + encodeURIComponent(sid))
        .then(function (r) { return r.json(); })
        .then(function (s) { if (typeof cd.renderContents === "function") cd.renderContents({ sections: s }); else cd.open(); })
        .catch(function () { location.href = CART_URL(); });
      return;
    }
    location.href = CART_URL();
  }
  function addToStoreCart(lines) {
    var items = lines.map(function (l) { return { id: +l.variant.id, quantity: l.quantity || 1 }; });
    // After Customize the builder already put the setup in the store cart: add only what is missing, never double it.
    var prep = builderOn ? cartQtyMap().then(function (have) {
      return items.map(function (it) { return { id: it.id, quantity: it.quantity - (have[it.id] || 0) }; }).filter(function (it) { return it.quantity > 0; });
    }) : Promise.resolve(items);
    var send = function (todo) {
      // ownError: a failure is said on the quiz's own button, so the cart drawer does not also open on its failure notice
      if (window.BDS && window.BDS.cart && window.BDS.cart.add) return window.BDS.cart.add(todo, { ownError: true });
      var props = CFGQ.saleActive ? { _bundle: "birthday" } : {};
      var root = BDSNAV().root || "/";
      return fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: todo.map(function (it) { return { id: it.id, quantity: it.quantity, properties: props }; }) }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (c) { document.dispatchEvent(new CustomEvent("cart:updated", { detail: c })); });
    };
    // Shopify throttles /cart/add with a 429 under load: wait and try again (twice) rather than open an empty cart.
    var sendRetry = function (todo, left) {
      return send(todo).catch(function (e) {
        if (!e || e.status !== 429 || !left) throw e;
        return new Promise(function (ok) { setTimeout(ok, 1500 * (3 - left)); }).then(function () { return sendRetry(todo, left - 1); });
      });
    };
    return prep.then(function (todo) {
      if (!todo.length) return null;
      return sendRetry(todo, 2);
    }).then(function () { openCartDrawer(items); });
    // A failed add rejects to the caller, which says so on the button and keeps the setup. It never navigates: /cart
    // would be empty and say nothing about why.
  }
  document.addEventListener("toggle", function (e) { if (e.target && e.target.classList && e.target.classList.contains("addons") && window.matchMedia("(min-width: 1024px)").matches) window.__aoOpen = e.target.open; }, true);
  var straighten = function (root) {
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) if (/[\u2018\u2019\u201C\u201D]/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
  };
  straighten(QROOT);
  if (window.MutationObserver) new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) straighten(n); else if (n.nodeType === 3 && /[\u2018\u2019\u201C\u201D]/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"'); }); }); }).observe(QROOT, { childList: true, subtree: true });
  var markRails = function () {
    document.querySelectorAll(".results .proof .vids, .results .proof .proof__rail, .addons__row").forEach(function (r) {
      var max = r.scrollWidth - r.clientWidth;
      r.classList.toggle("is-fade", max > 4 && r.scrollLeft < max - 4);
      var w = r.parentElement; if (!w || !w.classList.contains("qrail")) return;
      var p = w.querySelector('[data-rail-nav="-1"]'), n = w.querySelector('[data-rail-nav="1"]');
      if (p) p.hidden = r.scrollLeft <= 2;
      if (n) n.hidden = max <= 4 || r.scrollLeft >= max - 2;
    });
  };
  var railOf = function (el) { var w = el && el.closest && el.closest(".qrail"); return w ? w.querySelector(".vids, .proof__rail, .addons__row") : null; };
  var reducedMotion = function () { return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; };
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-rail-nav]"); if (!b) return;
    var r = railOf(b); if (!r) return;
    e.preventDefault();
    var c = r.firstElementChild, gap = parseFloat(getComputedStyle(r).columnGap) || 12;
    var step = c ? Math.max(c.offsetWidth + gap, Math.floor(r.clientWidth / (c.offsetWidth + gap)) * (c.offsetWidth + gap)) : r.clientWidth * 0.8;
    r.scrollBy({ left: +b.dataset.railNav * step, behavior: reducedMotion() ? "auto" : "smooth" });
  });
  // mouse click-and-drag (touch and trackpads scroll natively). Past 5px it is a drag, and the click it ends on is
  // swallowed, so letting go over a video doesn't start it.
  var railDrag = null, railDragEnd = 0;
  document.addEventListener("pointerdown", function (e) {
    if (e.pointerType !== "mouse" || e.button !== 0 || (e.target.closest && e.target.closest("[data-rail-nav]"))) return;
    var r = e.target.closest && e.target.closest(".results .proof .vids, .results .proof .proof__rail, .addons__row");
    if (!r || r.scrollWidth <= r.clientWidth) return;
    railDrag = { r: r, id: e.pointerId, x: e.clientX, left: r.scrollLeft, moved: false };
  });
  document.addEventListener("pointermove", function (e) {
    if (!railDrag || e.pointerId !== railDrag.id) return;
    var dx = e.clientX - railDrag.x;
    if (!railDrag.moved) {
      if (Math.abs(dx) < 5) return;
      railDrag.moved = true; railDrag.r.classList.add("is-drag");
      try { railDrag.r.setPointerCapture(e.pointerId); } catch (x) { /* ignore */ }
    }
    railDrag.r.scrollLeft = railDrag.left - dx;
  });
  var endRailDrag = function (e) {
    if (!railDrag || e.pointerId !== railDrag.id) return;
    if (railDrag.moved) { railDrag.r.classList.remove("is-drag"); railDragEnd = Date.now(); }
    railDrag = null;
  };
  document.addEventListener("pointerup", endRailDrag);
  document.addEventListener("pointercancel", endRailDrag);
  window.addEventListener("click", function (e) {
    if (Date.now() - railDragEnd < 300 && e.target.closest && e.target.closest(".results .proof .vids, .results .proof .proof__rail, .addons__row")) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener("dragstart", function (e) { if (e.target.closest && e.target.closest(".results .proof .vids, .results .proof .proof__rail, .addons__row")) e.preventDefault(); });
  window.addEventListener("resize", markRails);
  document.addEventListener("scroll", markRails, true);
  setInterval(markRails, 600);
  var markOverflow = function () {
    var c = document.getElementById("cart");
    if (c) c.classList.toggle("has-more", c.scrollHeight > c.clientHeight + 4 && c.scrollTop + c.clientHeight < c.scrollHeight - 4);
  };
  window.addEventListener("resize", markOverflow);
  setInterval(markOverflow, 600);
  document.addEventListener("scroll", function (e) {
    var c = e.target && e.target.id === "cart" ? e.target : null;
    if (c) c.classList.toggle("is-end", c.scrollTop + c.clientHeight >= c.scrollHeight - 4);
  }, true);

  var app = document.getElementById("app");
  var bar = document.querySelector(".progress__bar");
  var debug = /[?&]debug\b/.test(location.search);
  var money = new Intl.NumberFormat("en-AU", { style: "currency", currency: catalog.currency });

  var answers;
  var current;
  var advancing = false;

  var STEPS = [
    { id: "intro" },
    { id: "problems", question: true },
    { id: "rank", question: true, when: function (a) { return a.problems.length > 1; } },
    { id: "style", question: true },
    { id: "education" },
    { id: "drill", question: true },
    { id: "holdback", question: true },
    { id: "place", question: true },
    { id: "planning", question: true },
    { id: "severity", question: true },
    { id: "email" },
    { id: "analyzing" },
    { id: "results" },
  ];

  function visibleSteps() {
    return STEPS.filter(function (s) { return !s.when || s.when(answers); });
  }

  var showAllProblems = false;

  function reset() {
    showAllProblems = false;
    answers = { style: null, place: null, planning: null, problems: [], drill: null, holdback: null, severity: null };
    QROOT.removeAttribute("data-vibe");
  }

  function go(stepId) {
    current = stepId;
    // Never carry a scroll lock or a leftover overlay into the next screen.
    document.documentElement.classList.remove("sheet-open");
    QROOT.classList.remove("vibe-anim");
    document.querySelectorAll(".vibe-flash, .vibe-spark, .vibe-bloom").forEach(function (el) { el.remove(); });
    // Progress is a step's place in the full, fixed step list, so it only ever moves forward: answers that add or
    // skip the rank step never change the scale, and Back lands on exactly the width that step had before.
    var fixedIndex = STEPS.findIndex(function (s) { return s.id === stepId; });
    bar.style.width = (Math.max(0, fixedIndex) / (STEPS.length - 1)) * 100 + "%";
    app.innerHTML = RENDER[stepId]();
    if (stepId === "results") {
      // One Add button at a time and nothing covered on the first screen: the sticky bar stays tucked while the
      // offer strip (which carries the saving) or the Recommended block's button is on screen.
      var tuck = function () {
        var bar = document.querySelector(".checkout");
        if (!bar) return;
        var seen = [".mini__add"].some(function (sel) {
          var el = app.querySelector(sel);
          if (!el) return false;
          var rc = el.getBoundingClientRect();
          return rc.bottom > 0 && rc.top < window.innerHeight;
        });
        bar.classList.toggle("is-tucked", seen && !app.querySelector(".sheet"));
        // Never two Add buttons on screen: the bar steps aside while the inline Add to cart is visible.
        var inlineAdd = app.querySelector(".setup-cta .mini__add");
        var ir = inlineAdd && inlineAdd.getBoundingClientRect();
        var endBtn = app.querySelector(".end-cta__btn"), er = endBtn && endBtn.getBoundingClientRect();
        var onScreen = function (q) { return !!q && q.top < window.innerHeight - 20 && q.bottom > 120; };
        bar.classList.toggle("is-away", window.innerWidth < 1024 && (onScreen(ir) || onScreen(er)));
        // Content is never hidden behind the bar: the page always ends with the bar's height plus a gap.
        var resEl = app.querySelector(".results");
        if (resEl) resEl.style.paddingBottom = window.innerWidth < 1024 ? bar.offsetHeight + 24 + "px" : "";
        var setupSec = document.getElementById("res-2");
        bar.classList.toggle("is-slim", false);
        // Scroll-spy: the tab for the section in view is the current one.
        // A section is current once its top passes a line just under the sticky tabs, measured where the tabs are
        // now (they move up when the theme header hides on scroll-down). Where the setup stacks under the results
        // (phones, tablets) it counts as Fix; on desktop it is the sticky column beside them and always "passed",
        // so there it says nothing about which section is being read.
        var at = 0;
        var tabs = app.querySelectorAll(".res-nav [data-jump]");
        var navEl = app.querySelector(".res-nav");
        var spyLine = (navEl ? navEl.getBoundingClientRect().bottom : navStack()) + 48;
        var headEl = document.getElementById("res-0");
        tabs.forEach(function (b, i) {
          var id = b.getAttribute("data-jump"), sec = document.getElementById(id);
          b.hidden = !sec;
          if (sec && sec.getBoundingClientRect().top <= spyLine) at = i;
          if (id === "res-fix") {
            var su = document.getElementById("res-2");
            var stacked = su && headEl && su.getBoundingClientRect().left < headEl.getBoundingClientRect().right - 1;
            if (stacked && su.getBoundingClientRect().top <= spyLine) at = Math.max(at, i);
          }
        });
        var whyEl = document.getElementById("res-1");
        if (whyEl && window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4 && whyEl.getBoundingClientRect().top < window.innerHeight * 0.6) at = tabs.length - 1;
        tabs.forEach(function (b, i) { b.toggleAttribute("aria-current", i === at); });
      };
      window.removeEventListener("scroll", window.__tuck);
      window.__tuck = tuck;
      window.addEventListener("scroll", tuck, { passive: true });
      setTimeout(tuck, 0);
    }
    var cameo = quiz.results && quiz.results.images && quiz.results.images.cameos[stepId];
    var hintEl = cameo && (app.querySelector(".step .hint") || app.querySelector(".step h1"));
    if (hintEl) hintEl.insertAdjacentHTML("afterend", '<img class="cameo" src="' + cameo + '" alt="" width="460" height="200" />');
    app.setAttribute("data-step", stepId);
    clearTimeout(window.__analyzeTimer);
    // Mobile intro: Start lives in a bar on <body>, always visible, styled like the question Continue bar.
    var oldBar = document.getElementById("intro-bar");
    if (oldBar) oldBar.remove();
    var introCta = app.querySelector(".step.intro .intro__cta");
    if (introCta && window.matchMedia && window.matchMedia("(max-width: 899px)").matches) {
      var introBar = document.createElement("div");
      introBar.id = "intro-bar";
      introBar.className = "intro-bar";
      introBar.innerHTML = '<button type="button" class="button">' + introCta.querySelector(".button").innerHTML + "</button>" + (introCta.querySelector(".meta") ? '<p class="meta">' + introCta.querySelector(".meta").innerHTML + "</p>" : "");
      introBar.querySelector("button").addEventListener("click", function () { introCta.querySelector(".button").click(); });
      QROOT.appendChild(introBar);
      // Only one Start at a time: the bar shows while the inline button is off screen.
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (es) { introBar.classList.toggle("is-on", !es[0].isIntersecting); }).observe(introCta.querySelector(".button"));
      } else introBar.classList.add("is-on");
    }
    if (stepId === "results" && !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) {
      var gl = document.createElement("div");
      gl.className = "glitter";
      gl.setAttribute("aria-hidden", "true");
      for (var g = 0; g < 42; g++) gl.innerHTML += '<i style="left:' + (Math.random() * 100).toFixed(1) + "%;top:" + (Math.random() * 100).toFixed(1) + "%;animation-delay:" + Math.round(Math.random() * 60) + "ms;--s:" + (0.6 + Math.random() * 0.9).toFixed(2) + '"></i>';
      QROOT.appendChild(gl);
      setTimeout(function () { gl.remove(); }, 1000);
    }
    if (stepId === "analyzing") {
      var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.__analyzeTimer = setTimeout(function () { if (current === "analyzing") go("results"); }, /[?&]fast\b/.test(location.search) ? 300 : still ? 1200 : 4000);
    }
    if (stepId === "results") updateCart();
    window.scrollTo(0, 0);
    advancing = false;
    var heading = app.querySelector("h1");
    if (heading) heading.focus({ preventScroll: true });
  }

  function next() {
    var steps = visibleSteps();
    var index = steps.findIndex(function (s) { return s.id === current; });
    go(steps[index + 1].id);
  }

  function back() {
    var steps = visibleSteps();
    var index = steps.findIndex(function (s) { return s.id === current; });
    var prev = steps[Math.max(0, index - 1)];
    if (prev.id === "analyzing") prev = steps[Math.max(0, index - 2)];
    go(prev.id);
  }

  // ---------- helpers ----------

  // Height of the sticky header stack once stuck: the tab bar's sticky top plus its own height.
  function navStack() {
    var n = document.querySelector(".res-nav");
    if (!n) return 108;
    return (parseFloat(getComputedStyle(n).top) || 0) + n.offsetHeight;
  }
  // Scrolls a results section to just under the sticky tabs. The tabs' top depends on scroll direction (the theme
  // header slides away on the way down and back on the way up), so the first guess is made for the direction of
  // travel and then checked once the scroll settles; the first section always means the very top of the page.
  function jumpTo(target, isFirst) {
    var n = document.querySelector(".res-nav");
    var smooth = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    if (isFirst || !n) { window.scrollTo({ top: isFirst ? 0 : target.getBoundingClientRect().top + window.scrollY - 124, behavior: smooth ? "smooth" : "auto" }); return; }
    var gap = 16;
    var hdr = document.getElementById("HeaderGroup");
    var pin = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--bds-pin-top")) || 0;
    var goal = function () { return target.getBoundingClientRect().top + window.scrollY; };
    var down = goal() - gap - n.offsetHeight > window.scrollY;
    // Going down the header hides (top 0); going up it returns (pin + the 3px progress strip).
    var hides = hdr && getComputedStyle(hdr).position === "fixed";
    var top = down && hides ? 0 : pin + Math.min(3, pin);
    window.scrollTo({ top: Math.max(0, goal() - top - n.offsetHeight - gap), behavior: smooth ? "smooth" : "auto" });
    var settle = function () {
      window.removeEventListener("scrollend", settle);
      clearTimeout(t);
      var want = n.getBoundingClientRect().bottom + gap, off = target.getBoundingClientRect().top - want;
      if (Math.abs(off) > 4) window.scrollTo({ top: Math.max(0, window.scrollY + off), behavior: "auto" });
    };
    var t = setTimeout(settle, 1200);
    if ("onscrollend" in window) window.addEventListener("scrollend", settle);
  }
  function esc(value) {
    return String(value == null ? "" : value).replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // Shopify's CDN resizes on request; any other URL (e.g. bundled copies) is used as is.
  function img(url, width) {
    if (!url) return "";
    if (url.indexOf("https://cdn.shopify.com/") !== 0 || url.indexOf("/assets/") !== -1) return url;
    url = url.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "");
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  // A stat's source line, linked to the study when there is one.
  // Plain source text, never a link out (captain, 13 Oct): credibility without an exit.
  function sourceHtml(stat) {
    return '<span class="source">Source: ' + esc(stat.source) + "</span>";
  }

  function byId(list, id) {
    return list.filter(function (x) { return x.id === id; })[0];
  }

  function primary() {
    return byId(quiz.problems, answers.problems[0]);
  }

  function questionHeader(stepId, title, hint) {
    var questions = visibleSteps().filter(function (s) { return s.question; });
    var number = questions.findIndex(function (s) { return s.id === stepId; }) + 1;
    return (
      '<div class="step__nav"><button type="button" class="back" data-action="back">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 5 8l5 5" /></svg>Back</button>' +
      '<span class="step__count">Question ' + number + " of " + questions.length + "</span></div>" +
      '<h1 class="question" tabindex="-1">' + esc(title) + "</h1>" +
      (hint ? '<p class="hint">' + esc(hint) + "</p>" : "")
    );
  }

  // One line-icon family for the problem, place and planning answers: 24px grid, 1.75 stroke, round caps,
  // drawn in the theme's text colour so it re-themes with the vibe.
  var OPTION_ICONS = {"procrastination": "<path d=\"M7 3h10M7 21h10\"/><path d=\"M8 3v2.5c0 2.6 4 4.2 4 6.5s-4 3.9-4 6.5V21M16 3v2.5c0 2.6-4 4.2-4 6.5s4 3.9 4 6.5V21\"/><path d=\"M10 18.5h4\"/>", "focus": "<circle cx=\"11\" cy=\"13\" r=\"7.5\"/><circle cx=\"11\" cy=\"13\" r=\"3\"/><path d=\"M11 13l9-9M16.5 4H20v3.5\"/><path d=\"M3 4.5l2 2M19.5 19.5l1.5 1.5\"/>", "overwhelm": "<ellipse cx=\"12\" cy=\"7\" rx=\"8\" ry=\"2.6\"/><path d=\"M4 7v2.8c0 1.4 3.6 2.6 8 2.6s8-1.2 8-2.6V7\"/><path d=\"M4 12.6v2.8c0 1.4 3.6 2.6 8 2.6s8-1.2 8-2.6v-2.8\"/><path d=\"M5.5 18.6c1.5 1 3.8 1.6 6.5 1.6s5-.6 6.5-1.6\"/>", "time": "<path d=\"M5 10.5a7 7 0 0 1 14 0c0 2.6-.9 3.8-2 4.8v4.2a1.2 1.2 0 0 1-2.4 0v-2.6c-.8.3-1.7.5-2.6.5-3.9 0-7-3-7-6.9z\"/><path d=\"M12 6.5v4l2.5 1.6\"/><path d=\"M8 19.5v1.5\"/>", "phone": "<rect x=\"7.5\" y=\"3.5\" width=\"9\" height=\"17\" rx=\"2\"/><path d=\"M11 17.5h2M4.5 9v6M2 10.5v3M19.5 9v6M22 10.5v3\"/><circle cx=\"16\" cy=\"4.5\" r=\"2.2\"/>", "habits": "<rect x=\"3\" y=\"5\" width=\"18\" height=\"16\" rx=\"2.5\"/><path d=\"M3 10h18M8 3v4M16 3v4\"/><path d=\"M5.8 15.2l1 1 1.8-2M10.8 15.2l1 1 1.8-2\"/><path d=\"M16.2 14.2h2.4v2.4h-2.4z\" stroke-dasharray=\"1.2 1.2\"/>", "clutter": "<path d=\"M3 20h18\"/><path d=\"M5 20v-5.5h5.5V20\"/><path d=\"M12.5 11.5l4-1.6 2.6 3.8-4 1.6z\"/><circle cx=\"17.5\" cy=\"17.5\" r=\"2\"/><path d=\"M6.5 11c1-1.5 2.5-1.5 3.5-3s2.5-1.5 3.5-3\"/>", "multitasking": "<circle cx=\"6\" cy=\"10\" r=\"2.2\"/><circle cx=\"12\" cy=\"5\" r=\"2.2\"/><circle cx=\"18\" cy=\"10\" r=\"2.2\"/><path d=\"M4 17c2.4 3 13.6 3 16 0\"/><path d=\"M8.4 8.4l1.4-1.4M14.2 7l1.4 1.4\"/>", "study": "<path d=\"M12 6.5c-2-1.6-5-2.2-8-2.2v13.6c3 0 6 .6 8 2.1 2-1.5 5-2.1 8-2.1V4.3c-3 0-6 .6-8 2.2z\"/><path d=\"M12 6.5v13.5\"/>", "switchoff": "<rect x=\"4.5\" y=\"5\" width=\"15\" height=\"10\" rx=\"1.5\"/><path d=\"M2.5 18.5h19\"/><path d=\"M12 7.5v2.5M9.9 8.6a3 3 0 1 0 4.2 0\"/>", "home": "<path d=\"M4 10.5L12 4l8 6.5V20H4z\"/><path d=\"M10 20v-5h4v5\"/>", "office": "<path d=\"M5 20V4.5h10V20M15 9h4v11M3 20h18\"/><path d=\"M8 8h1M11 8h1M8 11.5h1M11 11.5h1M8 15h1M11 15h1\"/>", "onthego": "<path d=\"M7 9a5 5 0 0 1 10 0v11H7z\"/><path d=\"M10 4h4M9.5 14h5v3h-5z\"/>", "planner": "<rect x=\"5\" y=\"3\" width=\"14\" height=\"18\" rx=\"2\"/><path d=\"M9 3v18M3.5 7.5h3M3.5 12h3M3.5 16.5h3M12 8h4M12 11h3\"/>", "desk": "<rect x=\"6\" y=\"3.5\" width=\"12\" height=\"11\" rx=\"1.5\"/><path d=\"M9 7.5h6M9 10.5h4\"/><path d=\"M4 17h16v3H4z\"/>", "own": "<rect x=\"5\" y=\"3\" width=\"14\" height=\"18\" rx=\"2\"/><path d=\"M9 3v18M3.5 7.5h3M3.5 12h3M3.5 16.5h3\"/><path d=\"M11.5 12l1.8 1.8 3.2-3.6\"/>", "none": "<path d=\"M5 19l1-4L16 5l3 3L9 18z\"/><path d=\"M14 7l3 3\"/><path d=\"M19 15.5v3M17.5 17h3\"/>"};
  // Captain, 14 Oct: light icons on every answer screen (problems, rank, drill, place, planning), one simple metaphor each.
  var LIGHT_ICONS = {"problems": {"procrastination": "<path d=\"M7 3h10M7 21h10M8 3c0 5 8 6 8 9s-8 4-8 9M16 3c0 5-8 6-8 9s8 4 8 9\"/>", "focus": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><circle cx=\"12\" cy=\"12\" r=\"4\"/><circle cx=\"12\" cy=\"12\" r=\".6\"/>", "overwhelm": "<rect x=\"7.5\" y=\"3\" width=\"12\" height=\"15\" rx=\"1.5\"/><path d=\"M5 6.5v13A1.5 1.5 0 0 0 6.5 21H16\"/>", "time": "<circle cx=\"12\" cy=\"12\" r=\"8.5\"/><path d=\"M12 7.5V12l3 2\"/>", "phone": "<rect x=\"7\" y=\"3\" width=\"10\" height=\"18\" rx=\"2\"/><path d=\"M11 18h2\"/>", "habits": "<rect x=\"3.5\" y=\"5\" width=\"17\" height=\"15.5\" rx=\"2\"/><path d=\"M3.5 10h17M8 3v4M16 3v4M7 14h2M11 14h2M15 14h2M7 17.5h2M15 17.5h2\"/>", "clutter": "<rect x=\"4\" y=\"12.5\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"13\" y=\"4.5\" width=\"7\" height=\"7\" rx=\"1\" transform=\"rotate(14 16.5 8)\"/><circle cx=\"16.5\" cy=\"17\" r=\"2.5\"/>", "multitasking": "<rect x=\"3\" y=\"8\" width=\"13\" height=\"11\" rx=\"1.5\"/><path d=\"M8 8V6a1.5 1.5 0 0 1 1.5-1.5h10A1.5 1.5 0 0 1 21 6v8a1.5 1.5 0 0 1-1.5 1.5H16\"/>", "study": "<path d=\"M12 6.5c-2-1.5-5-2-8-2V18c3 0 6 .5 8 2 2-1.5 5-2 8-2V4.5c-3 0-6 .5-8 2zM12 6.5V20\"/>", "switchoff": "<path d=\"M12 3v8\"/><path d=\"M7 6.5a7 7 0 1 0 10 0\"/>"}, "place": {"home": "<path d=\"M4 11 12 4.5l8 6.5V20H4z\"/><path d=\"M10 20v-5h4v5\"/>", "office": "<path d=\"M6 20V4h9v16M15 9h3.5v11M4 20h16M9 8h3M9 12h3M9 16h3\"/>", "onthego": "<path d=\"M7 9a5 5 0 0 1 10 0v11H7z\"/><path d=\"M10 4.5h4M10 14h4\"/>"}, "planning": {"planner": "<rect x=\"6\" y=\"3\" width=\"13\" height=\"18\" rx=\"1.5\"/><path d=\"M9.5 3v18M4.5 7.5h3M4.5 12h3M4.5 16.5h3\"/>", "desk": "<rect x=\"7\" y=\"4\" width=\"10\" height=\"11\" rx=\"1\"/><path d=\"M9.5 8h5M9.5 11h3M4 17.5h16v2.5H4z\"/>", "own": "<rect x=\"6\" y=\"3\" width=\"13\" height=\"18\" rx=\"1.5\"/><path d=\"M9.5 3v18M4.5 7.5h3M4.5 12h3M4.5 16.5h3M12 12l1.8 1.8 3.2-3.6\"/>", "none": "<path d=\"M5 19l1-4 9.5-9.5 3 3L9 18z\"/><path d=\"M13.5 7.5l3 3\"/>"}, "drill": {"start": "<path d=\"M12 21V3M12 5h6.5l2 2-2 2H12M12 12H5.5l-2 2 2 2H12\"/>", "drift": "<path d=\"M4 8c3-2 5 2 8 0s5-2 8 0M4 13c3-2 5 2 8 0s5-2 8 0M4 18c3-2 5 2 8 0\"/>", "big": "<path d=\"M3 19l6.5-11 4 6.5 2.5-4L21 19z\"/>", "jumpy": "<path d=\"M4 16l4-8 4 8 4-8 4 8\"/>", "switching": "<path d=\"M4 8h14l-3-3M20 16H6l3 3\"/>", "slump": "<rect x=\"3\" y=\"8\" width=\"16\" height=\"8\" rx=\"1.5\"/><path d=\"M21 11v2M6 11v2\"/>", "endless": "<path d=\"M9 6h11M9 12h11M9 18h11\"/><circle cx=\"5\" cy=\"6\" r=\".6\"/><circle cx=\"5\" cy=\"12\" r=\".6\"/><circle cx=\"5\" cy=\"18\" r=\".6\"/>", "mixed": "<circle cx=\"9\" cy=\"12\" r=\"5.5\"/><circle cx=\"15\" cy=\"12\" r=\"5.5\"/>", "deadlines": "<rect x=\"3.5\" y=\"5\" width=\"17\" height=\"15.5\" rx=\"2\"/><path d=\"M3.5 10h17M8 3v4M16 3v4M10 18v-5.5h4.5l-1 1.5 1 1.5H10\"/>", "overrun": "<circle cx=\"11\" cy=\"13\" r=\"7.5\"/><path d=\"M11 9v4l2.5 1.5M19 2.5v4M17 4.5h4\"/>", "noplan": "<path d=\"M6 3h8l4 4v14H6z\"/><path d=\"M14 3v4h4\"/>", "week": "<rect x=\"3.5\" y=\"5\" width=\"17\" height=\"15.5\" rx=\"2\"/><path d=\"M3.5 10h17M8 3v4M16 3v4\"/>", "notifs": "<path d=\"M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15z\"/><path d=\"M10 20.5a2 2 0 0 0 4 0\"/>", "tool": "<rect x=\"7\" y=\"3\" width=\"10\" height=\"18\" rx=\"2\"/><path d=\"M9.5 8h5M9.5 11h5M9.5 14h3\"/>", "scroll": "<rect x=\"7\" y=\"3\" width=\"10\" height=\"18\" rx=\"2\"/><path d=\"M12 7.5v7M10 12.5l2 2 2-2\"/>", "remember": "<path d=\"M5 4h14v10l-5 6H5z\"/><path d=\"M14 20v-6h5\"/>", "consistent": "<path d=\"M4 11a7 7 0 0 1 12-4.5L18 8M20 13a7 7 0 0 1-12 4.5L6 16M18 4v4h-4M6 20v-4h4\"/>", "selfcare": "<path d=\"M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z\"/>", "cables": "<path d=\"M9 3v5M15 3v5M7 8h10v3a5 5 0 0 1-10 0zM12 16v5\"/>", "smallstuff": "<path d=\"M3.5 8 12 4l8.5 4v8L12 20l-8.5-4zM3.5 8 12 12l8.5-4M12 12v8\"/>", "vibe": "<path d=\"M11 3c.6 4.2 1.8 5.4 6 6-4.2.6-5.4 1.8-6 6-.6-4.2-1.8-5.4-6-6 4.2-.6 5.4-1.8 6-6zM18.5 14.5c.3 1.6.9 2.2 2.5 2.5-1.6.3-2.2.9-2.5 2.5-.3-1.6-.9-2.2-2.5-2.5 1.6-.3 2.2-.9 2.5-2.5z\"/>", "tabs": "<rect x=\"3\" y=\"8\" width=\"13\" height=\"11\" rx=\"1.5\"/><path d=\"M8 8V6a1.5 1.5 0 0 1 1.5-1.5h10A1.5 1.5 0 0 1 21 6v8a1.5 1.5 0 0 1-1.5 1.5H16\"/>", "requests": "<circle cx=\"9\" cy=\"8\" r=\"3\"/><path d=\"M3.5 19a5.5 5.5 0 0 1 11 0\"/><circle cx=\"17\" cy=\"9\" r=\"2.3\"/><path d=\"M15.5 14.2A4.5 4.5 0 0 1 21 18.5\"/>", "unfinished": "<path d=\"M12 3.5A8.5 8.5 0 1 1 3.5 12\"/><path d=\"M3.5 12A8.5 8.5 0 0 1 12 3.5\" stroke-dasharray=\"1.5 2.2\"/>", "cramming": "<rect x=\"4\" y=\"14\" width=\"16\" height=\"5\" rx=\"1\"/><rect x=\"6\" y=\"9\" width=\"13\" height=\"5\" rx=\"1\"/><rect x=\"5\" y=\"4\" width=\"12\" height=\"5\" rx=\"1\"/>", "starting": "<path d=\"M5 19l1-4 9.5-9.5 3 3L9 18z\"/><path d=\"M13.5 7.5l3 3\"/>", "focus": "<path d=\"M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/>", "late": "<path d=\"M19 14.5A7.5 7.5 0 0 1 9.5 5a7.5 7.5 0 1 0 9.5 9.5z\"/>", "everywhere": "<path d=\"M4 11 12 4.5l8 6.5V20H4z\"/><path d=\"M10 20v-5h4v5\"/>", "headspace": "<path d=\"M7 18a4 4 0 0 1-.6-8 5.5 5.5 0 0 1 10.6 1A3.5 3.5 0 0 1 17 18z\"/>"}, "rank": {"procrastination": "<path d=\"M7 3h10M7 21h10M8 3c0 5 8 6 8 9s-8 4-8 9M16 3c0 5-8 6-8 9s8 4 8 9\"/>", "focus": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><circle cx=\"12\" cy=\"12\" r=\"4\"/><circle cx=\"12\" cy=\"12\" r=\".6\"/>", "overwhelm": "<rect x=\"7.5\" y=\"3\" width=\"12\" height=\"15\" rx=\"1.5\"/><path d=\"M5 6.5v13A1.5 1.5 0 0 0 6.5 21H16\"/>", "time": "<circle cx=\"12\" cy=\"12\" r=\"8.5\"/><path d=\"M12 7.5V12l3 2\"/>", "phone": "<rect x=\"7\" y=\"3\" width=\"10\" height=\"18\" rx=\"2\"/><path d=\"M11 18h2\"/>", "habits": "<rect x=\"3.5\" y=\"5\" width=\"17\" height=\"15.5\" rx=\"2\"/><path d=\"M3.5 10h17M8 3v4M16 3v4M7 14h2M11 14h2M15 14h2M7 17.5h2M15 17.5h2\"/>", "clutter": "<rect x=\"4\" y=\"12.5\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"13\" y=\"4.5\" width=\"7\" height=\"7\" rx=\"1\" transform=\"rotate(14 16.5 8)\"/><circle cx=\"16.5\" cy=\"17\" r=\"2.5\"/>", "multitasking": "<rect x=\"3\" y=\"8\" width=\"13\" height=\"11\" rx=\"1.5\"/><path d=\"M8 8V6a1.5 1.5 0 0 1 1.5-1.5h10A1.5 1.5 0 0 1 21 6v8a1.5 1.5 0 0 1-1.5 1.5H16\"/>", "study": "<path d=\"M12 6.5c-2-1.5-5-2-8-2V18c3 0 6 .5 8 2 2-1.5 5-2 8-2V4.5c-3 0-6 .5-8 2zM12 6.5V20\"/>", "switchoff": "<path d=\"M12 3v8\"/><path d=\"M7 6.5a7 7 0 1 0 10 0\"/>"}};
  // Captain, 14 Oct: the original metaphors (plate stack, hourglass, melting clock...) for problems, place and planning,
  // drawn lighter; the drill answers keep the light set in the same style.
  ["problems", "rank", "place", "planning"].forEach(function (k) { LIGHT_ICONS[k] = OPTION_ICONS; });
  var ICON_STEPS = { problems: 1, rank: 1, drill: 1, place: 1, planning: 1 };
  function optionIcon(id) {
    var d = ICON_STEPS[current] && (LIGHT_ICONS[current] || {})[id];
    return d ? '<svg class="opt-icon" viewBox="0 0 24 24" aria-hidden="true">' + d + "</svg>" : "";
  }

  function option(o, selected, extra) {
    return (
      '<button type="button" class="option' + (extra && extra.className ? " " + extra.className : "") + '" data-value="' + esc(o.id) + '" aria-pressed="' + (selected ? "true" : "false") + '"' + (extra && extra.disabled ? " disabled" : "") + ">" +
      (extra && extra.before ? extra.before : optionIcon(o.id)) +
      '<span class="option__text"><span class="option__label">' + esc(o.label) + "</span>" +
      (o.body || o.sub ? '<span class="option__body">' + esc(o.body || o.sub) + "</span>" : "") +
      (extra && extra.after ? extra.after : "") +
      "</span>" +
      '<span class="option__check" aria-hidden="true"><svg viewBox="0 0 16 16"><path d="m3.5 8.5 3 3 6-7" /></svg></span>' +
      "</button>"
    );
  }

  function singleChoice(stepId, title, hint, options, key, layout) {
    return (
      '<section class="step">' +
      questionHeader(stepId, title, hint) +
      '<div class="options ' + (layout || "") + '" data-choose="' + key + '">' +
      options.map(function (o) { return option(o, String(answers[key]) === String(o.id), o.extra); }).join("") +
      "</div></section>"
    );
  }

  // ---------- screens ----------

  var PROMISE_ICONS = {
    bars: '<path d="M5 19V13M10 19V8M15 19V11M20 19V5"/>',
    bulb: '<path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/>',
    check: '<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/>',
    tools: '<rect x="7" y="4" width="10" height="11" rx="1"/><path d="M9.5 8h5M9.5 11h3M4 17.5h16v2.5H4z"/>',
  };

  var RENDER = {
    intro: function () {
      var i = quiz.intro;
      return (
        '<section class="step intro">' +
        (quiz.results && quiz.results.images ? '<img class="hero-img" src="' + quiz.results.images.hero + '" alt="Hands typing at a bright desk, the Flow Timer counting down beside the keyboard" width="460" height="345" />' : "") +
        '<p class="eyebrow">' + esc(i.eyebrow) + "</p>" +
        '<h1 class="display" tabindex="-1">' + esc(i.title) + "</h1>" +
        '<p class="lede">' + esc(i.body) + "</p>" +
        '<p class="promise__label">What you\'ll get</p><ul class="promise" aria-label="What you\'ll get">' +
        [["bars", "Your focus type"], ["bulb", "Why it happens"], ["check", "Tips for today"], ["tools", "Your matched toolkit"]].map(function (x) {
          return '<li><svg viewBox="0 0 24 24" aria-hidden="true">' + PROMISE_ICONS[x[0]] + "</svg>" + x[1] + "</li>";
        }).join("") + "</ul>" +
        '<div class="intro__cta"><button type="button" class="button" data-action="next">' + esc(i.cta) + "</button>" +
        '<p class="meta">' + esc(i.meta) + "</p></div>" +
        "</section>"
      );
    },

    style: function () {
      var options = quiz.styles.map(function (s) {
        return {
          id: s.id, label: s.label, body: s.body,
          extra: {
            className: "option--swatch",
            before: '<span class="swatches" aria-hidden="true">' + s.swatches.map(function (c) { return '<span style="background:' + c + '"></span>'; }).join("") + "</span>",
          },
        };
      });
      return singleChoice("style", "Which vibe feels most like you?", "We'll match colors and finishes to your style.", options, "style", "options--three").replace(/<\/section>$/,
        '<div class="step__footer step__footer--end"><button type="button" class="button" data-action="next" data-vibe-next' + (answers.style ? "" : " disabled") + ">Continue</button></div></section>");
    },

    place: function () {
      return singleChoice("place", "Where do you do most of your work?", null, quiz.places, "place");
    },

    planning: function () {
      return singleChoice("planning", quiz.planning.question, null, quiz.planning.options, "planning", "options--two");
    },

    problems: function () {
      var max = quiz.maxProblems;
      var full = answers.problems.length >= max;
      var shown = quiz.problemsShown || quiz.problems.length;
      var rest = quiz.problems.slice(shown);
      var open = showAllProblems || rest.some(function (p) { return answers.problems.indexOf(p.id) !== -1; });
      return (
        '<section class="step">' +
        questionHeader("problems", "What's getting in the way right now?", "Pick up to " + max + ".") +
        '<div class="options options--two options--problems" data-toggle="problems">' +
        (open ? quiz.problems : quiz.problems.slice(0, shown)).map(function (p) {
          var on = answers.problems.indexOf(p.id) !== -1;
          return option(p, on, { disabled: full && !on });
        }).join("") +
        "</div>" +
        (!open && rest.length ? '<p class="more-problems"><button type="button" class="link" data-action="more-problems">Something else</button></p>' : "") +
        '<div class="step__footer"><span class="counter">' + answers.problems.length + " of " + max + " selected</span>" +
        '<button type="button" class="button" data-action="next"' + (answers.problems.length ? "" : " disabled") + ">Continue</button></div>" +
        "</section>"
      );
    },

    rank: function () {
      var options = answers.problems.map(function (id) { return byId(quiz.problems, id); });
      return (
        '<section class="step">' +
        questionHeader("rank", "Which one costs you the most?", "We'll build your setup around this one first.") +
        '<div class="options" data-choose="rank">' +
        options.map(function (p, i) { return option(p, i === 0 && answers.ranked, null); }).join("") +
        "</div></section>"
      );
    },

    education: function () {
      var p = primary();
      var e = p.education;
      var v = quiz.results && quiz.results.edu[p.id];
      return (
        '<section class="step education">' +
        '<div class="step__nav"><button type="button" class="back" data-action="back">' +
        '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 5 8l5 5" /></svg>Back</button></div>' +
        '<p class="eyebrow">About ' + esc(p.name) + "</p>" +
        '<h1 class="display display--sm" tabindex="-1">' + esc(e.title) + "</h1>" +
        (v ? eduVisual(e, v) :
        '<figure class="stat"><span class="stat__value">' + esc(e.stat.value) + "</span>" +
        '<figcaption><span class="stat__text">' + esc(e.stat.text) + '</span>' + sourceHtml(e.stat) + "</figcaption></figure>" +
        '<p class="lede">' + esc(e.body) + "</p>" +
        '<div class="approach"><span class="approach__label">What works</span><p>' + esc(e.approach) + "</p></div>") +
        (e.note ? '<p class="note">' + esc(e.note) + "</p>" : "") +
        '<div class="step__footer step__footer--end"><button type="button" class="button" data-action="next">Let\'s narrow it down</button></div>' +
        "</section>"
      );
    },

    drill: function () {
      var d = primary().drill;
      return singleChoice("drill", d.question, null, d.options, "drill");
    },

    holdback: function () {
      var h = quiz.holdback;
      var options = h.options.map(function (o) {
        // Mahjong dot tiles (tong suit): one, two and three dots.
        return { id: o.value, label: o.label, extra: { className: "option--scale", before: mahjongTile(o.value) } };
      });
      return singleChoice("holdback", h.question, h.hint.replace("{problem}", primary().label), options, "holdback");
    },

    severity: function () {
      var s = quiz.severity;
      // Birthday nudge: each option shows roughly what that setup costs at sale prices and the gift it reaches.
      var est = function (v) {
        try {
          var res = engine.recommend(Object.assign({}, answers, { severity: v }), quiz, catalog);
          var lines = res.items.filter(function (e) { return !res.kit || res.kit.covers.indexOf(e.id) === -1; }).map(engine.lineFor);
          if (res.kit) lines.push({ handle: res.kit.product.handle, variant: res.kit.variant });
          return engine.priceCart(lines, catalog.discounts).total;
        } catch (e) { return 0; }
      };
      var tiers = OFFER.gifts ? OFFER.gifts.tiers : [];
      var options = s.options.map(function (o, i) {
        return { id: o.value, label: o.label, body: o.body, extra: { className: "option--scale", before: cardFan({ 1: 1, 3: 3, 4: 5 }[o.value] || 1),
          after: "" } };
      });
      // Not sure: we pick for them. Meeting decision (14 Oct): it gives The full kit (severity 4).
      options.push({ id: "auto", label: "Not sure yet? Just recommend me something", extra: { className: "option--ghost" } });
      var sale = OFFER.gifts ? '<div class="q8-sale"><span class="ticket"><span class="ticket__tag">' + esc(OFFER.tag || "Birthday Sale") + '</span><span class="ticket__body">Up to 30% off + free gifts</span></span></div>' : "";
      return singleChoice("severity", s.question, "", options, "severity").replace('<div class="options', sale + '<div class="options');
    },

    email: function () {
      var E = quiz.results.offer.email, M = emailMode();
      return (
        '<section class="step email">' +
        '<div class="step__nav"><button type="button" class="back" data-action="back">' +
        '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 5 8l5 5" /></svg>Back</button></div>' +
        '<p class="eyebrow">' + esc(E.eyebrow) + "</p>" +
        '<h1 class="display display--sm" tabindex="-1">' + esc(M.title) + ' <span class="optional-tag">(optional)</span></h1>' +
        '<p class="lede">' + esc(M.body) + "</p>" +
        '<form class="email__form" novalidate><label class="sr-only" for="quiz-email">' + esc(E.placeholder) + "</label>" +
        '<input id="quiz-email" type="email" autocomplete="email" placeholder="' + esc(E.placeholder) + '" />' +
        '<button type="submit" class="button">' + esc(E.cta) + "</button></form>" +
        (E.consent ? '<p class="email__consent">' + esc(E.consent) + "</p>" : "") +
        '<p class="email__skip"><button type="button" class="link" data-action="next">' + esc(E.skip) + "</button></p>" +
        "</section>"
      );
    },

    analyzing: function () {
      var SHORT_P = { procrastination: "starting", focus: "focus", overwhelm: "overwhelm", time: "time", phone: "your phone", habits: "routines", clutter: "your desk", multitasking: "juggling", study: "study", switchoff: "switching off" };
      var problems = answers.problems.map(function (id) { return byId(quiz.problems, id); }).filter(Boolean);
      var plan = { planner: "a planner you carry", desk: "cards on the desk", own: "your Modular Planner", none: "an easy first system" }[answers.planning] || "your style";
      var style = byId(quiz.styles, answers.style);
      var lines = [
        "Reading what gets in your way",
        "Matching methods that fix it",
        "Picking the tools that help",
      ];
      return (
        '<section class="step analyzing">' +
        '<p class="eyebrow">Your results</p>' +
        '<h1 class="display display--sm" tabindex="-1">Working out your results</h1>' +
        '<div class="analyzing__bar"><i></i></div>' +
        '<ol class="analyzing__list">' + lines.map(function (t, i) {
          return '<li style="--d:' + i + '"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M7.5 12.5l3 3 6-7"/></svg><span>' + esc(t) + "</span></li>";
        }).join("") + "</ol>" +

        "</section>"
      );
    },

    results: renderResults,
  };

  // ---------- results ----------
  // The results page is a checklist: everything recommended starts ticked, and prices (including Shopify's
  // automatic discounts, which depend on what else is in the cart) update as items are ticked or unticked.

  var result = null;
  var cart = null;

  function renderResults() {
    result = engine.recommend(answers, quiz, catalog);
    cart = { selected: {}, variants: {}, qty: {}, useKit: !!result.kit, extras: [] };
    allRows().forEach(function (row) { cart.selected[row.id] = !row.optional; });
    // A gift tier that already covers a piece (the pencil at 120) takes it off the bill instead of selling it.
    giftCovered = {};
    (OFFER.gifts ? OFFER.gifts.tiers : []).forEach(function (t) {
      if (!t.covers) return;
      var rest = allRows().filter(function (row) { return cart.selected[row.id] && t.covers.indexOf(row.product.handle) === -1; });
      if (true) { // 99: the pencil is a gift during the sale, so it's never sold as a line item
        allRows().forEach(function (row) { if (t.covers.indexOf(row.product.handle) !== -1) { cart.selected[row.id] = false; giftCovered[row.id] = true; } });
      }
    });

    var r = result;
    var p = r.primary;
    var style = byId(quiz.styles, answers.style);
    var place = byId(quiz.places, answers.place);
    var copy = quiz.results && quiz.results.paths[p.id + "/" + answers.drill];
    var sum = quiz.results && quiz.results.summaries[p.id + "/" + answers.drill];
    return (
      '<section class="results">' +
      '<nav class="res-nav" aria-label="Results sections">' +
      [["res-0", "Your results", "Results"], ["res-fix", "The fix", "Fix"], ["res-how", "How it works", "How"], ["res-stories", "Stories", "Stories"], ["res-1", "Why this happens", "Why"]].filter(function (t) { return t[0] !== "res-fix" || sum; }).map(function (t, n) { return '<button type="button" data-jump="' + t[0] + '"' + (n ? "" : ' aria-current="true"') + '><span class="nav-l">' + t[1] + '</span><span class="nav-s">' + t[2] + "</span></button>"; }).join("") +
      "</nav>" +
      '<header class="results__head" id="res-0">' +
      '<div class="res-top"><div class="res-top__copy">' +
      (sum
        ? reportCard(sum, r) + "</div>" + '<div class="res-top__viz">' + profileHtml(r) + fixHtml(sum) + "</div></div>"
        : '<h1 class="display display--sm" tabindex="-1">Your setup to ' + esc(p.goal) + "</h1>" + insightsHtml(r)) +

      "</header>" +
      '<div id="res-2" class="res-setup">' +
      '<div id="cart">' + renderCart() + "</div>" +
      '<p class="extras" data-extras></p>' +
      '<div class="offer-strip" data-offer></div>' +
      '<div class="setup-cta" data-mini></div>' +
      "</div>" + (r.makeItStick && r.planner ? makeItStick(r.makeItStick) : "") + howHtml() +
      proofHtml(r) +
      '<section class="why" id="res-1"><h2 class="why__title">' + esc(quiz.results.nav[1]) + "</h2>" +
      '<div class="why__body">' +
      '<p class="lede">' + esc(r.drill.insight || p.education.approach) + "</p>" +

      (copy ? '<p class="tips__label">' + esc(quiz.results.tipsLabel) + "</p><ol class=\"tips__list\">" +
        copy.tips.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("") + "</ol>" : "") +

      "</div></section>" +

      '<div class="end-cta" data-endcta></div>' +
      '<p class="retake"><button type="button" class="link" data-action="back-edit">Change my answers</button><span aria-hidden="true"> &middot; </span><button type="button" class="link" data-action="retake">Retake the quiz</button></p>' +
      (debug ? debugTable(r) : "") +
      "</section>" +
      '<div class="checkout" aria-live="polite"></div>'
    );
  }

  function plannerIds() {
    var ids = {};
    if (result.planner) {
      if (result.planner.binder) ids[result.planner.binder.id] = true;
      result.planner.inserts.forEach(function (e) { ids[e.id] = true; });
    }
    return ids;
  }

  function entryRow(entry, extra) {
    var problem = entry.reason.problem ? byId(quiz.problems, entry.reason.problem) : null;
    return Object.assign(
      {
        id: entry.id,
        product: entry.product,
        variant: chosenVariant(entry),
        picker: entry.item.role !== "insert" ? quiz.variantPickers[entry.product.handle] || null : null,
        why: entry.reason.text,
        whyLabel: problem ? "Why it helps with " + problem.name : "Why it helps",
        evidence: entry.evidence,
        badge: entry.isHero ? "Start here" : null,
      },
      extra || {}
    );
  }

  function chosenVariant(entry) {
    var id = cart.variants[entry.id];
    return (id && entry.product.variants.filter(function (v) { return v.id === id; })[0]) || entry.variant;
  }

  function swatchCss(title) {
    if (quiz.swatches[title]) return quiz.swatches[title];
    var p = title.split(" / ").map(function (t) { return quiz.swatches[t]; });
    return p.length === 2 && p[0] && p[1] ? "linear-gradient(135deg, " + p[0] + " 50%, " + p[1] + " 50%)" : "transparent";
  }

  function splitPicker(row) {
    var all = row.product.variants, vs = all.filter(function (v) { return v.available; });
    var cur = row.variant.title.split(" / ");
    var part = function (i, label) {
      var vals = [];
      all.forEach(function (v) { var x = v.title.split(" / ")[i]; if (vals.indexOf(x) === -1) vals.push(x); });
      return '<div class="picker__row"><span class="picker__mini">' + label + ": <strong>" + esc(cur[i]) + "</strong></span>" +
        '<div class="picker__options" role="group" aria-label="' + label + '">' + vals.map(function (val) {
          var want = cur.slice(); want[i] = val;
          var v = vs.filter(function (x) { return x.title === want.join(" / "); })[0] || vs.filter(function (x) { return x.title.split(" / ")[i] === val; })[0];
          if (!v) return '<button type="button" class="picker__swatch" aria-disabled="true" data-soldout="' + esc(val) + '" aria-label="' + esc(val) + ' · Sold out" title="' + esc(val) + ' · Sold out" style="--swatch:' + esc(quiz.swatches[val] || "transparent") + '"></button>';
          return '<button type="button" class="picker__swatch" data-variant="' + v.id + '" aria-pressed="' + (val === cur[i]) + '" aria-label="' + esc(val) + '" title="' + esc(val) + '" style="--swatch:' + esc(quiz.swatches[val] || "transparent") + '"></button>';
        }).join("") + "</div></div>";
    };
    return '<div class="picker picker--split" tabindex="0">' + part(0, "Timer") + part(1, "Tray") + "</div>";
  }

  function pickerHtml(row) {
    if (row.product.handle === "flow-bundle" && /\//.test(row.variant.title)) return splitPicker(row);
    var picker = row.picker;
    var name = function (v) { return picker.strip ? v.title.replace(picker.strip, "") : v.title; };
    return (
      '<div class="picker" tabindex="0">' +
      '<span class="picker__label">' + esc(picker.label) + ": <strong>" + esc(name(row.variant)) + "</strong></span>" +
      '<div class="picker__options" role="group" aria-label="' + esc(picker.label) + '">' +
      row.product.variants.map(function (v) {
        var on = v.id === row.variant.id;
        var label = name(v) + (v.available ? "" : " · Sold out");
        return (
          '<button type="button" class="' + (picker.text ? "picker__text" : "picker__swatch") + '" data-variant="' + v.id + '"' +
          ' aria-pressed="' + on + '" aria-label="' + esc(label) + '" title="' + esc(label) + '"' +
          (v.available ? "" : ' aria-disabled="true" data-soldout="' + esc(name(v)) + '"') +
          (picker.text ? ">" + esc(name(v)) : ' style="--swatch:' + esc(swatchCss(v.title)) + '">') +
          "</button>"
        );
      }).join("") +
      "</div></div>"
    );
  }

  // An unticked extra insert, offered alongside the planner so one tap can unlock the next REFILL discount tier.
  function suggestedInsert() {
    var planner = result.planner;
    if (!planner) return null;
    var chosen = planner.inserts.map(function (e) { return e.id; });
    var keys = [];
    result.problems.forEach(function (p) {
      var recipe = quiz.planner.recipes[p.id];
      if (recipe) (recipe.optional || []).concat(recipe.inserts).forEach(function (entry) { keys.push(entry[0]); });
    });
    keys = keys.concat(Object.keys(quiz.planner.inserts));
    var product = catalog.products.filter(function (x) { return x.handle === quiz.planner.insertProduct; })[0];
    for (var i = 0; i < keys.length; i++) {
      var id = "insert:" + keys[i];
      if (chosen.indexOf(id) !== -1) continue;
      var def = quiz.planner.inserts[keys[i]];
      var variant = product.variants.filter(function (v) { return v.available && v.title.indexOf(def.variant) === 0; })[0];
      if (!variant) continue;
      var reasons = quiz.reasons[id];
      var problem = result.problems.filter(function (p) { return reasons.problems[p.id]; })[0];
      return {
        id: id,
        product: product,
        variant: variant,
        why: problem ? reasons.problems[problem.id] : reasons.default,
        whyLabel: problem ? "Why it helps with " + problem.name : "Why it helps",
        optional: true,
      };
    }
    return null;
  }

  // Rows grouped for display. With the kit switched on, the pieces it covers collapse into one kit row.
  function groups() {
    var r = result;
    var inPlanner = plannerIds();
    var setup = r.items.filter(function (e) { return !inPlanner[e.id]; }).map(function (e) { return entryRow(e); });

    if (r.kit && cart.useKit) {
      var first = setup.findIndex(function (row) { return r.kit.covers.indexOf(row.id) !== -1; });
      var kitRow = {
        id: "kit",
        product: r.kit.product,
        variant: r.kit.variant,
        why: "Your " + joinWords(r.kit.coverTitles) + (r.kit.extras.length ? ", plus the " + joinWords(r.kit.extras) : "") + ", in one box for less.",
        whyLabel: "What's inside",
        badge: null,
        picker: quiz.variantPickers[r.kit.product.handle] || null,
      };
      setup = setup.filter(function (row) { return r.kit.covers.indexOf(row.id) === -1; });
      setup.splice(Math.max(0, first), 0, kitRow);
    }

    var list = [{ id: "setup", title: "Your setup", rows: setup }];
    if (r.planner) {
      var plannerRows = [];
      if (r.planner.binder) plannerRows.push(entryRow(r.planner.binder));
      r.planner.inserts.forEach(function (e) { plannerRows.push(entryRow(e, { insert: true })); });
      var extra = suggestedInsert();
      if (extra) plannerRows.push(Object.assign(extra, { insert: true }));
      var plannerGroup = {
        id: "planner",
        eyebrow: "Your Modular Planner",
        title: r.planner.title,
        note: r.planner.ownsBinder
          ? "These inserts clip straight into the Modular Planner you already have."
          : r.planner.problem ? "Pages chosen for " + r.planner.problem.name + ", in the order you'll use them." : "",
        rows: plannerRows,
        routine: r.planner.routine,
      };
      // One list: the planner pieces join the setup rows (first when the planner leads), under "Your setup".
      list[0].rows = inPlanner[r.items[0].id] ? plannerRows.concat(list[0].rows) : list[0].rows.concat(plannerRows);
      list[0].routine = plannerGroup.routine;
    }
    return list.filter(function (g) { return g.rows.length; });
  }

  function allRows() {
    return groups().reduce(function (rows, g) { return rows.concat(g.rows); }, []);
  }

  function renderCart() {
    var kit = result.kit;
    // The saving is against buying every piece in the kit separately, so name any piece the kit adds.
    var plus = kit && kit.extras.length ? " (with the " + joinWords(kit.extras) + " included)" : "";
    // One small line under the heading (captain, 14 Oct), with a tiny Split / Bundle link.
    var banner = false
      ? '<p class="kit-line">' +
        (cart.useKit
          ? "Bundled as the " + esc(kit.product.title) + ", saves " + money.format(kit.saving) +
            ' <button type="button" class="link" data-action="split-kit">Split</button>'
          : "Bundle as the " + esc(kit.product.title) + esc(plus) + " to save " + money.format(kit.saving) +
            ' <button type="button" class="link" data-action="use-kit">Bundle</button>') +
        "</p>"
      : "";

    return (
      groups().map(function (g) {
        return (
          '<section class="cart-group" data-group="' + g.id + '">' +
          '<header class="cart-group__head">' +
          (g.eyebrow ? '<p class="eyebrow">' + esc(g.eyebrow) + "</p>" : "") +
          '<div class="cart-group__title"><h2>' + esc(g.title) + "</h2>" +
          (g.id === "setup" ? '<button type="button" class="pill-btn" data-action="customize">Customize <span aria-hidden="true">+</span></button>' : "") + "</div>" +
          (g.note ? "<p>" + esc(g.note) + "</p>" : "") +
          "</header>" +
          (g.id === "setup" ? banner : "") +
          '<ul class="rows">' + g.rows.map(renderRow).join("") + "</ul>" +
          (g.id === "planner" ? '<p class="nudge" data-nudge="inserts" hidden></p>' : "") +
          (g.routine && g.routine.length
            ? '<details class="routine"><summary>How to use your planner</summary><ol>' +
              g.routine.map(function (step) { return '<li><span class="routine__when">' + esc(step[0]) + "</span><span>" + esc(step[1]) + "</span></li>"; }).join("") +
              "</ol></details>"
            : "") +
          "</section>"
        );
      }).join("")
    );
  }

  function renderRow(row) {
    var v = row.variant;
    var p = row.product;
    var variantName = v.title === "Default Title" ? "" : v.title;
    var title = p.title;
    if (row.insert) {
      // "Daily (60 Pages)" -> "Daily insert", "60 pages"
      var parts = /^(.*?)\s*\((.+)\)$/.exec(v.title) || [null, v.title, ""];
      title = parts[1] + " insert";
      variantName = parts[2].toLowerCase();
    }
    var href = p.url + "?variant=" + v.id;
    var inputId = "pick-" + row.id.replace(/[^a-z0-9-]/gi, "-");
    return (
      '<li class="row' + (row.optional ? " row--optional" : "") + '" data-row="' + esc(row.id) + '">' +
      '<input type="checkbox" class="row__check" id="' + inputId + '" data-row-check="' + esc(row.id) + '"' + (cart.selected[row.id] ? " checked" : "") + " />" +
      '<label class="row__box" for="' + inputId + '"><span class="sr-only">Add ' + esc(title) + " to cart</span>" +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m3.5 8.5 3 3 6-7" /></svg></label>' +
      '<span class="row__thumb"><img class="row__img" src="' + esc(img(v.image || p.image, 200)) + '" alt="See details: ' + esc(title) + '" width="80" height="80" data-view="' + esc(row.id) + '" />' +
      '<button type="button" class="row__zoom" data-view="' + esc(row.id) + '" aria-label="See details: ' + esc(title) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="7" cy="7" r="4.5"/><path d="m10.5 10.5 3 3"/></svg></button></span>' +
      '<div class="row__info">' +
      '<div class="row__head"><h3 data-view="' + esc(row.id) + '">' + esc(title) + "</h3>" + (row.insert || String(row.id).indexOf("insert:") === 0 ? "" : starsHtml(row.product.handle)) +
      (row.badge ? '<span class="tag tag--accent">' + esc(row.badge) + "</span>" : "") +
      (row.optional ? '<span class="tag">Optional</span>' : "") + "</div>" +
      (row.picker ? pickerHtml(row) : variantName ? '<p class="row__variant">' + esc(variantName) + "</p>" : "") +
      '<div class="row__price row__price--inline"></div>' +
      (row.id === "kit" && result.kit && cart.useKit ? '<span class="tag tag--save">Bundle saves ' + money.format(result.kit.saving) + "</span>" : "") +
      '<p class="row__why"><span class="row__why-label">' + esc(/^Why it helps/.test(row.whyLabel) ? "Why it helps" : row.whyLabel) + "</span>" + esc(firstSentence(row.why)) + "</p>" +
      '<p class="row__more"><button type="button" class="row__details" data-view="' + esc(row.id) + '">See details</button></p>' +
      (row.evidence ? '<p class="row__proof"><strong>' + esc(row.evidence.value) + "</strong> " + esc(row.evidence.text) + ' <span class="source">' + esc(row.evidence.source) + "</span></p>" : "") +
      '<div class="row__actions">' +
      (row.insert && M.guides[String(v.id)] ? '<button type="button" class="row__guide" data-guide="' + esc(row.id) + '">How to use</button>' : "") +
      "</div>" +
      "</div>" +
      '<div class="row__price row__price--side"></div>' +
      '<div class="row__qty">' + rowStep(row) + "</div>" +
      "</li>"
    );
  }

  function priceHtml(line) {
    var each = line.quantity > 1 ? '<span class="each">' + money.format(line.final) + " each</span>" : "";
    if (!line.discount) return '<strong class="now">' + money.format(line.total) + "</strong>" + each;
    return (
      '<s class="was">' + money.format(line.listTotal) + "</s>" +
      '<strong class="now now--sale">' + money.format(line.total) + "</strong>" +
      (line.discount.percent > 30 ? "" : '<span class="off">' + line.discount.percent + "% off</span>") + each
    );
  }

  var MAX_QTY = 10;

  function qtyOf(row) {
    return cart.qty[row.id] || 1;
  }

  // The shared stepper (gift-widget V9.6). data-qs-row ties it back to this setup row.
  function rowStep(row) {
    if (!window.BDS || !window.BDS.qtyStep) return qtyHtml(row);
    return window.BDS.qtyStep([{ handle: row.product.handle, id: +(cart.variants[row.id] || row.variant.id) }], { name: row.product.title, qty: qtyOf(row), cls: "bds-qs--quiz" })
      .replace('class="bds-qs ', 'data-qs-row="' + esc(row.id) + '" class="bds-qs ');
  }
  function qtyHtml(row) {
    var q = qtyOf(row);
    return (
      '<div class="qty" role="group" aria-label="Quantity of ' + esc(row.product.title) + '">' +
      '<button type="button" data-qty="-1" aria-label="Remove one"' + (q <= 1 ? " disabled" : "") + ">−</button>" +
      '<span class="qty__value" aria-live="polite">' + q + "</span>" +
      '<button type="button" data-qty="1" aria-label="Add one"' + (q >= MAX_QTY ? " disabled" : "") + ">+</button>" +
      "</div>"
    );
  }

  function toLines(rows) {
    return rows.map(function (row) { return { handle: row.product.handle, variant: row.variant, quantity: qtyOf(row) }; });
  }

  // Recalculate prices for the current selection and update the page in place.
  window.addEventListener("quiz-qs", function (ev) {
    var x = ev.detail;
    if (x.row) {
      var q = qtyOf({ id: x.row });
      if (x.d < 0 && q <= 1) cart.selected[x.row] = false;
      else { cart.qty[x.row] = Math.min(MAX_QTY, Math.max(1, q + x.d)); if (x.d > 0) cart.selected[x.row] = true; }
    } else if (x.extra) {
      cart.extras = (cart.extras || []).map(function (e) { if ((e.group || e.handle + ":" + e.variant.id) === x.extra) e.quantity = Math.min(MAX_QTY, e.quantity + x.d); return e; }).filter(function (e) { return e.quantity > 0; });
    }
    document.getElementById("cart").innerHTML = renderCart();
    updateCart();
  });
  // Every quiz Add button routes to the store cart. The builder's own Checkout stays inside the builder.
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a.mini__add, .checkout a.button, a.end-cta__btn");
    if (!a) return;
    e.preventDefault();
    if (addingToCart) return;   // one add at a time: a second tap while it runs would add the setup twice
    var sel = allRows().filter(function (r) { return cart.selected[r.id]; });
    var label = a.innerHTML;
    addingToCart = true;
    a.classList.remove("is-error");
    a.classList.add("is-busy");
    a.setAttribute("aria-busy", "true");
    var done = function () { addingToCart = false; a.classList.remove("is-busy"); a.removeAttribute("aria-busy"); };
    addToStoreCart(toLines(sel).concat(extraLines())).then(done, function (err) {
      done();
      if (window.console) console.warn("[quiz] add to cart failed", err);
      // Say it on the button the shopper pressed, keep the setup as it is, and put the label back after a moment.
      a.classList.add("is-error");
      a.innerHTML = '<span role="alert">Couldn&#39;t add to cart, try again</span>';
      clearTimeout(a.__errT);
      a.__errT = setTimeout(function () { if (document.contains(a)) { a.classList.remove("is-error"); a.innerHTML = label; } }, 4000);
    });
  });
  var addingToCart = false;
  function updateCart() {
    var rows = allRows();
    var selected = rows.filter(function (row) { return cart.selected[row.id]; });
    var priced = engine.priceCart(toLines(selected).concat(extraLines()), catalog.discounts);
    var extrasEl = app.querySelector("[data-extras]");
    var bx = (cart.extras || []).filter(function (e) { return !e.addon; });
    if (extrasEl) extrasEl.innerHTML = bx.length ? "Also in your toolkit from the builder: " + bx.map(function (e) { return esc(e.product.title) + (e.quantity > 1 ? " x" + e.quantity : ""); }).join(", ") : "";

    rows.forEach(function (row) {
      var el = app.querySelector('[data-row="' + cssEscape(row.id) + '"]');
      if (!el) return;
      var on = !!cart.selected[row.id];
      el.classList.toggle("is-off", !on);
      // Unticked rows show what they would cost if added, discounts included.
      var line = on
        ? priced.lines[selected.indexOf(row)]
        : engine.priceCart(toLines(selected.concat([row])), catalog.discounts).lines[selected.length];
      // Two price slots: beside the row on wide screens, under the title on phones.
      el.querySelectorAll(".row__price").forEach(function (slot) { slot.innerHTML = priceHtml(line); });
    });

    var nudgeEl = app.querySelector('[data-nudge="inserts"]');
    if (nudgeEl) {
      var nudge = priced.nudges.filter(function (n) { return n.label === "inserts"; })[0];
      var applied = priced.lines.filter(function (l) { return l.line.handle === quiz.planner.insertProduct && l.discount; })[0];
      nudgeEl.hidden = !nudge && !applied;
      nudgeEl.innerHTML = nudge
        ? "Add " + nudge.needed + " more insert" + (nudge.needed > 1 ? "s" : "") + " to get <strong>" + nudge.percent + "% off</strong> all your inserts."
        : applied ? "<strong>" + applied.discount.percent + "% off</strong> all your inserts is applied." : "";
    }

    var offerEl = app.querySelector("[data-offer]");
    if (offerEl && quiz.results) offerEl.innerHTML = offerStrip(priced);
    Object.keys(giftCovered).forEach(function (id) {
      var el = app.querySelector('[data-row="' + cssEscape(id) + '"]');
      if (el) el.style.display = cart.selected[id] ? "" : "none";
    });
    var miniEl = app.querySelector("[data-mini]");
    if (miniEl && quiz.results) miniEl.innerHTML = miniSetup(selected, priced);
    var endEl = document.querySelector("[data-endcta]"), endAdd = miniEl && miniEl.querySelector(".mini__add");
    if (endEl) {
      var tp = TYPES[primary().id];
      endEl.innerHTML = endAdd ? '<p class="end-cta__t">Your toolkit' + (tp ? " for " + esc(tp[0].replace(/^The /, "the ")) : "") + "</p>" +
        '<div class="end-cta__thumbs">' + selected.map(function (row) { return '<img src="' + esc(img((row.variant && row.variant.image) || row.product.image, 120)) + '" alt="" width="44" height="44" />'; }).join("") + "</div>" +
        (priced.savings > 0 ? '<p class="end-cta__save">You save ' + money.format(priced.savings) + "</p>" : "") +
        endAdd.outerHTML.replace("mini__add", "mini__add end-cta__btn") + (OFFER.gifts ? '<div class="end-cta__gift">' + giftText(priced.total) + "</div>" : "") +
        '<p class="end-cta__trust">100-day returns &middot; &#9733; 4.7 from 4,346 reviews</p>' : "";
    }
    var checkout = document.querySelector(".checkout");
    var count = selected.reduce(function (sum, row) { return sum + qtyOf(row); }, 0) + extraLines().reduce(function (s, l) { return s + l.quantity; }, 0);
    var url = count ? engine.cartUrl(catalog.store, toLines(selected).concat(extraLines())) + (emailUnlocked ? "?discount=" + encodeURIComponent(quiz.results.offer.email.code) : "") : null;
    checkout.innerHTML =
      '<button type="button" class="checkout__thumbs" data-action="open-sheet" aria-label="Edit your setup">' +
      selected.map(function (row) { return '<img src="' + esc(img((row.variant && row.variant.image) || row.product.image, 120)) + '" alt="" width="44" height="44" />'; }).join("") +
      "</button>" +
      (selected.length ? '<button type="button" class="checkout__editlink" data-action="customize">Edit setup</button>' : "") +
      '<div class="checkout__gift">' + giftText(priced.total) + "</div>" +
      '<div class="checkout__summary"><span>' +
      (priced.savings > 0 ? ' <em class="saving">You save ' + money.format(priced.savings) + "</em>" : "") + "</span>" +
      "<strong>" + (priced.savings > 0 ? '<s class="was">' + money.format(priced.subtotal) + "</s> " : "") + money.format(priced.total) + "</strong></div>" +
      (url
        ? '<a class="button" href="' + esc(url) + '">Add ' + count + " to cart</a>"
        : '<span class="button" aria-disabled="true">Add to cart</span>');
  }

  // A store line ({ product, variant }) for any handle + variant id, priced like a setup row: the quiz's own Liquid catalog
  // first, else window.BDS_PRODUCTS (the builder's catalog, every product) through the shared reader BDS.priceOf, so the market
  // price and compare-at come out the same whatever shape the catalog has. priceCart then applies the discount (the product's
  // own %, or the insert tier). null when the variant is unknown.
  function storeLine(handle, id) {
    var p = catalog.products.filter(function (x) { return x.handle === handle; })[0];
    var v = p && p.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (v) return { product: p, variant: v };
    var B = window.BDS, bp = (window.BDS_PRODUCTS || []).filter(function (x) { return x.handle === handle; })[0];
    var bv = bp && bp.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    var po = bv && B && B.priceOf ? B.priceOf(handle, bv.id) : null;
    if (!bv || !po || String(po.variantId) !== String(bv.id)) return null;
    return { product: { handle: handle, title: bp.title, image: bp.image, url: catalog.store + "/products/" + handle },
      variant: { id: +bv.id, title: bv.title, price: po.full, compareAt: po.compareAt, available: bv.available !== false, image: bv.image || bp.image } };
  }

  // ---------- Customize: the shared Bundle Builder slide-out ----------
  // Extra lines (add-ons, anything added in Customize) ride along with the ticked rows.
  function extraLines() {
    return (cart.extras || []).map(function (e) { return { handle: e.handle, variant: e.variant, quantity: e.quantity }; });
  }
  // Customize opens the shared builder slide-out (BDSBuilder.slideout, Bear). The theme has ONE cart: the prefill goes into the
  // store cart (never doubled) and the builder checks out from its own panel. onChange / close sync the lines back here.
  function builderLines() {
    var b = window.BDSBuilder, c = b && b.cart;
    if (c && c.lines) return c.lines.slice();
    var st = window.BDS && window.BDS.cart && window.BDS.cart.state;
    return ((st && st.items) || []).filter(function (it) { return !(it.properties && it.properties._bds_gift); })
      .map(function (it) { return { handle: it.handle, id: it.variant_id, qty: it.quantity }; });
  }
  function openBuilder() {
    var B = window.BDSBuilder;
    var sel = allRows().filter(function (r) { return cart.selected[r.id]; });
    var prefill = sel.filter(function (r) { return builderKnown(r.product.handle); })
      .map(function (r) { return { handle: r.product.handle, id: +(cart.variants[r.id] || r.variant.id), qty: qtyOf(r) }; })
      .concat((cart.extras || []).filter(function (e) { return builderKnown(e.handle); }).map(function (e) { return { handle: e.handle, id: e.variant.id, qty: e.quantity }; }));
    // what was in the store cart before Customize: not part of the quiz setup, so it never becomes a quiz extra
    builderBase = {};
    builderLines().forEach(function (l) { var k = l.handle + ":" + l.id; builderBase[k] = (builderBase[k] || 0) + (l.qty || 0); });
    builderOn = true;
    if (!builderUnsub && B.slideout.onChange) builderUnsub = B.slideout.onChange(function (lines) { syncFromBuilder(lines); });
    B.slideout.open(prefill, {
      title: "Customize your setup",
      focus: prefill.map(function (l) { return { handle: l.handle, id: l.id }; }),
      filter: sel.some(function (r) { return r.product.handle === "a5-binder-cover" || String(r.id).indexOf("insert:") === 0; }) ? "planner" : "bundles",
      onClose: function () { syncFromBuilder(); },
    });
  }
  function syncFromBuilder(linesIn) {
    var lines = (linesIn || builderLines()).map(function (l) { return { handle: l.handle, id: +l.id, qty: l.qty != null ? l.qty : l.quantity }; }), used = {};
    allRows().forEach(function (row) {
      if (!builderKnown(row.product.handle)) return; // not sold in the builder: keep the quiz's own pick
      var isIns = row.insert || String(row.id).indexOf("insert:") === 0;
      var i = -1;
      lines.forEach(function (l, k) { if (i < 0 && !used[k] && l.handle === row.product.handle && (!isIns || l.id === row.variant.id)) i = k; });
      if (i < 0) { cart.selected[row.id] = false; return; }
      used[i] = true;
      cart.selected[row.id] = true;
      cart.qty[row.id] = Math.min(MAX_QTY, lines[i].qty);
      if (lines[i].id !== row.variant.id) cart.variants[row.id] = lines[i].id;
    });
    var base = Object.assign({}, builderBase || {}), extras = [];
    lines.forEach(function (l, k) {
      if (used[k]) return;
      var key = l.handle + ":" + l.id, b = base[key] || 0, take = Math.min(l.qty, b), q = l.qty - take;
      base[key] = b - take;
      if (q <= 0) return;
      var sl = storeLine(l.handle, l.id);
      if (sl) extras.push({ handle: l.handle, product: sl.product, variant: sl.variant, quantity: q });
    });
    cart.extras = extras;
    document.getElementById("cart").innerHTML = renderCart();
    updateCart();
  }

  // ---------- setup sheet (phones) ----------
  // The setup block itself moves into a bottom sheet, so every tick, swatch and quantity works exactly as on the page
  // and the page shows the same state when the sheet closes.
  var sheetHome = null;
  function openSheet() {
    var setup = document.getElementById("res-2"), res = app.querySelector(".results");
    if (!setup || !res || app.querySelector(".sheet")) return;
    sheetHome = document.createComment("setup");
    setup.parentNode.insertBefore(sheetHome, setup);
    var sheet = document.createElement("div");
    sheet.className = "sheet";
    sheet.setAttribute("role", "dialog");
    sheet.setAttribute("aria-modal", "true");
    sheet.setAttribute("aria-label", "Your setup");
    sheet.innerHTML = '<div class="sheet__scrim" data-action="close-sheet"></div><div class="sheet__panel"><button type="button" class="sheet__close" data-action="close-sheet" aria-label="Close">&times;</button></div>';
    sheet.querySelector(".sheet__panel").appendChild(setup);
    res.appendChild(sheet);
    res.classList.add("is-custom", "has-sheet");
    document.documentElement.classList.add("sheet-open");
    sheet.querySelector(".sheet__close").focus();
  }
  function closeSheet() {
    var sheet = app.querySelector(".sheet"), setup = document.getElementById("res-2"), res = app.querySelector(".results");
    if (!sheet || !setup || !sheetHome) return;
    sheetHome.parentNode.insertBefore(setup, sheetHome);
    sheetHome.remove();
    sheet.remove();
    if (res) res.classList.remove("is-custom", "has-sheet");
    document.documentElement.classList.remove("sheet-open");
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSheet(); });

  // ---------- insert guide modal ----------
  // Mirrors the theme's "Insert detail" modal: an overview (what's included, best for) and a stepped
  // "How to use" walkthrough, both driven by the insert variant's metafields (data/insert-guides.js).

  var guideDialog = null;
  var guideState = null;

  function openGuide(rowId) {
    if (!guideDialog) {
      guideDialog = document.createElement("dialog");
      guideDialog.className = "guide";
      guideDialog.setAttribute("aria-labelledby", "guide-title");
      QROOT.appendChild(guideDialog);
      guideDialog.addEventListener("click", onGuideClick);
      guideDialog.addEventListener("close", function () {
        var trigger = app.querySelector('[data-guide="' + cssEscape(guideState.rowId) + '"]');
        if (trigger) trigger.focus();
      });
    }
    guideState = { rowId: rowId, step: -1 };
    renderGuide();
    guideDialog.showModal();
  }

  function guideRow() {
    return allRows().filter(function (r) { return r.id === guideState.rowId; })[0];
  }

  function renderGuide(focusSelector) {
    var row = guideRow();
    var guide = M.guides[String(row.variant.id)];
    var parts = /^(.*?)\s*\((.+)\)$/.exec(row.variant.title) || [null, row.variant.title, ""];
    var name = parts[1] + " insert";
    var step = guideState.step;
    var steps = guide.steps;
    var image = step < 0 ? row.variant.image || row.product.image : steps[step].image;
    var selected = !!cart.selected[row.id];

    var content;
    var foot;
    if (step < 0) {
      content =
        '<h2 id="guide-title">' + esc(name) + "</h2>" +
        '<p class="guide__tagline">' + esc(guide.tagline) + "</p>" +
        '<div class="guide__cols">' +
        '<div><h3>What\'s included</h3><ul>' + guide.inside.map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul></div>" +
        '<div><h3>Best for</h3><ul>' + guide.bestFor.map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul></div>" +
        "</div>" +
        '<div class="guide__why"><h3>' + esc(row.whyLabel) + "</h3><p>" + esc(row.why) + "</p></div>";
      foot =
        '<button type="button" class="button button--ghost button--small" data-guide-action="steps">How to use</button>' +
        '<span class="guide__spacer"></span>' +
        (selected
          ? '<span class="guide__added">In your setup</span><button type="button" class="link" data-guide-action="close">Done</button>'
          : '<button type="button" class="button button--small" data-guide-action="add">Add to my setup</button>');
    } else {
      content =
        '<ol class="guide__dots" aria-label="Steps">' +
        steps.map(function (_, i) {
          return '<li><button type="button" data-guide-action="goto" data-step="' + i + '" aria-label="Step ' + (i + 1) + '"' + (i === step ? ' aria-current="step"' : "") + ">" + (i + 1) + "</button></li>";
        }).join("") +
        "</ol>" +
        '<p class="eyebrow">Step ' + (step + 1) + " of " + steps.length + "</p>" +
        '<h2 id="guide-title">' + esc(steps[step].title) + "</h2>" +
        '<p class="guide__lead">' + esc(steps[step].lead) + "</p>" +
        (steps[step].body ? '<p class="guide__body-text">' + esc(steps[step].body) + "</p>" : "");
      foot =
        '<button type="button" class="link" data-guide-action="overview">Back to overview</button>' +
        '<span class="guide__spacer"></span>' +
        '<button type="button" class="button button--ghost button--small" data-guide-action="prev"' + (step === 0 ? " disabled" : "") + ">Back</button>" +
        (step < steps.length - 1
          ? '<button type="button" class="button button--small" data-guide-action="next">Next</button>'
          : '<button type="button" class="button button--small" data-guide-action="overview">Finish</button>');
    }

    guideDialog.innerHTML =
      '<div class="guide__bar"><span class="eyebrow">Insert guide · ' + money.format(row.variant.price) + "</span>" +
      '<button type="button" class="guide__close" data-guide-action="close" aria-label="Close">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" /></svg></button></div>' +
      '<div class="guide__main">' +
      '<figure class="guide__media"><img src="' + esc(img(image, 700)) + '" alt="' + esc(step < 0 ? name : steps[step].title) + '" width="600" height="600" />' +
      (guide.pages ? '<figcaption class="guide__pages">' + esc(guide.pages) + "</figcaption>" : "") +
      (guide.fullImage
        ? '<button type="button" class="guide__zoom" data-guide-action="zoom" aria-label="View the full ' + esc(name) + ' template">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="5.5" /><path d="M12.5 12.5 17 17M8.5 6v5M6 8.5h5" /></svg></button>'
        : "") +
      "</figure>" +
      '<div class="guide__content">' + content + "</div>" +
      "</div>" +
      '<div class="guide__foot">' + foot + "</div>";

    var target = focusSelector && guideDialog.querySelector(focusSelector);
    if (target && !target.disabled) target.focus();
  }

  function onGuideClick(event) {
    // A click on the backdrop lands on the dialog element itself.
    if (event.target === guideDialog) { guideDialog.close(); return; }
    var el = event.target.closest("[data-guide-action]");
    if (!el) return;
    var action = el.getAttribute("data-guide-action");
    var steps = M.guides[String(guideRow().variant.id)].steps;
    if (action === "close") { guideDialog.close(); return; }
    if (action === "zoom") { openLightbox(guideRow()); return; }
    if (action === "add") {
      cart.selected[guideState.rowId] = true;
      var box = app.querySelector('[data-row="' + cssEscape(guideState.rowId) + '"] .row__check');
      if (box) box.checked = true;
      updateCart();
      renderGuide('[data-guide-action="close"]');
      return;
    }
    if (action === "steps") guideState.step = 0;
    else if (action === "overview") guideState.step = -1;
    else if (action === "next") guideState.step = Math.min(steps.length - 1, guideState.step + 1);
    else if (action === "prev") guideState.step = Math.max(0, guideState.step - 1);
    else if (action === "goto") guideState.step = Number(el.getAttribute("data-step"));
    renderGuide(action === "overview" ? '[data-guide-action="steps"]' : action === "goto" ? '[aria-current="step"]' : '[data-guide-action="' + action + '"]');
  }

  // Full-size template viewer, opened from the magnifier. It stacks above the guide modal; Esc, the close
  // button or a click outside the image returns to the guide. Clicking the image toggles fit and 100% zoom.
  var lightbox = null;

  function openLightbox(row) {
    var guide = M.guides[String(row.variant.id)];
    var parts = /^(.*?)\s*\((.+)\)$/.exec(row.variant.title) || [null, row.variant.title, ""];
    var label = parts[1] + " insert template";
    if (!lightbox) {
      lightbox = document.createElement("dialog");
      lightbox.className = "lightbox";
      QROOT.appendChild(lightbox);
      lightbox.addEventListener("click", function (event) {
        var image = event.target.closest(".lightbox__img");
        if (image) {
          var zoomed = lightbox.classList.toggle("is-zoomed");
          image.setAttribute("aria-label", zoomed ? "Fit to screen" : "Zoom to full size");
          return;
        }
        if (event.target.closest("[data-lightbox-close]") || event.target === lightbox || event.target.classList.contains("lightbox__stage")) lightbox.close();
      });
      lightbox.addEventListener("close", function () {
        var zoom = guideDialog && guideDialog.querySelector(".guide__zoom");
        if (zoom) zoom.focus();
      });
    }
    lightbox.classList.remove("is-zoomed");
    lightbox.setAttribute("aria-label", label);
    lightbox.innerHTML =
      '<div class="lightbox__bar"><span>' + esc(label) + "</span>" +
      '<button type="button" class="lightbox__close" data-lightbox-close aria-label="Close">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" /></svg></button></div>' +
      '<div class="lightbox__stage"><button type="button" class="lightbox__img" aria-label="Zoom to full size">' +
      '<img src="' + esc(guide.fullImage) + '" alt="' + esc(label) + '" width="1000" height="1000" /></button></div>';
    lightbox.showModal();
  }

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : value;
  }

  // One setup row's unit price as the quiz charges it, { full, sale, pct }, for the variant the row has picked. A ticked row is
  // priced inside the setup as it stands; an unticked one as if it were added, exactly as updateCart prices its slot. null for another
  // variant (the sheet then prices it by the shared rule).
  function rowUnitPrice(rowId, id) {
    var rows = allRows(), row = rows.filter(function (x) { return x.id === rowId; })[0];
    if (!row || String(row.variant.id) !== String(id)) return null;
    var selected = rows.filter(function (r) { return cart.selected[r.id]; });
    var on = !!cart.selected[row.id];
    var line = on
      ? engine.priceCart(toLines(selected).concat(extraLines()), catalog.discounts).lines[selected.indexOf(row)]
      : engine.priceCart(toLines(selected.concat([row])), catalog.discounts).lines[selected.length];
    if (!line || !line.quantity) return null;
    return { full: line.listTotal / line.quantity, sale: line.final, pct: line.discount ? line.discount.percent : 0 };
  }

  // ---------- product modal ----------
  // Uses the shared product modal (BDSProductModal, the Bundle Builder's "See details" sheet) when the page loads it.
  // Until then a small built-in sheet shows the product without ever navigating away from the quiz.
  function openProduct(rowId) {
    var row = allRows().filter(function (x) { return x.id === rowId; })[0];
    if (!row) return;
    var refresh = function () { document.getElementById("cart").innerHTML = renderCart(); updateCart(); };
    if (window.BDSProductModal) {
      var scrollY0 = window.scrollY;
      window.BDSProductModal.open(row.product.handle, {
        variantId: row.variant.id,
        addLabel: "Add to bag",
        context: "quiz",
        backLabel: "Back to my results",
        // the sheet colours the option as this row does (the quiz's walnut brown); its name stays the product's own ("Color: Walnut")
        swatches: row.product.variants.reduce(function (m, v) { var c = swatchCss(v.title); if (c && c !== "transparent") m[v.title] = c; return m; }, {}),
        // the sheet states the row's own price: in the setup, what the setup charges for it (a planner insert at the setup's
        // insert tier); not yet in it, what it would cost once added. Same priceCart as the row, so the two never disagree.
        price: function (h, id) { return rowUnitPrice(row.id, id); },
        qty: function () { return cart.selected[row.id] ? qtyOf(row) : 0; },
        onAdd: function () { cart.selected[row.id] = true; refresh(); },
        onQty: function (h, id, delta) {
          var q = qtyOf(row) + delta;
          if (q < 1) cart.selected[row.id] = false; else cart.qty[row.id] = Math.min(MAX_QTY, q);
          refresh();
        },
        onPick: function (h, id) { cart.variants[row.id] = id; refresh(); },
        onBack: function () { window.scrollTo({ top: scrollY0 }); },
      });
      return;
    }
    var dlg = document.createElement("dialog");    var dlg = document.createElement("dialog");
    dlg.className = "pmodal";
    dlg.innerHTML =
      '<button type="button" class="pmodal__x" aria-label="Close">&times;</button>' +
      '<img src="' + esc(img(row.variant.image || row.product.image, 600)) + '" alt="" />' +
      "<h2>" + esc(row.product.title) + "</h2>" +
      (row.variant.title !== "Default Title" ? '<p class="pmodal__variant">' + esc(row.variant.title) + "</p>" : "") +
      (row.why ? "<p>" + esc(row.why) + "</p>" : "") +
      '<button type="button" class="button pmodal__add">' + (cart.selected[row.id] ? "In your setup" : "Add to setup") + "</button>";
    QROOT.appendChild(dlg);
    var close = function () { dlg.close(); dlg.remove(); };
    dlg.querySelector(".pmodal__x").addEventListener("click", close);
    dlg.querySelector(".pmodal__add").addEventListener("click", function () { cart.selected[row.id] = true; refresh(); close(); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener("cancel", function () { dlg.remove(); });
    dlg.showModal();
  }

  // The fix: three steps, each with a thumbnail of the product doing that job, in the colour picked for this setup.
  function thumbFor(handle) {
    var photo = quiz.results.images && quiz.results.images.fix && quiz.results.images.fix[handle];
    if (photo) return photo;
    var row = allRows().filter(function (x) { return x.product.handle === handle; })[0];
    if (row) return row.variant.image || row.product.image;
    var kit = result.kit && result.kit.product.contains.indexOf(handle) !== -1;
    var p = catalog.products.filter(function (x) { return x.handle === handle; })[0];
    if (!p) return "";
    var pick = (result.items.filter(function (e) { return e.product.handle === handle; })[0] || {}).variant;
    return (pick && pick.image) || p.image;
  }

  // A second chosen problem gets one line of its own, so its chip is answered.
  function alsoLine(r) {
    var second = r.problems[1];
    if (!second || !quiz.results.insights[second.id]) return "";
    return '<p class="summary__also"><strong>Also, ' + esc(second.title.toLowerCase()) + ":</strong> " + esc(quiz.results.insights[second.id]) + "</p>";
  }

  // The banner shows the setup's lead product in the chosen vibe: planner photo for planner-led setups,
  // a Flow Timer photo for timer-led ones, nothing for desk-led ones.
  function bannerFor(r) {
    var I = quiz.results.images;
    if (!I) return "";
    var lead = r.kit ? r.kit.product.handle : r.items[0] ? r.items[0].id : "";
    var planner = lead === "a5-binder-cover" || lead.indexOf("insert:") === 0;
    var timer = ["flow-bundle", "flow-timer", "task-time", "task-time-bundle", "focus-habits-kit", "weeks-habits"].indexOf(lead) !== -1;
    if (planner) return I.banners.pastel;
    if (timer) return answers.style === "dark" ? I.banners.dark : I.banners.light;
    return "";
  }

  // The fix is built from the setup: a step shows only if its product (or the exact planner page it names) is in
  // the setup, and any gap is filled from the setup's own pieces. Every image is that product's studio shot in the
  // chosen colourway, on the same square tile.
  var FIX_FILL = {
    "flow-timer": "Set a session and press the knob.",
    "task-time": "Write today's tasks on one card.",
    "weeks-habits": "Put this week and your habits on one card.",
    "card-pencil-tray": "Stand today's card in the tray, in view.",
    "a5-binder-cover": "Keep your whole plan in one binder.",
    "desk-pad": "Mark out a clear work zone.",
    "cable-management-kit": "Hide the cable tangle.",
    "coaster-set-5-piece": "Give your drink a spot outside the work zone.",
    "insert:daily": "Block out tomorrow on a Daily page before you stop.",
    "insert:weekly": "Map the week on Sunday, deadlines first.",
    "insert:monthly": "Put every date for the month on one spread.",
    "insert:habit": "Tick each habit off on the Habit Tracker before bed.",
    "insert:goal": "Write one goal and the first three steps toward it.",
    "insert:focus": "Split today into Do first and Do later.",
    "insert:meeting": "Give each meeting a page and circle the actions.",
    "insert:todo": "Keep one To-Do list at the front of the binder.",
    "insert:memo": "Catch stray thoughts on a Memo page, not sticky notes.",
    "insert:wellness": "Log sleep, water and mood in a minute a day.",
  };

  function setupParts() {
    var parts = {}, order = [];
    var add = function (key, row) { if (!parts[key]) { parts[key] = row || true; order.push(key); } };
    allRows().forEach(function (row) {
      if (!cart.selected[row.id]) return;
      if (row.id === "kit" && result.kit) {
        result.kit.product.contains.forEach(function (h) { add(h, null); });
        return;
      }
      add(row.id, row);
      add(row.product.handle, row);
    });
    return { has: function (k) { return !!parts[k]; }, row: function (k) { return parts[k] === true ? null : parts[k]; }, order: order };
  }

  function partImage(key, parts) {
    var row = parts.row(key);
    if (row && row.variant) return row.variant.image || row.product.image;
    if (key.indexOf("insert:") === 0) {
      var def = quiz.planner.inserts[key.slice(7)], p = catalog.products.filter(function (x) { return x.handle === quiz.planner.insertProduct; })[0];
      var v = p && def && p.variants.filter(function (x) { return x.title.indexOf(def.variant) === 0; })[0];
      return (v && v.image) || (p && p.image) || "";
    }
    return vibeImage(key);
  }

  // Each fix step belongs to one bar of the results chart. Steps are ordered by that bar's score and spread across
  // different bars where the setup allows, so the fix reads as the answer to the chart. The tray and pencil are
  // accessories of the card system, so they only get a step when there are no cards.
  // The bars each piece answers, best fit first.
  var FIX_DIM = {
    "flow-timer": ["focus", "time"], "task-time": ["overwhelm", "time", "focus"], "weeks-habits": ["habits", "time"], "card-pencil-tray": ["space"],
    "a5-binder-cover": ["overwhelm", "time"], "insert:daily": ["time", "overwhelm"], "insert:weekly": ["time", "overwhelm"], "insert:monthly": ["time"],
    "insert:habit": ["habits"], "insert:goal": ["overwhelm", "habits"], "insert:focus": ["focus", "overwhelm"], "insert:meeting": ["overwhelm", "time"],
    "insert:todo": ["overwhelm", "focus"], "insert:memo": ["overwhelm", "space"], "insert:wellness": ["habits"],
    "desk-pad": ["space", "focus"], "cable-management-kit": ["space"], "coaster-set-5-piece": ["space"],
  };
  function fixSteps(sum) {
    var parts = setupParts(), seen = {}, pool = [];
    var hasCards = parts.has("task-time") || parts.has("weeks-habits");
    var add = function (k, t) {
      if (seen[k] || !parts.has(k) || k === "pencil" || (hasCards && k === "card-pencil-tray")) return;
      seen[k] = true;
      if (t) pool.push({ key: k, t: t, dims: FIX_DIM[k] || ["focus"], order: pool.length });
    };
    sum.fix.forEach(function (s) { add(s.h, s.t); });
    parts.order.forEach(function (k) { add(k, FIX_FILL[k]); });
    var score = {};
    profileScores(result).forEach(function (d) { score[d.id] = d.score; });
    // Highest bar first: give each bar the first piece that answers it, then fill with the rest on their best bar.
    var order = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; });
    var steps = [];
    order.forEach(function (d) {
      if (steps.length >= 3) return;
      // The piece for which this bar is the strongest fit (the timer for Focus, the cards for Overwhelm).
      var s = pool.filter(function (x) { return steps.indexOf(x) === -1 && x.dims.indexOf(d) !== -1; })
        .sort(function (a, b) { return a.dims.indexOf(d) - b.dims.indexOf(d) || a.order - b.order; })[0];
      if (s) { s.dim = d; steps.push(s); }
    });
    pool.forEach(function (s) { if (steps.length < 3 && steps.indexOf(s) === -1) { s.dim = s.dims[0]; steps.push(s); } });
    return steps.sort(function (a, b) { return (score[b.dim] || 0) - (score[a.dim] || 0); });
  }

  // Every piece the fix can show has a method: its name, our tool for it, and three plain steps (round 7, items 13-14).
  var FIX_METHOD = {"flow-timer": ["Focus sessions", "Flow Timer", ["Pick one task and nothing else.", "Set 25 minutes and press start.", "When it buzzes, take the 5-minute break, then go again."]], "task-time": ["Time blocking", "Task & Time Cards", ["Write your one most important task in the Today's Focus box. Do that one first.", "List the rest underneath in the order you'll do them. We suggest no more than six.", "Give each task a block on the time grid, then work down the card."]], "weeks-habits": ["Weekly view + habit streaks", "Weeks & Habits Cards", ["On Sunday, write the week's dates and deadlines.", "Pick up to five habits to track.", "Tick each one off as you do it and keep it in view."]], "card-pencil-tray": ["One home for today's plan", "Card & Pencil Tray", ["Stand today's card in the front slot.", "Keep spare cards and the pencil behind it.", "Clear everything else off the desk."]], "a5-binder-cover": ["One binder for everything", "A5 Modular Planner", ["Put the pages you use most at the front.", "Move pages around as your weeks change.", "Take it wherever you work, so the plan comes with you."]], "insert:daily": ["Daily planning", "Daily insert", ["Before you stop, write tomorrow's top three.", "Block them on the timeline.", "Open it first thing and start with number one."]], "insert:weekly": ["Weekly review", "Weekly insert", ["On Sunday, list the week's deadlines first.", "Spread the tasks across the days.", "Glance at it each morning and move what slips."]], "insert:monthly": ["Month at a glance", "Monthly insert", ["Add every fixed date for the month.", "Mark the busiest week.", "Plan lighter days around it."]], "insert:habit": ["Habit tracking", "Habit Tracker insert", ["Choose up to five habits.", "Tick each one before bed.", "Never miss twice in a row."]], "insert:goal": ["Goal setting", "Goal Setting insert", ["Write one goal and why it matters.", "List the first three steps.", "Put step one on today's list."]], "insert:focus": ["Do first, do later", "Focus insert", ["List everything on your mind.", "Split it into Do first and Do later.", "Work only from Do first until it's done."]], "insert:meeting": ["Meeting notes that turn into actions", "Meeting Notes insert", ["Give each meeting its own page.", "Circle every action as it comes up.", "Move the actions onto your list straight after."]], "insert:todo": ["One list for everything", "To-Do insert", ["Write every task on one page.", "Star the top three.", "Cross them off as you go and carry the rest forward."]], "insert:memo": ["A capture page", "Memo insert", ["Jot stray thoughts the moment they come.", "Read the page back at the end of the day.", "Move anything useful onto a list."]], "insert:wellness": ["A one-minute wellness log", "Wellness Tracker insert", ["Log sleep, water and mood each day.", "It takes about a minute.", "Look back weekly for patterns."]], "cable-management-kit": ["A clear desk", "Cable Management Kit", ["Unplug what you don't use.", "Bundle and clip the rest.", "Route the cables out of sight."]], "desk-pad": ["A defined work zone", "Desk Pad", ["Lay the pad where you work.", "Only today's tools go on it.", "Clear it at the end of the day."]], "coaster-set-5-piece": ["Drinks out of the work zone", "Coaster Set", ["Give your drink one spot.", "Keep it outside the work zone.", "No more rings or spills on your notes."]]};

  function poolImage(key, used) {
    var pool = ((quiz.results.images || {}).inuse || {})[key];
    if (!pool) return null;
    if (typeof pool === "string") pool = [pool];
    var seed = (answers.problems[0] || "") + "/" + (answers.drill || ""), h = 0;
    for (var i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
    for (var j = 0; j < pool.length; j++) {
      var src = pool[(h + j) % pool.length];
      if (used.indexOf(src) === -1) { used.push(src); return src; }
    }
    return null;
  }

  var TOP_DIM = null;
  var LAST_FIX = [];
  // One compact "How it works" section under the products: each fix method's steps, collapsed by default.
  var HOW_CUTS = (quiz.results.how || {}).cuts || {};
  var HOW_RENDERS = (quiz.results.how || {}).renders || {};
  function howHtml() {
    var steps = LAST_FIX.filter(function (s) { return FIX_METHOD[s.key]; });
    if (!steps.length) return "";
    return '<details class="how" id="res-how"><summary>How it works<span class="how__sub">' + steps.length + ' methods &middot; 1 min read</span></summary><div class="how__body">' + steps.map(function (s, i) {
      var m = FIX_METHOD[s.key];
      // The tool's real cut-out (transparent, from the Figma asset banks) beside the steps; tapping it opens the product sheet.
      var row = allRows().filter(function (x) { return x.id === s.key || x.product.handle === s.key; })[0];
      var rend = HOW_RENDERS[s.key], cut = rend ? "" : HOW_CUTS[s.key] || "";
      if (rend) return '<section class="how__m has-render' + (s.key === "task-time" || s.key === "weeks-habits" ? " is-card" : " is-spread") + '"><div class="how__text"><h3><span>' + (i + 1) + "</span>" + esc(m[0]) + '</h3><ul class="how__steps">' +
        m[2].map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + '</ul><p class="how__tool">Our tool for this: ' + esc(m[1]) + "</p></div>" +
        '<button type="button" class="how__render" ' + (row ? 'data-view="' + esc(row.id) + '"' : 'data-tool="' + esc(s.key) + '"') + ' aria-label="See details: ' + esc(m[1]) + '"><img src="' + rend + '" alt="' + esc(m[1]) + ', filled in" loading="lazy" /></button></section>';
      var thumb = cut ? '<button type="button" class="how__cut" ' + (row ? 'data-view="' + esc(row.id) + '"' : 'data-tool="' + esc(s.key) + '"') + ' aria-label="See details: ' + esc(m[1]) + '"><img src="' + cut + '" alt="" loading="lazy" /></button>' : "";
      return '<section class="how__m' + (cut ? " has-cut" : "") + '"><div class="how__text"><h3><span>' + (i + 1) + "</span>" + esc(m[0]) + '</h3><ul class="how__steps">' +
        m[2].map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + '</ul><p class="how__tool">Our tool for this: ' + esc(m[1]) + "</p></div>" + thumb + "</section>";
    }).join("") + "</div></details>";
  }

  function fixHtml(sum) {
    var parts = setupParts(), used = [];
    TOP_DIM = profileScores(result)[0].id;
    return (
      '<section class="fix" id="res-fix" aria-label="' + esc(quiz.results.fixLabel) + '"><p class="fix__label">' + esc(quiz.results.fixLabel) + "</p><ol>" +
      (LAST_FIX = fixSteps(sum)).map(function (step, i) {
        var use = poolImage(step.key, used);
        return '<li><img src="' + (use ? use : esc(img(partImage(step.key, parts), 640))) + '" alt="" width="240" height="160" loading="lazy" />' +
          '<span class="fix__n">' + (i + 1) + '</span><span class="fix__dim' + (step.dim === TOP_DIM ? " is-top" : "") + '">' + esc(PROFILE_DIMS[step.dim] || "") + "</span>" +
          (FIX_METHOD[step.key] ? '<strong class="fix__method">' + esc(FIX_METHOD[step.key][0]) + "</strong>" : "") +
          '<span class="fix__line">' + esc(step.t) + "</span></li>";
      }).join("") + "</ol></section>"
    );
  }

  // Specific names for the Recommended list: "Daily insert", "A5 Modular Planner Binder · Sage Green".
  function rowLabel(row) {
    var t = row.variant && row.variant.title !== "Default Title" ? row.variant.title : "";
    if (row.insert || (row.id && String(row.id).indexOf("insert:") === 0)) return (/^(.*?)\s*\(/.exec(t) || [null, t])[1] + " insert";
    return row.product.title + (t ? " \u00b7 " + t : "");
  }

  // Education visual: the stat as a ring (percentages) or a large figure, a one-line caption with Sam's source,
  // then a before -> after pair with the product in the colour of the vibe already picked.
  function statGraphic(value, ring) {
    var pct = /^(\d+)%$/.exec(value);
    var r = 52, c = 2 * Math.PI * r, fill = ring && ring.fill ? ring.fill : pct ? Math.min(100, +pct[1]) / 100 : 1;
    return (
      '<svg class="ring" viewBox="0 0 120 120" aria-hidden="true">' +
      '<circle cx="60" cy="60" r="' + r + '" class="ring__track" />' +
      '<circle cx="60" cy="60" r="' + r + '" class="ring__fill" stroke-dasharray="' + (c * fill).toFixed(1) + " " + c.toFixed(1) + '" transform="rotate(-90 60 60)" />' +
      (ring ? ringParts(ring.value, ring.unit, ring.note) : ringText(value)) + "</svg>"
    );
  }

  // The number sits inside the ring with room to breathe; a unit ("days", "min") goes on its own line below it.
  function ringText(value) {
    var m = /^([\d.]+)(x|%)?\s*(.*)$/.exec(value) || [null, value, "", ""];
    var big = m[1] + (m[2] || ""), unit = m[3];
    return unit
      ? '<text x="60" y="54" class="ring__value" text-anchor="middle" dominant-baseline="central">' + esc(big) + "</text>" +
        '<text x="60" y="78" class="ring__unit" text-anchor="middle" dominant-baseline="central">' + esc(unit) + "</text>"
      : '<text x="60" y="60" class="ring__value" text-anchor="middle" dominant-baseline="central">' + esc(big) + "</text>";
  }

  // A ring with a comparison note: "55" / "days" / "vs 34 guessed".
  function ringParts(big, unit, note) {
    return '<text x="60" y="48" class="ring__value" text-anchor="middle" dominant-baseline="central">' + esc(big) + "</text>" +
      '<text x="60" y="70" class="ring__unit" text-anchor="middle" dominant-baseline="central">' + esc(unit) + "</text>" +
      (note ? '<text x="60" y="86" class="ring__note" text-anchor="middle" dominant-baseline="central">' + esc(note) + "</text>" : "");
  }

  function vibeImage(handle) {
    var p = catalog.products.filter(function (x) { return x.handle === handle; })[0];
    if (!p) return "";
    var prefs = quiz.variantPrefs[handle] && quiz.variantPrefs[handle].by === "style" ? quiz.variantPrefs[handle][answers.style] || [] : [];
    var v = null;
    prefs.some(function (needle) {
      v = p.variants.filter(function (x) { return x.available && x.title.toLowerCase().indexOf(needle.toLowerCase()) !== -1; })[0];
      return !!v;
    });
    return (v && v.image) || p.image;
  }

  function eduVisual(e, v) {
    return (
      '<figure class="edu-stat">' + (statViz(e.stat.value) || statGraphic(e.stat.value, v.ring)) +
      "<figcaption><span>" + esc(v.caption) + "</span>" + sourceHtml(e.stat) + "</figcaption></figure>" +
      '<div class="edu-pair">' +
      '<div class="edu-pair__before">' + icon(v.before.icon) + "<span>" + esc(v.before.t) + "</span></div>" +
      '<svg class="edu-pair__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
      '<div class="edu-pair__after"><img src="' + esc(img(vibeImage(v.after.h), 240)) + '" alt="" width="96" height="96" />' +
      "<span>" + esc(v.after.t) + "</span></div></div>"
    );
  }

  // One graphic per kind of number (captain, 14 Oct), same family: theme accent, thin strokes, 120-unit box.
  //   percentages -> 10x10 dot grid; seconds -> stopwatch dial; minutes -> clock pie; guess vs actual -> two bars;
  //   days to a habit -> a grid of day dots; projects -> a stack of cards.
  var VIZ = {
    "95%": { t: "grid", n: 95 }, "27%": { t: "grid", n: 27 }, "90%": { t: "grid", n: 90 },
    "40 sec": { t: "dial", n: 40 }, "25 min": { t: "pie", n: 25 }, "66 days": { t: "days", n: 66 },
    "10 projects": { t: "stack", n: 10 },
    "55 days": { t: "num", big: "+21", u: "days over plan" },
    "2x": { t: "num", big: "85x", u: "a day" },
    "9 min": { t: "num", big: "9 min", u: "faster" },
  };
  function statViz(value) {
    var v = VIZ[value];
    if (!v) return "";
    var o = '<svg class="viz viz--' + v.t + '" viewBox="0 0 140 120" aria-hidden="true">', i;
    if (v.t === "num") return '<div class="viz viz--num" aria-hidden="true"><b>' + esc(v.big) + "</b><span>" + esc(v.u) + "</span></div>";
    if (v.t === "grid") {
      for (i = 0; i < 100; i++) o += '<circle cx="' + (25 + (i % 10) * 10) + '" cy="' + (15 + Math.floor(i / 10) * 10) + '" r="3.4" class="' + (i < v.n ? "on" : "off") + '"/>';
    } else if (v.t === "days") {
      for (i = 0; i < 70; i++) o += '<rect x="' + (22 + (i % 10) * 10) + '" y="' + (10 + Math.floor(i / 10) * 11) + '" width="7" height="7" rx="1.5" class="' + (i < v.n ? "on" : "off") + '"/>';
      o += '<text x="70" y="112" text-anchor="middle" class="viz__t">' + v.n + " days</text>";
    } else if (v.t === "dial" || v.t === "pie") {
      var cx = 70, cy = 56, r = 36, a = v.n / 60 * 2 * Math.PI, x = cx + r * Math.sin(a), y = cy - r * Math.cos(a);
      o += '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" class="viz__face"/>';
      if (v.t === "dial") o += '<rect x="64" y="7" width="12" height="7" rx="2" class="viz__line"/><path d="M70 14v6" class="viz__line"/>';
      for (i = 0; i < 12; i++) { var t = i / 12 * 2 * Math.PI; o += '<path d="M' + (cx + 30 * Math.sin(t)).toFixed(1) + " " + (cy - 30 * Math.cos(t)).toFixed(1) + "L" + (cx + 34 * Math.sin(t)).toFixed(1) + " " + (cy - 34 * Math.cos(t)).toFixed(1) + '" class="viz__line"/>'; }
      o += '<path d="M' + cx + " " + cy + "L" + cx + " " + (cy - r) + "A" + r + " " + r + " 0 " + (a > Math.PI ? 1 : 0) + " 1 " + x.toFixed(1) + " " + y.toFixed(1) + 'Z" class="viz__wedge"/>';
      o += '<text x="' + cx + '" y="112" text-anchor="middle" class="viz__t">' + v.n + (v.t === "dial" ? " seconds" : " minutes") + "</text>";
    } else if (v.t === "stack") {
      for (i = 0; i < v.n; i++) o += '<rect x="' + (18 + (i % 5) * 21) + '" y="' + (22 + Math.floor(i / 5) * 40 + (i % 2) * 4) + '" width="16" height="30" rx="2.5" class="on-soft"/>';
      o += '<text x="70" y="112" text-anchor="middle" class="viz__t">' + v.n + " at once</text>";
    } else if (v.t === "bars") {
      var max = Math.max(v.a[1], v.b[1]);
      [v.a, v.b].forEach(function (bar, k) {
        var y0 = 22 + k * 48, w = Math.round(bar[1] / max * 116);
        o += '<text x="12" y="' + y0 + '" class="viz__l">' + esc(bar[0]) + "</text>" +
          '<rect x="12" y="' + (y0 + 6) + '" width="' + w + '" height="16" rx="8" class="' + (k ? "on" : "off") + '"/>' +
          '<text x="' + Math.min(128, 12 + w + 4) + '" y="' + (y0 + 18) + '" class="viz__v"' + (w > 90 ? ' text-anchor="end" dx="-10" fill-opacity="1" data-in="1"' : "") + ">" + bar[1] + "</text>";
      });
      o += '<text x="12" y="116" class="viz__l">' + esc(v.u) + "</text>";
    }
    return o + "</svg>";
  }

  // Small stroke icons for the insight lines (no emoji).
  var ICONS = {
    clock: '<path d="M12 7v5l3 2"/><circle cx="12" cy="12" r="8"/>',
    target: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3.5"/>',
    list: '<path d="M9 7h10M9 12h10M9 17h10M5 7h.01M5 12h.01M5 17h.01"/>',
    phone: '<rect x="7" y="3.5" width="10" height="17" rx="2"/><path d="M11 17h2"/>',
    repeat: '<path d="M4 12a8 8 0 0 1 14-5.3L20 9M20 4v5h-5M20 12a8 8 0 0 1-14 5.3L4 15M4 20v-5h5"/>',
    box: '<path d="M4 8l8-4 8 4-8 4zM4 8v8l8 4 8-4V8"/>',
    moon: '<path d="M19 14.5A7.5 7.5 0 0 1 9.5 5a7.5 7.5 0 1 0 9.5 9.5z"/>',
    pencil: '<path d="M4 20l4-1 11-11-3-3L5 16z"/>',
    tabs: '<rect x="3.5" y="7" width="13" height="10" rx="1.5"/><path d="M7.5 7V4.5h13v10h-4"/>',
  };
  var PROBLEM_ICON = { procrastination: "clock", focus: "target", overwhelm: "list", time: "clock", phone: "phone", habits: "repeat", clutter: "box", multitasking: "target", study: "clock", switchoff: "moon" };
  function icon(name) {
    return '<svg class="insight__icon" viewBox="0 0 24 24" aria-hidden="true">' + ICONS[name] + "</svg>";
  }

  // One line per chosen problem (up to 3), then the planning answer, capped at 4.
  function insightsHtml(r) {
    var R = quiz.results;
    var lines = r.problems.map(function (x) { return { icon: PROBLEM_ICON[x.id] || "target", label: x.title, text: R.insights[x.id] }; });
    var plan = R.planningInsights[answers.planning];
    if (plan) lines.push({ icon: "pencil", label: "Planning", text: plan });
    return '<ul class="insights">' + lines.slice(0, 4).map(function (l) {
      return '<li>' + icon(l.icon) + '<span><strong>' + esc(l.label) + ":</strong> " + esc(l.text) + "</span></li>";
    }).join("") + "</ul>";
  }

  // ---------- market ----------
  // Prices, availability and currency come from Liquid for the visitor's market. The quiz recommends for AU and US; any other
  // market uses the US product set (AU-only pieces drop out) in its own currency.
  var LQM = M.market || {};
  var ISO = String(LQM.iso || (window.BDS && window.BDS.market && window.BDS.market.iso) || "US").toUpperCase();
  var MARKET = ISO === "AU" ? "AU" : "US";
  catalog.currency = LQM.currency || (MARKET === "AU" ? "AUD" : "USD");
  // Prices read exactly as the rest of the store writes them (product cards, the product modal, the Bundle Builder, the
  // cart): BDS.money, which follows the store's money format for the visitor's market, so Australia sees "$92.65" beside a
  // currency selector that says "Australia | AUD $". Without the sale core, the currency's local narrow symbol.
  var money0 = new Intl.NumberFormat(MARKET === "AU" ? "en-AU" : "en-US", { style: "currency", currency: catalog.currency, currencyDisplay: "narrowSymbol" });
  money = { format: function (n) {
    var B = window.BDS;
    if (B && typeof B.money === "function") return (n < 0 ? "-" : "") + B.money(Math.abs(n), true);
    return money0.format(n);
  } };
  if (MARKET !== "AU") (quiz.results.auOnly || []).forEach(function (h) { delete quiz.items[h]; });

  // ---------- offer ----------
  // The sale follows the global switch (BDS.sale.active: theme setting + window). ?offer=<mode> overrides for testing.
  var BDSX = window.BDS || null;
  var SALE_ON = !!(BDSX && BDSX.sale && BDSX.sale.active);
  var OFFER_KEY = (/[?&]offer=(\w+)/.exec(location.search) || [])[1] || (SALE_ON ? "birthday" : "evergreen");
  var OFFER = quiz.results.offer.modes[OFFER_KEY] || quiz.results.offer.modes.evergreen;
  // BDS prices every line (engine bdsPrice); these rules only price when the sale layer is not on the page.
  catalog.discounts = OFFER.discounts === "everyday" ? (M.discountsEveryday || []).slice() : [];
  // Gift tiers and free shipping come from the market (settings + the market metafield), never from the content file.
  if (OFFER.gifts && BDSX && BDSX.M) {
    var mk0 = BDSX.M(), mt = mk0.tiers || [];
    OFFER.gifts.tiers.forEach(function (t, i) { if (mt[i + 1]) t.at = +mt[i + 1]; });
    OFFER.gifts.freeShipping = OFFER.gifts.freeShipping || {};
    if (mk0.ship) OFFER.gifts.freeShipping[catalog.currency] = +mk0.ship;
  }
  var emailUnlocked = false;
  var giftCovered = {};

  function giftMeta(total) {
    var g = OFFER.gifts, S = quiz.results.offer.strings;
    if (!g) return "";
    // Free shipping only where this market has a threshold; no fallback figure.
    // The ticket always counts down to the next gift tier, the same on every path (captain's example).
    var ship = null;
    if (ship && total < ship) return S.toShipping.replace("{amount}", money.format(ship - total));
    var got = [], next = null;
    g.tiers.forEach(function (t) {
      if (t.skipIf && allRows().some(function (r) { return cart.selected[r.id] && t.skipIf.indexOf(r.product.handle) !== -1; })) return;
      if (total >= t.at) got.push(t.gift); else if (!next) next = t;
    });
    var parts = [];
    // every gift reached so far, not just the last tier's: "free pencil + coasters"
    if (got.length) parts.push(S.got.replace("{gift}", got.join(" + ")).toLowerCase());
    if (next) {
      // A paid pencil in the setup is taken off the bill when the tier is reached, so the line only promises what's new.
      var paidPencil = allRows().some(function (r) { return cart.selected[r.id] && r.product.handle === "pencil"; });
      var amt = money.format(next.at - total);
      parts.push(paidPencil && /pencil/.test(next.gift)
        ? amt + " more and your " + next.gift + (/s$/.test(next.gift) ? " are" : " is") + " free"
        : S.toGift.replace("{amount}", amt).replace("{gift}", next.gift).replace(/ a free (\w+s)$/, " free $1"));
    }
    return parts.join(" · ");
  }

  // Stories from our customers: Sam's theme has the live PDP UGC carousel and review cards; standalone, this shows
  // the proof row, customer photos (timer setups) and verified review cards filtered to the products in the setup.
  // Prev / next arrows on the results rails and the add-ons strip (Sam, 16 Oct): the scrollbars are hidden, so a mouse needs a way across.
  // Touch screens swipe and never see them (CSS); a mouse can also click-and-drag a rail (wired below with markRails).
  function railNav(d) {
    return '<button type="button" class="qrail__nav qrail__nav--' + (d < 0 ? "prev" : "next") + '" data-rail-nav="' + d + '" aria-label="' + (d < 0 ? "Scroll back" : "Scroll for more") + '" hidden>' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (d < 0 ? "m15 18-6-6 6-6" : "m9 18 6-6-6-6") + '"/></svg></button>';
  }

  function proofHtml(r) {
    var P = quiz.results.proof, I = quiz.results.images || {}, parts = setupParts();
    var has = function (h) { return parts.has(h) || (h === "a5-planner-inserts" && parts.order.some(function (k) { return k.indexOf("insert:") === 0; })); };
    var timer = has("flow-timer"), planner = has("a5-binder-cover") || has("a5-planner-inserts");
    var cards = [];
    if (timer && I.ugc) P.ugc.forEach(function (u) { if (I.ugc[u[0]]) cards.push('<figure class="proof__card proof__card--photo"><img src="' + I.ugc[u[0]] + '" alt="" width="160" height="200" loading="lazy" /><figcaption>' + esc(u[2]) + "<span>" + esc(u[1]) + "</span></figcaption></figure>"); });
    void 0;
    var lead = r.items[0] ? r.items[0].id : "";
    var leadCat = lead === "a5-binder-cover" || lead.indexOf("insert:") === 0 ? "planner" : lead === "flow-timer" ? "timer" : lead === "task-time" || lead === "weeks-habits" ? "cards" : planner ? "planner" : timer ? "timer" : "cards";
    var line = ""; // Captain, 14 Oct: no per-product rating line; the store-wide row carries the proof.
    // Videos: their products first, then the others, so it's never all one product.
    var cats = { timer: timer, planner: planner, cards: has("task-time") || has("weeks-habits") };
    var allowed = { timer: true, planner: !cats.cards, cards: !cats.planner };
    var byCat = { timer: [], planner: [], cards: [] };
    (P.videos || []).forEach(function (v) { byCat[v[0]].push(v); });
    var order = ["timer", "planner", "cards"].sort(function (a, b) { return (cats[b] ? 1 : 0) - (cats[a] ? 1 : 0) || (a === leadCat ? -1 : b === leadCat ? 1 : 0); });
    var vids = [];
    for (var round = 0; vids.length < 8 && round < 6; round++) {
      order.forEach(function (c) {
        if (!allowed[c]) return;
        var take = cats[c] ? 2 : round === 0 ? 1 : 0;
        for (var t = 0; t < take && vids.length < 8; t++) { var v = byCat[c].shift(); if (v) vids.push(v); }
      });
    }
    vids = (P.videos || []).slice();   // One fixed set on every path, every customer video (item 32): no per-path picks.
    var NAMES = { timer: "Flow Timer", planner: "Modular Planner", cards: "Task & Time Cards" };
    var videoRail = vids.length ? '<div class="qrail">' + railNav(-1) + '<div class="vids">' + vids.map(function (v) {
      return '<figure class="vid"><button type="button" class="vid__play" data-video="' + esc(v[1]) + '" aria-label="Play customer video"><img src="' + esc(v[2]) + '" alt="" width="160" height="284" loading="lazy" /><span class="vid__icon" aria-hidden="true"></span></button><figcaption>' + NAMES[v[0]] + "</figcaption></figure>";
    }).join("") + "</div>" + railNav(1) + "</div>" : "";
    // Review cards: setup products first, then a few from the rest, so the mix stays honest.
    var mine = [], rest = [];
    var LEAD_H = { planner: ["a5-binder-cover", "a5-planner-inserts"], timer: ["flow-timer"], cards: ["task-time", "weeks-habits"] }[leadCat] || [];
    Object.keys(P.reviews).sort(function (a, b) { return (LEAD_H.indexOf(b) !== -1) - (LEAD_H.indexOf(a) !== -1); })
      .forEach(function (h) {
        var cat = h === "flow-timer" ? "timer" : h.indexOf("a5-") === 0 ? "planner" : h === "task-time" || h === "weeks-habits" ? "cards" : null;
        if (!has(h) && cat && !allowed[cat]) return;
        P.reviews[h].forEach(function (q) { (has(h) ? mine : rest).push([q[0], q[1], q[2], h]); });
      });
    cards = [];
    var RNAME = { "flow-timer": "Flow Timer", "a5-binder-cover": "Modular Planner", "a5-planner-inserts": "Planner Inserts", "task-time": "Task & Time Cards", "weeks-habits": "Weeks & Habits Cards", "card-pencil-tray": "Card & Pencil Tray" };
    var STARS = '<span class="stars" aria-label="5 out of 5 stars">' + [0, 1, 2, 3, 4].map(function () { return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"/></svg>'; }).join("") + "</span>";
    // Round 7, item 32: the same full set of reviews on every path, all products together.
    mine = []; rest = [];
    Object.keys(P.reviews).forEach(function (h) { P.reviews[h].forEach(function (q) { mine.push([q[0], q[1], q[2], h]); }); });
    mine.forEach(function (q) {
      cards.push('<figure class="proof__card">' + STARS + '<blockquote>"' + esc(shortQuote(q[0])) + '"</blockquote><figcaption><span>' + esc(q[1]) + "</span> &middot; verified buyer<small>" + esc(RNAME[q[3]] || "") + "</small></figcaption></figure>");
    });
    return (
      '<section class="proof" id="res-stories" aria-label="' + esc(P.title) + '"><h2 class="proof__title">' + esc(P.title) + "</h2>" +
      (line ? '<p class="proof__line">' + esc(line) + "</p>" : "") +
      '<p class="proof__row proof__row--chips">' + P.row.map(function (x) { return '<span class="nowrap">' + esc(x) + "</span>"; }).join("") + "</p>" +
      videoRail + (cards.length ? '<div class="qrail">' + railNav(-1) + '<div class="proof__rail">' + cards.join("") + "</div>" + railNav(1) + "</div>" : "") + "</section>"
    );
  }

  // Your results graphic: their problems as thick ranked bars (weighted as Sam's engine weights them), the
  // biggest one labelled, and their own answer about it underneath.
  // Your results chart: four areas scored 1-10 from their answers. Each picked problem feeds the areas it belongs
  // to, weighted by rank as Sam's engine weights them; areas nobody picked sit at a low baseline. A desk-clutter
  // pick swaps in "Space" for the lowest area so their problem is always on the chart.
  var PROFILE_DIMS = { focus: "Focus", time: "Time", overwhelm: "Overwhelm", habits: "Habits", space: "Space" };
  var PROFILE_MAP = {
    procrastination: { time: 0.7, focus: 0.6 }, focus: { focus: 1, time: 0.3 }, overwhelm: { overwhelm: 1, time: 0.3 }, time: { time: 1, overwhelm: 0.3 },
    phone: { focus: 0.9, time: 0.4 }, habits: { habits: 1, time: 0.3 }, clutter: { space: 1, focus: 0.3 }, multitasking: { overwhelm: 0.8, focus: 0.5 },
    study: { focus: 0.6, time: 0.6 }, switchoff: { overwhelm: 0.6, habits: 0.5 },
  };
  function profileScores(r) {
    var w = quiz.problemWeights, raw = {};
    r.problems.forEach(function (p, i) {
      var m = PROFILE_MAP[p.id] || {}, k = (w[i] || w[w.length - 1]) / w[0];
      Object.keys(m).forEach(function (d) { raw[d] = (raw[d] || 0) + m[d] * k; });
    });
    var dims = ["focus", "time", "overwhelm", "habits"].map(function (d) { return { id: d, score: Math.max(2, Math.min(10, Math.round(2 + 8 * Math.min(1, raw[d] || 0)))) }; });
    if (raw.space) {
      dims.sort(function (a, b) { return a.score - b.score; });
      dims[0] = { id: "space", score: Math.max(2, Math.min(10, Math.round(2 + 8 * Math.min(1, raw.space)))) };
    }
    // "A little" softens every score, "A lot" keeps them at full strength.
    var hb = { 1: 0.7, 2: 0.85, 3: 1 }[answers.holdback] || 0.85;
    dims.forEach(function (d) { d.score = Math.max(2, Math.round(2 + (d.score - 2) * hb)); });
    var top0 = dims.reduce(function (m, d) { return d.score > m.score ? d : m; }, dims[0]);
    var seed = String(answers.drill || "") + "|" + (answers.planning || "") + "|" + (answers.place || "");
    dims.forEach(function (d) {
      if (d === top0) return;
      var h = 0; for (var k = 0; k < (seed + d.id).length; k++) h = (h * 31 + (seed + d.id).charCodeAt(k)) >>> 0;
      var bump = h % 4 + (answers.planning === "none" && d.id === "habits" ? 1 : 0) + (answers.place === "onthego" && d.id === "time" ? 1 : 0);
      d.score = Math.min(top0.score - 1, d.score + bump);
    });
    var ORDER = ["focus", "time", "overwhelm", "habits", "space"];
    return dims.sort(function (a, b) { return b.score - a.score || ORDER.indexOf(a.id) - ORDER.indexOf(b.id); });
  }
  // The Focus Report: a type card styled like an issued document (items 42, 43). Easter eggs are one tap each.
  var TYPES = {"procrastination": ["The Night-Before Hero", "Give you a deadline and you deliver.", "The easy stuff waits for the deadline too.", "Working well under pressure is exactly what the pressure wants you to think."], "focus": ["The Tab Hopper", "Curious about everything and quick to spot an idea.", "Twelve tabs open, one thing half done.", "We counted. It's never just one more tab."], "overwhelm": ["The Juggler", "People hand you things because you get them done.", "You won't drop a ball, so they all wobble.", "You're allowed to put one down. Nobody will tell."], "time": ["The Optimist", "You believe in what a day can hold.", "Your plan assumes a perfect day. Real ones run long.", "Optimists plan 34 days. The calendar says 55."], "phone": ["The Scroller", "Always in the loop and first to know.", "Your phone gets the first hour and the last.", "It's not you. That app has a whole team working on you."], "habits": ["The Sprinter", "Big starts and real energy on day one.", "Week two is where it fades.", "Day one: a new you. Day nine: who?"], "clutter": ["The Curator", "Everything on your desk has a story.", "There's no clear spot left to work.", "That mug is load-bearing. We get it."], "multitasking": ["The Plate Spinner", "You keep a lot moving at once.", "Every switch costs you the warm-up again.", "Plates spinning right now: all of them."], "study": ["The Crammer", "You can get a lot done in one long push.", "Cramming feels like it worked. Spacing it out works better.", "The library at 2am knows you by name."], "switchoff": ["The Always-On", "You care, and it shows in your work.", "Work follows you to dinner and to bed.", "Your laptop would like the evening off too."]};
  var SCORE_NOTES = {"focus": "How often the shiny thing wins.", "time": "How often the clock wins the argument.", "overwhelm": "How tall the pile feels on a Tuesday.", "habits": "How fast good intentions wander off.", "space": "How loudly your desk talks back."};
  function reportNo() {
    var n = null;
    try { n = sessionStorage.getItem("mds-report-code"); } catch (e) {}
    if (!n) {
      // Consonant-only prefixes (no words), five digits starting 3-9 (never reads as a year).
      var PRE = ["MDS", "FCS", "DGT", "TMB", "PLN", "KTR", "QRT", "BNX", "VLM", "HRZ", "CRD", "WKD"];
      n = PRE[Math.floor(Math.random() * PRE.length)] + "-" + (3 + Math.floor(Math.random() * 7)) + String(Math.floor(Math.random() * 10000)).padStart(4, "0");
      try { sessionStorage.setItem("mds-report-code", n); } catch (e) {}
    }
    return n;
  }
  // Item 6: a short explainer per type and a "Does this sound like you?" list, under Read more.
  var PERSONA = {
    procrastination: ["You do your best work when the clock is loud. A deadline gives the task a shape, so you start and you deliver.", "The cost is the days before it. The task gets heavier each day, and the easy things wait with it.", ["You know what to do and still open something else.", "Your best ideas arrive the night before.", "Small tasks pile up behind the big one.", "You promise yourself an early start next time."]],
    focus: ["Your brain loves a new thread. You spot ideas fast and connect things other people miss.", "Every jump costs a little warm-up time, and a day of small jumps adds up to a lot of half-finished work.", ["You open a tab to check one thing and find twelve.", "You reread the same paragraph after every ping.", "The day ends busy, with the main task still open.", "Quiet helps, and quiet is hard to find."]],
    overwhelm: ["You're the one people count on. When something needs doing, it lands with you, and it gets done.", "The list in your head never gets shorter, so even a good day ends with a feeling that you're behind.", ["Your to-do list lives in three places.", "You lie awake remembering things.", "Saying yes is easier than explaining why you can't.", "You can't tell which task matters most today."]],
    time: ["You plan with real hope. A day looks big from the morning side, so you fill it.", "Tasks take longer than the plan says, the day runs out first, and the leftovers roll into tomorrow.", ["You think a task takes 20 minutes. It takes an hour.", "The same items carry over every day.", "The end of the day surprises you.", "You run a few minutes late, often."]],
    phone: ["You like being connected and you hear about things first. A lot of your life happens on your phone.", "It's also the easiest thing to reach for, so short checks turn into long ones and the day loses its edges.", ["You pick up your phone and forget why.", "Your first and last hour are on a screen.", "You check notifications mid-task.", "A five-minute break turns into thirty."]],
    habits: ["You start strong. New plans get your full energy and the first week feels great.", "Week two is the hard part. The energy dips, nothing reminds you to keep going, and the habit quietly stops.", ["You've restarted the same habit more than once.", "Your apps are full of week-one streaks.", "Missing one day feels like the end of the streak.", "You need to see progress to keep going."]],
    clutter: ["Your space has character. Things stay because they mean something, or might be useful soon.", "When every surface is full, your eyes keep landing on something else, and starting means clearing a spot first.", ["You move things around before you can start.", "Cables, cups and notes share your work spot.", "Small things go missing in plain sight.", "A clean desk feels great, for a day."]],
    multitasking: ["You keep a lot moving at once, and people rely on that. Nothing stays forgotten for long.", "Each switch needs a moment to warm back up, and across a day those moments cost more than any one task.", ["You answer messages while you work on something else.", "Five things are open and one is in progress.", "You feel busy all day and finish little.", "You start a task, then remember another."]],
    study: ["You can focus hard for a long stretch when it counts, and you've pulled off results that way.", "What you learn in one push fades faster, so the same topics need cramming again before the next test.", ["Your study plan starts the week before the exam.", "You reread notes, feel ready, then go blank.", "Late nights before a deadline feel normal.", "You know you should start earlier."]],
    switchoff: ["You care about your work, and it shows. You stay reachable and you follow through.", "With no clear end to the day, work keeps running in the background and rest stops feeling like rest.", ["You check messages after dinner.", "Tomorrow's list runs through your head in bed.", "Weekends start slowly because work hasn't stopped.", "Being offline makes you feel guilty."]],
  };
  var HELPS = {
    procrastination: "A first step you can see, and a timer that makes starting feel small.",
    focus: "One task in view, and a countdown you can see that holds your attention on it.",
    overwhelm: "Everything out of your head and onto one page, then one task at a time.",
    time: "Blocking the day on paper, so the plan fits the hours you really have.",
    phone: "A timer that isn't your phone, so the phone can go in another room.",
    habits: "A streak you can see every day, kept where you'll look at it.",
    clutter: "A home for each tool, so the desk clears in one move.",
    multitasking: "One task per block, with the breaks planned in.",
    study: "Short, spaced sessions on a timer, tracked so you can see them add up.",
    switchoff: "Writing tomorrow's list before you stop, so the day has a clear end.",
  };
  var SEAL_ICONS = {
    procrastination: '<circle cx="47" cy="53" r="17"/><circle class="seal__cut" cx="55" cy="47" r="14"/><path d="M64 31l2 5 5 2-5 2-2 5-2-5-5-2 5-2z"/>',
    focus: '<rect x="42" y="31" width="26" height="19" rx="3" opacity=".45"/><rect class="seal__sep" x="37" y="37" width="26" height="19" rx="3" opacity=".72"/><rect class="seal__sep" x="32" y="43" width="26" height="19" rx="3"/><rect class="seal__cut" x="35" y="49" width="20" height="2"/>',
    overwhelm: '<path d="M33 58a17 17 0 0 1 34 0" fill="none" stroke="currentColor" stroke-width="2.2" stroke-dasharray="2 3.2" stroke-linecap="round"/><circle cx="33" cy="58" r="6"/><circle cx="50" cy="37" r="6"/><circle cx="67" cy="58" r="6"/>',
    time: '<path d="M36 60a14 14 0 0 1 28 0z"/><rect x="30" y="62" width="40" height="3.4" rx="1.7"/><path d="M50 36v6M35.5 44.5l4 4M64.5 44.5l-4 4M29 55h4.5M66.5 55H71" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>',
    phone: '<rect x="39" y="30" width="22" height="40" rx="4.5"/><rect class="seal__cut" x="42" y="35" width="16" height="27" rx="1.5"/><path d="M50 39.5v14M45 49l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>',
    habits: '<path d="M55 29L37 54h12l-4 18 18-26H51z"/>',
    clutter: '<rect x="31" y="34" width="38" height="31" rx="2.5"/><rect class="seal__cut" x="35" y="38" width="30" height="23"/><path d="M37 59l8.5-10.5 6 7 4.5-4.5 7 8z"/><circle cx="57" cy="44" r="3"/>',
    multitasking: '<ellipse cx="50" cy="38" rx="16" ry="5"/><rect x="48.4" y="43" width="3.2" height="27" rx="1.6"/><path d="M29 32q-4.5 6 0 12M71 32q4.5 6 0 12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>',
    study: '<path d="M49 38c-6-4-12-5-18-4v28c6-1 12 0 18 4z"/><path d="M51 38c6-4 12-5 18-4v28c-6-1-12 0-18 4z"/><path class="seal__cutline" d="M35 42h10M35 47h10M55 42h10M55 47h10" fill="none" stroke-width="1.6" stroke-linecap="round"/>',
    switchoff: '<path d="M50 31v16" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round"/><path d="M40.5 38.5a15 15 0 1 0 19 0" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>',
  };
  window.MDS_SEAL_ICONS = SEAL_ICONS;
  function personaHtml(id, t) {
    var P = PERSONA[id];
    if (!P) return "";
    return '<div class="persona"><p class="persona__h">About ' + esc(t[0].replace(/^The /, "the ")) + "</p><p>" + esc(P[0]) + "</p><p>" + esc(P[1]) + "</p>" +
      '<p class="persona__h">Does this sound like you?</p><ul class="persona__list">' + P[2].map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul></div>";
  }
  function reportCard(sum, r) {
    var p = primary(), t = TYPES[p.id];
    if (!t) return '<h1 class="display display--sm summary__problem" tabindex="-1">' + esc(sum.problem) + "</h1>";
    var second = (answers.problems || []).filter(function (id) { return id !== p.id && TYPES[id]; })[0];
    var date = new Date().toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    var ring = ("Certified " + t[0] + " \u00b7 ").toUpperCase();
    return '<section class="report" id="report" aria-label="Your focus report">' +
      '<p class="report__meta">Focus Report &middot; ' + esc(reportNo()) + " &middot; " + esc(date) + "</p>" +
      '<div class="report__head"><div class="report__id"><p class="report__eyebrow">Your focus type</p>' +
      '<h2 class="report__type" data-egg="type" tabindex="0">' + esc(t[0]) + "</h2>" +
      (second ? '<p class="report__streak">with a streak of ' + esc(TYPES[second][0].replace(/^The /, "the ")) + "</p>" : "") + "</div>" +
      '<span class="seal-hint" aria-hidden="true"><span class="seal-hint__t"><span class="h-touch">tap me</span><span class="h-mouse">click me</span></span><svg viewBox="0 0 36 30"><path d="M4 4c13 0 22 6 26 19M30 23l-6-2M30 23l2-6"/></svg></span>' +
      '<button type="button" class="report__seal" data-egg="seal" aria-label="Seal: certified ' + esc(t[0]) + '"><svg viewBox="0 0 100 100" aria-hidden="true">' +
      '<defs><path id="seal-ring" d="M50 50m-36 0a36 36 0 1 1 72 0a36 36 0 1 1 -72 0"/></defs>' +
      '<circle cx="50" cy="50" r="46" class="seal__o"/><circle cx="50" cy="50" r="27" class="seal__i"/>' +
      '<text class="seal__t"><textPath href="#seal-ring" textLength="224" lengthAdjust="spacingAndGlyphs">' + esc(ring) + "</textPath></text>" +
      '<path class="seal__check" d="M39 51l7 7 15-16"/>' +
      (SEAL_ICONS[p.id] ? '<g class="seal__persona" fill="currentColor">' + SEAL_ICONS[p.id] + "</g>" : "") +
      '<path class="seal__heart" d="M50 62c-8.5-5.6-13.5-10-13.5-15.6 0-3.8 2.9-6.6 6.5-6.6 2.9 0 5.4 1.7 7 4.2 1.6-2.5 4.1-4.2 7-4.2 3.6 0 6.5 2.8 6.5 6.6 0 5.6-5 10-13.5 15.6z"/>' +
      '<g class="seal__leaf"><g transform="rotate(-32 50 50)"><path class="seal__stem" d="M50 64v9"/><path class="seal__blade" d="M50 28c9 6 13.5 14 13 22-.5 8-5.5 13.5-13 15-7.5-1.5-12.5-7-13-15-.5-8 4-16 13-22z"/><path class="seal__vein" d="M50 33v31M50 43l5.5-4.5M50 43l-5.5-4.5M50 51l7-5M50 51l-7-5M50 59l6-4.5M50 59l-6-4.5"/></g></g><path class="seal__bat" d="M50 41l2.4-3.6 1.8 4.8c6-3.6 14.4-4.8 24.6-3-4.2 3.6-5.4 9-4.2 15-4.2-3-9-2.4-11.4 1.8-3-2.4-7.2-1.8-9 3l-4.2 8.4-4.2-8.4c-1.8-4.8-6-5.4-9-3-2.4-4.2-7.2-4.8-11.4-1.8 1.2-6 0-11.4-4.2-15 10.2-1.8 18.6-.6 24.6 3l1.8-4.8z"/></svg></button></div>' +
      '<h1 class="report__line summary__problem" tabindex="-1">' + esc(sum.problem) + "</h1>" +
      '<div class="report__more" id="report-more" hidden>' +
      personaHtml(p.id, t) + '<p class="report__why">' + esc(sum.why) + "</p>" + alsoLine(r) +
      '<p class="report__trait"><b>Strength:</b> ' + esc(t[1]) + "<br><b>Blind spot:</b> " + esc(t[2]) + "</p>" +
      (HELPS[p.id] ? '<p class="report__helps"><b>What helps:</b> ' + esc(HELPS[p.id]) + ' <button type="button" class="link report__fixlink" data-jump="res-fix">See your fix</button></p>' : "") +
      '<p class="report__sign">Minimal Desk Setups, Dept. of Getting Things Done</p>' +
      '<button type="button" class="report__toggle report__toggle--less" data-report="less">Show less</button></div>' +
      '<button type="button" class="report__toggle report__toggle--more" data-report="more" aria-expanded="false" aria-controls="report-more">Read more</button>' +
      "</section>";
  }

  function profileHtml(r) {
    var dims = profileScores(r);
    return '<figure class="profile profile--table" aria-label="What gets in your way">' +
      '<figcaption class="profile__title">What gets in your way<span class="profile__scale">Higher = gets in your way more</span></figcaption>' +
      dims.map(function (d, i) {
        var dots = ""; for (var k = 0; k < 10; k++) dots += '<i class="' + (k < d.score ? "on" : "") + '"></i>';
        return '<div class="profile__row' + (i === 0 ? " is-top" : "") + '"><div class="profile__label"><span>' + PROFILE_DIMS[d.id] + '<em class="profile__word' + (d.score >= 7 ? " is-high" : "") + '"> &middot; ' + (d.score >= 9 ? "Most days" : d.score >= 7 ? "Often" : d.score >= 4 ? "Sometimes" : "Rarely") + "</em>" + '</span><span class="profile__leader" aria-hidden="true"></span>' +
          '<b data-egg="score" data-dim="' + d.id + '" tabindex="0"><span class="count" data-to="' + d.score + '">' + d.score + "</span><small>/10</small></b></div>" +
          '<div class="profile__dots" aria-hidden="true">' + dots + "</div></div>";
      }).join("") + '<p class="profile__note">Scored from your answers</p>' +
      '<button type="button" class="profile__more" data-action="profile-more">Show all ' + dims.length + "</button></figure>";
  }

  function offerStrip(priced) {
    var S = quiz.results.offer.strings, E = quiz.results.offer.email;
    var meta = [];
    meta.push("Your setup " + money.format(priced.total));
    if (priced.savings > 0) meta.push("save " + money.format(priced.savings));
    var gift = giftMeta(priced.total);
    if (gift) meta.push(gift);
    if (!OFFER.tag) {
      return emailUnlocked ? '<span class="ticket"><span class="ticket__tag">' + esc(E.code) + '</span><span class="ticket__body">' + esc(E.applied) + "</span></span>" : "";
    }
    return '<span class="ticket"><span class="ticket__tag">' + esc(OFFER.tag) + '</span><span class="ticket__body">' +
      (priced.savings > 0 ? "You save " + money.format(priced.savings) : "Sale prices applied") + "</span></span>";
  }

  // Gift progress: each free gift as a small icon that unlocks at its tier, and how far to the next one.
  // ONE gift progress component, used on the results ticket, the mobile bar, the desktop card and Q8.
  // Tiers from BDS.tiers (sale-core): free shipping (per-market threshold from custom.shipping_threshold, via sale-core's
  // market shipMeta), the pencil, the coasters (Sam, 16 Oct). Light tiles in every theme; locked = dimmed + lock.
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  var LOCK = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="3.5" y="7" width="9" height="6.5" rx="1.2"/><path d="M5.5 7V5.2a2.5 2.5 0 0 1 5 0V7"/></svg>';
  var GIFTBOX = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="9" width="16" height="11" rx="1.5"/><path d="M3 9h18M12 9v11M12 9c-1.5-3-5-3.5-5-1.5S10 9 12 9zM12 9c1.5-3 5-3.5 5-1.5S14 9 12 9z"/></svg>';
  function shipAt() {
    var B = window.BDS, m = B && B.markets && B.markets[B.market];
    var n = m && parseFloat(String(m.shipMeta || "").replace(/[^0-9.]/g, ""));
    if (n) return n;
    var g = OFFER.gifts;
    return g && g.freeShipping ? g.freeShipping[catalog.currency] || null : null;
  }
  // BDS.gifts[x].img is a theme asset name ('cut-pencil.png'); BDS.assets maps it to the CDN url
  function gimg(n) { var A = window.BDS && window.BDS.assets; return n ? (A && A[n]) || n : n; }
  function giftList() {
    if (!OFFER.gifts) return [];
    var B = window.BDS, Mk = B && B.M ? B.M() : null, G = (B && B.gifts) || {};
    var at = Mk ? Mk.tiers : [shipAt(), OFFER.gifts.tiers[0].at, OFFER.gifts.tiers[1].at];
    var T = B && B.tiers && B.tiers.length ? B.tiers : [{ label: "Free shipping", get: "free shipping", gifts: ["shipping"] },
      { label: "Metal Pencil", get: "a free Metal Pencil", gifts: ["pencil"] }, { label: "Coasters", get: "free coasters", gifts: ["coasters"] }];
    // one tile per tier: the truck for free shipping, else the tier's gift image(s); id = the tier's gift ids ("pencil")
    return T.map(function (t, i) {
      var real = (t.gifts || []).filter(function (x) { return !(G[x] || {}).perk && x !== "shipping"; });
      var imgs = real.map(function (x) { return gimg((G[x] || {}).img); });
      return { id: real.length ? real.join("+") : "ship", gifts: real, name: t.label, at: at[i], icon: real.length ? null : TRUCK,
        imgs: imgs.length > 1 ? imgs : null, img: imgs.length === 1 ? imgs[0] : null, next: t.get || t.label.toLowerCase() };
    });
  }
  function giftMoney(n) { return money.format(n).replace(/\.00$/, ""); }
  // The shared line, in the store's money format: "Spend $85 for free shipping", "Spend $31 more for a free pencil".
  function giftNextLine(total) {
    var list = giftList(), next = list.filter(function (x) { return total < x.at; })[0];
    if (!next) return "All gifts unlocked";
    return total <= 0 ? "Spend " + giftMoney(next.at) + " for " + next.next : "Spend " + giftMoney(next.at - total) + " more for " + next.next;
  }
  // opts: { names: show names + "Spend $X" under tiles, label: show the FREE GIFTS label + next-step text, compact: small tiles }
  function giftTiles(total, opts) {
    opts = opts || {};
    var list = giftList();
    if (!list.length) return "";
    var nextText = giftNextLine(total);
    return '<div class="gifts' + (opts.compact ? " gifts--compact" : "") + '">' +
      (opts.label ? '<p class="gifts__label">' + GIFTBOX + "<b>Free gifts</b><span>" + esc(nextText) + "</span></p>" : "") +
      '<ul class="gifts__row">' + list.map(function (x) {
        var on = total >= x.at;
        var art = x.icon ? x.icon : x.imgs ? x.imgs.map(function (u) { return u ? '<img src="' + u + '" alt="" />' : ""; }).join("") : x.img ? '<img src="' + x.img + '" alt="" />' : "";
        return '<li class="gifts__g' + (on ? " is-on" : "") + '"><span class="gifts__tile' + (x.imgs ? " gifts__tile--pair" : "") + '">' + art +
          '<i class="gifts__badge">' + (on ? "&#10003;" : LOCK) + "</i></span>" +
          (opts.names ? '<span class="gifts__name">' + esc(x.name) + '</span><span class="gifts__at">' + (on ? "Unlocked" : "Spend " + esc(giftMoney(x.at))) + "</span>" : "") + "</li>";
      }).join("") + "</ul>" +
      (!opts.label && opts.compact && !opts.noNext ? '<span class="gifts__next">' + esc(nextText) + "</span>" : "") + "</div>";
  }

  // One line for tight spots, the same wording as the builder: what comes next, and how much more to spend.
  function giftText(total) {
    var list = giftList();
    if (!list.length) return "";
    var next = list.filter(function (x) { return total < x.at; })[0];
    var paidPencil = allRows().some(function (r) { return cart.selected[r.id] && r.product.handle === "pencil"; });
    var txt = next && next.gifts && next.gifts.indexOf("pencil") !== -1 && paidPencil && total > 0 ? "Spend " + giftMoney(next.at - total) + " more: " + next.name + " free" : giftNextLine(total);
    return '<p class="gift-text">' + GIFTBOX + "<span>" + esc(txt) + (next ? "" : " &#10003;") + "</span></p>";
  }

  // Desktop setup card: one summary line under the CTA, the labelled tiles on tap. Open by default below 1024px.
  function giftDropdown(total) {
    var open = !(window.matchMedia && window.matchMedia("(min-width: 1024px)").matches);
    return '<div class="ladder gifts-open">' + giftText(total) + giftTiles(total, { names: true, compact: true, noNext: true }) + "</div>";
  }

  // Up to three easy add-ons from the shared engine (BDSAddons.pick) that move the bag towards the next gift tier.
  // Card packs, inserts, the tray, a case when a timer is in. Never anything on BDS.noSuggest (Cable Kit, low stock).
  // An add-on you've added stays in the list as a stepper, so you can change or remove it in place.
  var ADDON_OK_UNUSED = ["task-time", "weeks-habits", "a5-planner-inserts", "card-pencil-tray", "carry-case"];
  // what each tier gives, from BDS.tiers: "free shipping" / "a free pencil" / "free coasters"
  var tierGet = function (i) { var t = window.BDS && window.BDS.tiers && window.BDS.tiers[i]; return t ? t.get || t.label.toLowerCase() : ""; };
  function addonGroups(extras) {
    var out = [], by = {};
    extras.forEach(function (e) {
      var k = e.group || e.handle + ":" + e.variant.id;
      if (!by[k]) { by[k] = { key: k, name: e.groupName || e.product.title, img: e.groupImg || e.variant.image || e.product.image, items: [] }; out.push(by[k]); }
      by[k].items.push(e);
    });
    return out;
  }
  function gapPick(selected, total) {
    var A = window.BDSAddons, B = window.BDS, known = {};
    if (!A || !A.pick || !B || !B.M || !OFFER.gifts) return "";
    var no = noSuggest(), ok = ADDON_OK_UNUSED.concat(MARKET === "AU" ? ["desk-pad"] : []).filter(function (h) { return no.indexOf(h) === -1; });
    var T = B.M().tiers, next = -1;
    for (var t = 0; t < T.length; t++) if (total < T[t]) { next = t; break; }
    var added = (cart.extras || []).filter(function (e) { return e.addon; });
    var planner = selected.some(function (r) { return r.product.handle === "a5-binder-cover" || String(r.id).indexOf("insert:") === 0; });
    var lines = selected.filter(function (r) { return builderKnown(r.product.handle); }).map(function (r) { return { handle: r.product.handle, id: +(cart.variants[r.id] || r.variant.id) }; })
      .concat((cart.extras || []).map(function (e) { return { handle: e.handle, id: e.variant.id }; }));
    var picks = [];
    if (next !== -1) {
      var gap = T[next] - total;
      try { picks = A.pick(lines, total, { max: 20 }); } catch (e) { picks = []; }
      // the shared engine's own ranking (complete the system, protect it, close the gap, then gifts and extras); single-line picks only
      picks = picks.filter(function (c) { return c.lines.every(function (l) { return no.indexOf(l.handle) === -1; }); });
      // Each card is priced as the cart would charge it once added, by the same priceCart as the setup rows: the card's own
      // lines at their discount (an insert at the tier the new insert count reaches), and the note by what the add-on adds to
      // the setup total (adding an insert can lift the inserts already picked to a better tier).
      var have = toLines(selected).concat(extraLines()), r2 = function (n) { return Math.round(n * 100) / 100; };
      picks = picks.slice(0, Math.max(0, 4 - added.length)).map(function (c) {
        var cl = c.lines.map(function (l) { var sl = storeLine(l.handle, l.id); return sl ? { handle: l.handle, variant: sl.variant, quantity: 1 } : null; });
        if (cl.every(Boolean)) {
          var pr = engine.priceCart(have.concat(cl), catalog.discounts), mine = pr.lines.slice(have.length);
          c.full = r2(mine.reduce(function (a, l) { return a + l.listTotal; }, 0));
          c.now = r2(mine.reduce(function (a, l) { return a + l.total; }, 0));
          c.pct = c.full > c.now ? Math.round((1 - c.now / c.full) * 100) : 0;
          c.adds = r2(pr.total - total);
        }
        var adds = c.adds != null ? c.adds : c.now;
        c.note = adds >= gap ? "gets you " + tierGet(next) : money.format(gap - adds).replace(/\.00$/, "") + " to " + tierGet(next).replace(/^(a|the) /, "");
        return c;
      });
    }
    if (!added.length && !picks.length) return "";
    var stepper = function (e) {
      var k = esc(e.handle + ":" + e.variant.id);
      if (window.BDS && window.BDS.qtyStep) return window.BDS.qtyStep([{ handle: e.handle, id: e.variant.id }], { name: e.product.title, qty: e.quantity, cls: "bds-qs--quiz" }).replace('class="bds-qs ', 'data-qs-extra="' + k + '" class="bds-qs ');
      return '<span class="qty qty--sm" role="group" aria-label="Quantity"><button type="button" data-xq="' + k + ':-1" aria-label="Remove one">&minus;</button><span class="qty__value">' + e.quantity + '</span><button type="button" data-xq="' + k + ':1" aria-label="Add one">+</button></span>';
    };
    var aoOpen = !(window.matchMedia && window.matchMedia("(min-width: 1024px)").matches) || window.__aoOpen;
    var nCards = addonGroups(added).length + picks.length;
    // An added add-on says what it is and what it costs: "Weekly insert" (the variant, when it names the piece, as an insert
    // row does) and "$9.60 · Added", priced by the same priceCart as the setup rows, from the setup as it stands.
    var setupLines = toLines(selected), extraPriced = engine.priceCart(setupLines.concat(extraLines()), catalog.discounts).lines.slice(setupLines.length);
    var addedName = function (g) {
      var e = g.items[0], vt = e.variant && e.variant.title;
      if (g.items.length > 1 || e.groupName || !vt || vt === "Default Title") return g.name;
      return e.handle === "a5-planner-inserts" ? vt.replace(/\s*\(.*\)$/, "") + " insert" : g.name + " · " + vt;
    };
    var addedMeta = function (g) {
      var ids = g.items.map(function (e) { return +e.variant.id; });
      var mine = extraPriced.filter(function (l) { return ids.indexOf(+l.line.variant.id) !== -1; });
      var now = mine.reduce(function (a, l) { return a + l.total; }, 0), full = mine.reduce(function (a, l) { return a + l.listTotal; }, 0);
      return (mine.length ? '<span class="addon__pr">' + esc(money.format(now)) + (full > now + 0.004 ? " <s>" + esc(money.format(full)) + "</s>" : "") + "</span> &middot; " : "") + "Added";
    };
    return '<details class="addons"' + (aoOpen ? " open" : "") + '><summary class="addons__h">' + (next === -1 ? "Your add-ons" : "Add-ons &middot; free gifts as you build") + ' <span class="addons__n">(' + nCards + ')</span></summary><div class="qrail qrail--ao">' + railNav(-1) + '<div class="addons__row">' +
      addonGroups(added).map(function (g) {
        var k = esc(g.key), q = Math.min.apply(null, g.items.map(function (e) { return e.quantity; }));
        var st = window.BDS && window.BDS.qtyStep ? window.BDS.qtyStep(g.items.map(function (e) { return { handle: e.handle, id: e.variant.id }; }), { name: g.name, qty: q, cls: "bds-qs--quiz" }).replace('class="bds-qs ', 'data-qs-extra="' + k + '" class="bds-qs ') : stepper(g.items[0]);
        return '<div class="addon is-added"><img src="' + esc(img(g.img, 120)) + '" alt="" width="40" height="40" /><span class="addon__t"><b>' + esc(addedName(g)) + "</b><small>" + addedMeta(g) + "</small></span>" + st + "</div>";
      }).join("") +
      picks.map(function (c) {
        var h1 = c.lines.length === 1 ? c.lines[0].handle : "", lc = h1 && M.ratings && M.ratings[h1], rm = lc && /([\d.]+)\s*\((\d[\d,]*)\)/.exec(lc.rating || "");
        // the magnifier opens the product on the very variant this add-on would add (Sam, 16 Oct)
        var tool = h1 ? ' data-tool="' + esc(h1) + '"' + (c.lines[0].id ? ' data-tool-variant="' + esc(c.lines[0].id) + '"' : "") : "";
        return '<div class="addon"><span class="addon__img"><img src="' + esc(img(c.img, 120)) + '" alt=""' + tool + ' width="40" height="40" />' + (c.pct ? '<i class="addon__pct">' + c.pct + "% OFF</i>" : "") +
          (h1 ? '<button type="button" class="addon__zoom"' + tool + ' aria-label="See details: ' + esc(c.name) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="7" cy="7" r="4.5"/><path d="m10.5 10.5 3 3"/></svg></button>' : "") + "</span>" +
          '<span class="addon__t"><span class="addon__n"><b' + tool + ">" + esc(c.name) + "</b>" + (rm ? '<em class="addon__stars">\u2605 ' + rm[1] + " (" + rm[2] + ")</em>" : "") + "</span>" +
          '<small><span class="addon__pr">' + esc(money.format(c.now)) + (c.full > c.now ? " <s>" + esc(money.format(c.full)) + "</s>" : "") + "</span> &middot; " + esc(c.note) + "</small></span>" +
          '<button type="button" class="addon__add" data-addpick="' + esc(JSON.stringify({ key: c.key, name: c.name, img: c.img, lines: c.lines })) + '" aria-label="Add ' + esc(c.name) + '">Add</button></div>';
      }).join("") + "</div>" + railNav(1) + "</div></details>";
  }

  function firstSentence(t) { var m = String(t || "").match(/^.*?[.!?](\s|$)/); return m ? m[0].trim() : String(t || ""); }
  function shortQuote(t) {
    t = String(t || ""); if (t.length <= 110) return t;
    var cut = t.slice(0, 110), end = Math.max(cut.lastIndexOf(". "), cut.lastIndexOf("! "), cut.lastIndexOf("? "));
    return end > 60 ? cut.slice(0, end + 1) : cut.slice(0, cut.lastIndexOf(" ")).replace(/[,;:]$/, "") + "\u2026";
  }

  function giftTrack(total) {
    return giftTiles(total, { names: true, label: true });
  }

  // Compact "Your setup" right under the fix card: picture, name and price of each selected piece, one Add button.
  function miniSetup(selected, priced) {
    var count = selected.reduce(function (sum, row) { return sum + qtyOf(row); }, 0) + extraLines().reduce(function (s, l) { return s + l.quantity; }, 0);
    var url = count ? engine.cartUrl(catalog.store, toLines(selected).concat(extraLines())) + (emailUnlocked ? "?discount=" + encodeURIComponent(quiz.results.offer.email.code) : "") : null;
    if (true) return (
      (url ? '<a class="button mini__add" href="' + esc(url) + '">' + (count === 1 ? "Add to cart" : "Add " + count + " to cart") + " &middot; " + money.format(priced.total) + "</a>" : "") +
      (OFFER.gifts ? giftDropdown(priced.total) : "") + gapPick(selected, priced.total)
    );
    return (
      '<p class="mini__label">Recommended for you</p><ul class="mini__list">' +
      selected.slice(0, 3).map(function (row, i) {
        var line = priced.lines[i];
        return '<li><img src="' + esc(img(row.variant.image || row.product.image, 200)) + '" alt="" width="56" height="56" loading="lazy" />' +
          '<span class="mini__name">' + esc(rowLabel(row)) + "</span>" +
          '<span class="mini__price">' + (line.discount ? '<s class="was">' + money.format(line.listTotal) + "</s> " : "") + money.format(line.total) + "</span></li>";
      }).join("") + "</ul>" +
      (selected.length > 3 ? '<p class="mini__more"><button type="button" class="link" data-jump="res-2">+ ' + (selected.length - 3) + " more in your setup</button></p>" : "") +
      '<div class="mini__foot">' +
      (url ? '<a class="button mini__add" href="' + esc(url) + '">' + (count === 1 ? "Add to cart" : "Add " + count + " to cart") + " &middot; " + money.format(priced.total) + "</a>" : "") +
      '<button type="button" class="link" data-action="customize">Customize</button></div>'
    );
  }

  // Re-theme: every background, text and border colour eases to the new vibe together (850ms), while a soft
  // bloom in the tapped vibe's own three swatch colours spreads from the tap and fades. The bloom is feathered to
  // transparent at every edge, so nothing sweeps across the page. Instant with reduced motion.
  var vibeTimer = null;
  function setVibe(value, x, y) {
    var root = QROOT, htmlEl = document.documentElement;
    if (root.getAttribute("data-vibe") === value) return;
    var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (still) { root.setAttribute("data-vibe", value); return; }
    // Themed reveal (captain, 14 Oct): the new vibe grows out of the tapped card as a heart (pastel), a bat (dark)
    // or a leaf (light), via a View Transition mask. Without View Transitions, the colour ease below runs instead.
    // Round 7: a pop-in variant was tried and rolled back at Damien's request; the original expanding reveal below runs.
    if (false) {
      var px = (x || window.innerWidth / 2), py = (y || window.innerHeight / 2);
      var pop = document.createElement("div");
      pop.className = "vibe-pop";
      pop.setAttribute("aria-hidden", "true");
      pop.setAttribute("data-shape", value);
      pop.style.left = px + "px";
      pop.style.top = py + "px";
      pop.innerHTML = '<i class="vibe-pop__shape"></i><span class="vibe-pop__spark">' + [0, 1, 2, 3, 4, 5, 6, 7].map(function (s) { return '<b style="rotate:' + s * 45 + 'deg"></b>'; }).join("") + "</span>";
      QROOT.appendChild(pop);
      setTimeout(function () { pop.remove(); }, 1300);
      root.classList.add("vibe-anim");
      root.setAttribute("data-vibe", value);
      clearTimeout(vibeTimer);
      vibeTimer = setTimeout(function () { root.classList.remove("vibe-anim"); }, 950);
      return;
    }
    if (true) {
      // Largest circle inside each shape (centre ax/ay, radius r, as fractions of the box), measured with canvas.
      var FIT = { pastel: [0.49, 0.5, 0.305], dark: [0.49, 0.38, 0.141], light: [0.5, 0.53, 0.375] }[value];
      var B = 1000, cx = x || window.innerWidth / 2, cy = y || window.innerHeight / 2;
      var far = Math.max(Math.hypot(cx, cy), Math.hypot(window.innerWidth - cx, cy), Math.hypot(cx, window.innerHeight - cy), Math.hypot(window.innerWidth - cx, window.innerHeight - cy));
      var cover = document.createElement("div");
      cover.className = "vibe-cover";
      cover.setAttribute("aria-hidden", "true");
      cover.setAttribute("data-shape", value);
      cover.style.left = (cx - FIT[0] * B) + "px";
      cover.style.top = (cy - FIT[1] * B) + "px";
      cover.style.setProperty("--ax", FIT[0] * 100 + "%");
      cover.style.setProperty("--ay", FIT[1] * 100 + "%");
      cover.style.setProperty("--s0", (40 / B).toFixed(4));
      // End scale = the smallest scale at which the shape really covers the screen (9x9 grid of viewport points
      // tested with isPointInPath), so every shape covers at exactly 900ms and nothing holds at full size.
      var PATHS = { pastel: "M50 90C21 70 5 52 5 33 5 18 16 8 30 8c9 0 16 5 20 12 4-7 11-12 20-12 14 0 25 10 25 25 0 19-16 37-45 57z", dark: "M50 24l4-6 3 8c10-6 24-8 41-5-7 6-9 15-7 25-7-5-15-4-19 3-5-4-12-3-15 5l-7 14-7-14c-3-8-10-9-15-5-4-7-12-8-19-3 2-10 0-19-7-25 17-3 31-1 41 5l3-8z", light: "M50 4C80 16 94 42 86 68 80 86 64 95 50 96 36 95 20 86 14 68 6 42 20 16 50 4z" };
      var hi = far / (FIT[2] * B) * 1.04, lo = 40 / B;
      try {
        var ctx = setVibe.ctx || (setVibe.ctx = document.createElement("canvas").getContext("2d"));
        var path = new Path2D(PATHS[value]), W = window.innerWidth, H = window.innerHeight;
        var covers = function (sc) {
          var size = sc * B;
          for (var gx = 0; gx <= 8; gx++) for (var gy = 0; gy <= 8; gy++) {
            var px = W * gx / 8, py = H * gy / 8;
            if (!ctx.isPointInPath(path, FIT[0] * 100 + (px - cx) / size * 100, FIT[1] * 100 + (py - cy) / size * 100)) return false;
          }
          return true;
        };
        if (covers(hi)) { for (var it = 0; it < 22; it++) { var mid = (lo + hi) / 2; if (covers(mid)) hi = mid; else lo = mid; } }
      } catch (err) {}
      cover.style.setProperty("--s1", (hi * 1.03).toFixed(4));
      QROOT.appendChild(cover);
      root.style.setProperty("--vx", cx + "px");
      root.style.setProperty("--vy", cy + "px");
      var spark = document.createElement("div");
      spark.className = "vibe-spark";
      spark.setAttribute("aria-hidden", "true");
      for (var s = 0; s < 8; s++) spark.innerHTML += '<i style="rotate:' + s * 45 + 'deg"></i>';
      QROOT.appendChild(spark);
      // The page crossfades to the new vibe right away (600ms); the wash and the words sit on top, faint.
      root.classList.add("vibe-anim");
      root.setAttribute("data-vibe", value);
      clearTimeout(vibeTimer);
      vibeTimer = setTimeout(function () { root.classList.remove("vibe-anim"); }, 650);
      var words = document.createElement("div");
      words.className = "vibe-words vibe-words--" + value;
      words.setAttribute("aria-hidden", "true");
      var letters = function (t) { var n = t.length; return t.split("").map(function (c, k) { return '<b style="--d:' + (k - (n - 1) / 2).toFixed(1) + '">' + (c === " " ? "&nbsp;" : c) + "</b>"; }).join(""); };
      var beats = ["da", "na", "na", "na", "na", "na", "na", "na&hellip;"].map(function (w, k) { return '<b style="--i:' + k + '">' + w + "</b>"; }).join(" ");
      var spk = [[-14, 6], [104, 18], [-8, 78], [102, 86]].map(function (p, k) { return '<i class="spk" style="left:' + p[0] + "%;top:" + p[1] + "%;--i:" + k + '">&#10022;</i>'; }).join("");
      var WORDS2 = {
        dark: '<svg class="bat" viewBox="0 0 100 100"><path d="M50 24l4-6 3 8c10-6 24-8 41-5-7 6-9 15-7 25-7-5-15-4-19 3-5-4-12-3-15 5l-7 14-7-14c-3-8-10-9-15-5-4-7-12-8-19-3 2-10 0-19-7-25 17-3 31-1 41 5l3-8z"/></svg><span class="beat">' + beats + "</span>",
        pastel: '<span style="--i:0">soft.</span><span style="--i:1">sweet.</span><span style="--i:2">so you.</span>' + spk,
        light: '<span class="br br--in">' + letters("breathe in") + '</span><span class="br br--out">' + letters("breathe out") + "</span>",
      };
      words.innerHTML = {
        dark: '<svg viewBox="0 0 100 100"><path d="M50 24l4-6 3 8c10-6 24-8 41-5-7 6-9 15-7 25-7-5-15-4-19 3-5-4-12-3-15 5l-7 14-7-14c-3-8-10-9-15-5-4-7-12-8-19-3 2-10 0-19-7-25 17-3 31-1 41 5l3-8z"/></svg><span>da na na na na na na na&hellip;</span>',
        pastel: "<span>soft.</span><span>sweet.</span><span>so you.</span>",
        light: "<span>breathe in &hellip; breathe out</span>",
      }[value] || "";
      words.innerHTML = WORDS2[value] || "";
      QROOT.appendChild(words);
      // Anchor on the tapped card (same origin as the growing shape), clamped inside the viewport.
      var card = null;
      try { var hit = document.elementFromPoint(cx, cy); card = hit && hit.closest ? hit.closest(".option") : null; } catch (er) {}
      var r0 = card ? card.getBoundingClientRect() : { left: cx, top: cy, width: 0, height: 0 };
      var wx = r0.left + r0.width / 2, wy = r0.top + r0.height / 2, ww = words.offsetWidth, wh = words.offsetHeight;
      // ...and above a pinned Continue bar (phones), so the words never cover the button the shopper reaches for next.
      var foot = app.querySelector(".step__footer"), fr = foot && foot.getBoundingClientRect();
      var floor = fr && fr.height && fr.top < window.innerHeight && fr.bottom > window.innerHeight - 4 ? fr.top : window.innerHeight;
      wx = Math.max(ww / 2 + 12, Math.min(window.innerWidth - ww / 2 - 12, wx));
      wy = Math.max(wh / 2 + 12, Math.min(floor - wh / 2 - 12, wy));
      words.style.setProperty("--wx", wx + "px");
      words.style.setProperty("--wy", wy + "px");
      cover.addEventListener("animationend", function (e) { if (e.animationName === "vibe-wash") { cover.remove(); spark.remove(); } });
      setTimeout(function () { cover.remove(); spark.remove(); }, 1100);
      setTimeout(function () { words.remove(); }, 1450);
      return;
    }
    if (document.startViewTransition) {
      // the View Transition pseudo-elements read these from <html>
      htmlEl.style.setProperty("--vx", (x || window.innerWidth / 2) + "px");
      htmlEl.style.setProperty("--vy", (y || window.innerHeight / 2) + "px");
      htmlEl.setAttribute("data-shape", value);
      var vt = document.startViewTransition(function () {
        root.setAttribute("data-vibe", value);
        // The shape grows in the new theme's colour, then fades into the page, so it shows even between two light themes.
        var flash = document.createElement("div");
        flash.className = "vibe-flash";
        flash.setAttribute("aria-hidden", "true");
        QROOT.appendChild(flash);
        var spark = document.createElement("div");
        spark.className = "vibe-spark";
        spark.setAttribute("aria-hidden", "true");
        for (var s = 0; s < 8; s++) spark.innerHTML += '<i style="rotate:' + s * 45 + 'deg"></i>';
        QROOT.appendChild(spark);
        vt.finished.then(function () { flash.remove(); spark.remove(); });
      });
      return;
    }
    var card = document.querySelector('[data-choose="style"] [data-value="' + value + '"]');
    var cols = card ? Array.prototype.map.call(card.querySelectorAll(".swatches span"), function (s) { return getComputedStyle(s).backgroundColor; }) : [];
    while (cols.length < 3) cols.push(cols[0] || "rgba(255,255,255,0.6)");
    var wash = document.createElement("div");
    wash.className = "vibe-bloom";
    wash.setAttribute("aria-hidden", "true");
    wash.style.setProperty("--vx", (x || window.innerWidth / 2) + "px");
    wash.style.setProperty("--vy", (y || window.innerHeight / 2) + "px");
    wash.style.setProperty("--c1", cols[0]);
    wash.style.setProperty("--c2", cols[1]);
    wash.style.setProperty("--c3", cols[2]);
    QROOT.appendChild(wash);
    wash.addEventListener("animationend", function () { wash.remove(); });
    setTimeout(function () { if (wash.parentNode) wash.remove(); }, 1000);
    root.classList.add("vibe-anim");
    root.setAttribute("data-vibe", value);
    clearTimeout(vibeTimer);
    vibeTimer = setTimeout(function () { root.classList.remove("vibe-anim"); }, 950);
  }

  // Mahjong dot tiles for the setup-size question. Coins are concentric rings; the one-dot is the big ornate flower.
  var MJ = { g: "#2F7A4D", r: "#C2392F", b: "#1F2B47" };
  function mjCoin(x, y, r, c) {
    return '<circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="' + c + '"/>' +
      '<circle cx="' + x + '" cy="' + y + '" r="' + (r * 0.74).toFixed(2) + '" fill="#FBF7EC"/>' +
      '<circle cx="' + x + '" cy="' + y + '" r="' + (r * 0.56).toFixed(2) + '" fill="' + c + '"/>' +
      '<circle cx="' + x + '" cy="' + y + '" r="' + (r * 0.2).toFixed(2) + '" fill="#FBF7EC"/>';
  }
  // Line version (captain, 13 Oct): tile outline with 1 / 2 / 3 outlined coins, same stroke as the card fans.
  function mahjongTile(n) {
    var coin = function (x, y, r) { return '<circle cx="' + x + '" cy="' + y + '" r="' + r + '"/><circle cx="' + x + '" cy="' + y + '" r="' + (r * 0.45).toFixed(2) + '"/>'; };
    var face = n === 1
      ? '<circle cx="12" cy="16" r="7.6"/><circle cx="12" cy="16" r="5.6" stroke-dasharray="1.4 1.6"/><circle cx="12" cy="16" r="2.6"/>'
      : n === 2 ? coin(12, 9.6, 4.6) + coin(12, 22.4, 4.6)
      : coin(7, 8.4, 3.5) + coin(12, 16, 3.5) + coin(17, 23.6, 3.5);
    return '<svg class="mj-tile" viewBox="0 0 24 32" aria-hidden="true"><rect x="1" y="1" width="22" height="30" rx="4"/>' + face + "</svg>";
  }

  function mahjongTileColour(n) {
    var face = "";
    if (n === 1) {
      var petals = "", cross = "";
      for (var i = 0; i < 12; i++) petals += '<ellipse cx="18" cy="13.6" rx="1.5" ry="2.6" fill="' + MJ.g + '" transform="rotate(' + i * 30 + ' 18 24)"/>';
      for (var j = 0; j < 6; j++) cross += '<circle cx="18" cy="20.6" r="1.05" fill="#FBF7EC" transform="rotate(' + j * 60 + ' 18 24)"/>';
      face = '<circle cx="18" cy="24" r="13.5" fill="' + MJ.g + '"/><circle cx="18" cy="24" r="11.8" fill="#FBF7EC"/>' + petals +
        '<circle cx="18" cy="24" r="6" fill="' + MJ.r + '"/>' + cross + '<circle cx="18" cy="24" r="1.1" fill="#FBF7EC"/>';
    } else if (n === 2) {
      face = mjCoin(18, 14.5, 7.5, MJ.g) + mjCoin(18, 33.5, 7.5, MJ.b);
    } else {
      face = mjCoin(10.5, 11, 6.2, MJ.g) + mjCoin(18, 24, 6.2, MJ.r) + mjCoin(25.5, 37, 6.2, MJ.b);
    }
    return '<svg class="mj-tile" viewBox="0 0 36 50" aria-hidden="true">' +
      '<rect x="0.5" y="2.5" width="35" height="47" rx="5" fill="#CDBF9C"/>' +
      '<rect x="0.5" y="0.5" width="35" height="46" rx="5" fill="#F6EFDC" stroke="rgba(60,45,20,0.18)"/>' +
      '<rect x="2.5" y="2.5" width="31" height="42" rx="3.5" fill="none" stroke="rgba(255,255,255,0.7)"/>' +
      face + "</svg>";
  }

  // Live PDP star ratings (BDS_LIVE_CARDS, read 13 Oct): "4.8 (479)" -> "★ 4.8 · 479 reviews".
  function starsHtml(handle) {
    var c = M.ratings && M.ratings[handle], m = c && /([\d.]+)\s*\((\d[\d,]*)\)/.exec(c.rating || "");
    return m ? '<p class="row__stars"><span aria-hidden="true">\u2605</span> ' + m[1] + " &middot; " + m[2] + " reviews</p>" : "";
  }

  // Setup size: a fanned hand of 1, 3 or 5 cards, drawn in the theme colours.
  function cardFan(n) {
    var angles = { 1: [0], 3: [-16, 0, 16], 5: [-28, -14, 0, 14, 28] }[n] || [0];
    return '<svg class="fan" viewBox="-2 -2 48 42" aria-hidden="true">' + angles.map(function (a, i) {
      var top = i === Math.floor(angles.length / 2) && angles.length > 1;
      return '<g transform="rotate(' + a + ' 22 34)"><rect x="15" y="6" width="14" height="20" rx="2.5" class="' + (top ? "fan__top" : "fan__card") + '"/>' +
        '<path d="M18.5 11h7M18.5 14.5h5" class="fan__line"/></g>';
    }).join("") + "</svg>";
  }

  var SIZE_STACK = [["flow-timer"], ["flow-timer", "task-time", "card-pencil-tray"], ["flow-timer", "task-time", "card-pencil-tray", "a5-binder-cover", "weeks-habits"]];
  function productStack(handles) {
    return '<span class="pstack" aria-hidden="true">' + handles.map(function (h) {
      var p = catalog.products.filter(function (x) { return x.handle === h; })[0];
      return p ? '<img src="' + esc(img(p.image, 96)) + '" alt="" width="30" height="30" />' : "";
    }).join("") + "</span>";
  }

  function makeItStick(m) {
    return (
      '<section class="stick"><h2>' + esc(m.title) + "</h2>" +
      '<p class="stick__stat"><b>77%</b><span>of people who use their planner every day say it fully helped.</span><small class="source">Source: MDS 2026 customer survey, 261 planner users</small></p>' +
      "<p>" + esc(m.body) + "</p>" +

      "<ul>" + m.tips.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("") + "</ul></section>"
    );
  }

  function debugTable(r) {
    return (
      '<details class="debug" open><summary>Debug: scoring</summary><table><tr><th>Item</th><th>Variant</th><th>Score</th></tr>' +
      r.items.map(function (e) { return "<tr><td>" + esc(e.id) + "</td><td>" + esc(e.variant.title) + "</td><td>" + e.score.toFixed(1) + "</td></tr>"; }).join("") +
      "</table><pre>" + esc(JSON.stringify(answers)) + "</pre></details>"
    );
  }

  function joinWords(words) {
    if (words.length < 2) return words.join("");
    return words.slice(0, -1).join(", ") + " and " + words[words.length - 1];
  }

  // ---------- events ----------

  // The quiz's Klaviyo payload. Five profile properties for segments, scores and vibe on the event only. A popup answer in mds_problem is overwritten: the quiz is the more accurate signal.
  function buildKlaviyoPayload(email) {
    var res = engine.recommend(answers, quiz, catalog), p = primary(), t = TYPES[p.id] || [p.label];
    var scores = {}; profileScores(res).forEach(function (d) { scores[d.id] = d.score; });
    // mds_problem is one of the four shared values the popup also writes. "space" (clutter) never reaches it.
    var FOUR = ["focus", "time", "overwhelm", "habits"];
    var top = FOUR.slice().sort(function (a, b) { return (scores[b] || 0) - (scores[a] || 0); })[0];
    var handles = [];
    res.items.filter(function (e) { return !res.kit || res.kit.covers.indexOf(e.id) === -1; }).map(engine.lineFor).forEach(function (l) { if (l && l.handle && handles.indexOf(l.handle) === -1 && !(OFFER.gifts && l.handle === "pencil")) handles.push(l.handle); });
    if (res.kit && handles.indexOf(res.kit.product.handle) === -1) handles.unshift(res.kit.product.handle);
    var size = { 1: "essentials", 3: "solid", 4: "full" }[answers.severity] || "solid";
    var profile = {
      mds_source: "quiz",
      mds_type: t[0],
      mds_problem: top,
      mds_setup_size: answers.severityAuto ? "full (not sure)" : size,
      mds_recommended: handles,
      // every problem they picked, in their ranked order (the first is their primary), for segments
      mds_problems: (answers.problems || []).slice(),
    };
    var ev = {
      mds_vibe: answers.style || "",
      mds_scores: { focus: scores.focus || 0, time: scores.time || 0, overwhelm: scores.overwhelm || 0, habits: scores.habits || 0 },
      mds_score_focus: scores.focus || 0, mds_score_time: scores.time || 0, mds_score_overwhelm: scores.overwhelm || 0, mds_score_habits: scores.habits || 0,
      mds_market: MARKET,
    };
    Object.keys(profile).forEach(function (k) { ev[k] = profile[k]; });
    return { email: email, consent: "email", event: "Completed Focus Quiz", profile_properties: profile, event_properties: ev };
  }
  function emailMode() {
    var E = quiz.results.offer.email;
    return E.modes[OFFER_KEY === "evergreen" ? "evergreen" : "sale"];
  }

  // Email step: an empty field just shows results. With an email: subscribe through Klaviyo's client API (when keys
  // are set), and in evergreen mode unlock the welcome code.
  app.addEventListener("submit", function (event) {
    if (!event.target.closest(".email__form")) return;
    event.preventDefault();
    var input = app.querySelector("#quiz-email");
    if (!input.value.trim()) { next(); return; }
    if (!input.checkValidity()) { input.reportValidity(); return; }
    var E = quiz.results.offer.email;
    // Only here, on submit, is anything built about the shopper. See KLAVIYO-INTEGRATION.md.
    var kp = buildKlaviyoPayload(input.value.trim());
    (window.MDS_KLAVIYO_LOG = window.MDS_KLAVIYO_LOG || []).push(kp);
    if (typeof window.MDS_KLAVIYO_SEND === "function") { try { window.MDS_KLAVIYO_SEND(kp); } catch (er) {} }
    if (!emailMode().unlocks || emailUnlocked) { next(); return; }
    emailUnlocked = true;
    catalog.discounts.push({ title: E.code, percent: E.percent, products: catalog.products.map(function (p) { return p.handle; }) });
    next();
  });

  app.addEventListener("click", function (event) {
    var jumpEl = event.target.closest("[data-jump]");
    if (jumpEl) {
      var target = document.getElementById(jumpEl.getAttribute("data-jump"));
      if (target && target.tagName === "DETAILS") target.open = true;
      var navTabs = app.querySelectorAll(".res-nav [data-jump]");
      if (target) jumpTo(target, navTabs.length && navTabs[0].getAttribute("data-jump") === target.id);
      navTabs.forEach(function (b) { b.toggleAttribute("aria-current", b.getAttribute("data-jump") === jumpEl.getAttribute("data-jump")); });
      return;
    }
    // "View product" opens the shared product modal instead of leaving the quiz.
    var whyEl = event.target.closest(".row__why");
    if (whyEl) { whyEl.closest(".row").classList.toggle("is-open"); return; }
    var skipEl = event.target.closest("[data-skip]");
    if (skipEl && !advancing) {
      var sk = skipEl.getAttribute("data-skip").split(":");
      answers[sk[0]] = sk[1];
      advancing = true;
      setTimeout(next, 120);
      return;
    }
    var xqEl = event.target.closest("[data-xq]");
    if (xqEl) {
      var xq = xqEl.getAttribute("data-xq").split(":"), xh = xq[0], xid = +xq[1], xd = +xq[2];
      cart.extras = (cart.extras || []).map(function (e) { if (e.handle === xh && e.variant.id === xid) e.quantity = Math.min(MAX_QTY, e.quantity + xd); return e; }).filter(function (e) { return e.quantity > 0; });
      document.getElementById("cart").innerHTML = renderCart();
      updateCart();
      return;
    }
    var addEl = event.target.closest("[data-addpick]");
    if (addEl) {
      var raw = addEl.getAttribute("data-addpick"), pick;
      try { pick = JSON.parse(raw); } catch (er) { var hp = raw.split(":"); pick = { key: raw, lines: [{ handle: hp[0], id: +hp[1] }] }; }
      var grp = pick.lines.length > 1 ? pick.key : null;
      pick.lines.forEach(function (l) {
        var sl = storeLine(l.handle, l.id);
        if (!sl) return;
        cart.extras = (cart.extras || []).concat([{ handle: l.handle, product: sl.product, variant: sl.variant, quantity: 1, addon: true,
          group: grp, groupName: grp ? pick.name : null, groupImg: grp ? pick.img : null }]);
      });
      document.getElementById("cart").innerHTML = renderCart();
      updateCart();
      return;
    }
    var vidEl = event.target.closest("[data-video]");
    if (vidEl) {
      var vEl = document.createElement("video");
      vEl.src = vidEl.getAttribute("data-video");
      vEl.controls = true; vEl.autoplay = true; vEl.playsInline = true;
      vEl.setAttribute("playsinline", "");
      vEl.className = "vid__video";
      vidEl.replaceWith(vEl);
      return;
    }
    var viewEl = event.target.closest("[data-view]");
    if (viewEl) {
      event.preventDefault();
      openProduct(viewEl.getAttribute("data-view"));
      return;
    }
    var actionEl = event.target.closest("[data-action]");
    if (actionEl) {
      var action = actionEl.getAttribute("data-action");
      if (action === "next") next();
      else if (action === "back") back();
      else if (action === "back-edit") go("severity");
      else if (action === "retake") { reset(); go("problems"); }
      else if (action === "profile-more") { var pf = actionEl.closest(".profile"); pf.classList.toggle("is-open"); actionEl.textContent = pf.classList.contains("is-open") ? "Show less" : "Show all"; }
      else if (action === "open-sheet") {
        // Captain, 14 Oct: no modal. Scroll to the setup on the page and highlight it briefly.
        var setupEl2 = document.getElementById("res-2");
        if (setupEl2) {
          window.scrollTo({ top: setupEl2.getBoundingClientRect().top + window.scrollY - 110, behavior: "smooth" });
          setupEl2.classList.remove("is-flash");
          void setupEl2.offsetWidth;
          setupEl2.classList.add("is-flash");
        }
      }
      else if (action === "skip-analyzing") { go("results"); }
      else if (action === "close-sheet") { closeSheet(); }
      else if (action === "customize" && window.BDSBuilder && window.BDSBuilder.slideout) { openBuilder(); }
      else if (action === "customize") {
        var resEl = app.querySelector(".results");
        if (resEl) resEl.classList.add("is-custom");
        var setupEl = document.getElementById("res-2");
        if (setupEl) window.scrollTo({ top: setupEl.getBoundingClientRect().top + window.scrollY - 120, behavior: "smooth" });
      }
      else if (action === "more-problems") {
        showAllProblems = true;
        app.innerHTML = RENDER.problems();
        var revealed = app.querySelectorAll(".options--problems .option")[quiz.problemsShown || 0];
        if (revealed) revealed.focus();
      }
      else if (action === "use-kit" || action === "split-kit") {
        cart.useKit = action === "use-kit";
        allRows().forEach(function (row) { if (!(row.id in cart.selected)) cart.selected[row.id] = !row.optional; });
        document.getElementById("cart").innerHTML = renderCart();
        updateCart();
      }
      return;
    }

    // Clicking anywhere on a product row (except its link or checkbox) toggles it.
    var rowEl = event.target.closest(".row");
    var qtyEl = event.target.closest("[data-qty]");
    if (qtyEl && rowEl) {
      var qtyRowId = rowEl.getAttribute("data-row");
      var newQty = Math.min(MAX_QTY, Math.max(1, (cart.qty[qtyRowId] || 1) + Number(qtyEl.getAttribute("data-qty"))));
      cart.qty[qtyRowId] = newQty;
      // Adding more of something means they want it.
      if (Number(qtyEl.getAttribute("data-qty")) > 0) {
        cart.selected[qtyRowId] = true;
        rowEl.querySelector(".row__check").checked = true;
      }
      rowEl.querySelector(".qty__value").textContent = newQty;
      rowEl.querySelector('[data-qty="-1"]').disabled = newQty <= 1;
      rowEl.querySelector('[data-qty="1"]').disabled = newQty >= MAX_QTY;
      updateCart();
      return;
    }

    var guideEl = event.target.closest("[data-guide]");
    if (guideEl) {
      openGuide(guideEl.getAttribute("data-guide"));
      return;
    }

    var soldEl = event.target.closest("[data-soldout]");
    if (soldEl) {
      // Tap shows what it is, and selects nothing.
      var lab = soldEl.closest(".picker__row, .picker");
      var strong = lab && lab.querySelector(".picker__mini strong, .picker__label strong");
      if (strong) { var was = strong.getAttribute("data-was") || strong.textContent; strong.setAttribute("data-was", was); strong.textContent = soldEl.getAttribute("data-soldout") + " · Sold out"; clearTimeout(strong.__t); strong.__t = setTimeout(function () { strong.textContent = was; strong.removeAttribute("data-was"); }, 1800); }
      return;
    }
    var variantEl = event.target.closest("[data-variant]");
    if (variantEl && rowEl) {
      var rowId = rowEl.getAttribute("data-row");
      cart.variants[rowId] = Number(variantEl.getAttribute("data-variant"));
      // Choosing a colour means they want it.
      cart.selected[rowId] = true;
      var fresh = allRows().filter(function (r) { return r.id === rowId; })[0];
      rowEl.outerHTML = renderRow(fresh);
      updateCart();
      var again = app.querySelector('[data-row="' + cssEscape(rowId) + '"] [data-variant="' + fresh.variant.id + '"]');
      if (again) again.focus();
      return;
    }
    if (rowEl && !event.target.closest("a, input, label, button")) {
      var box = rowEl.querySelector(".row__check");
      box.checked = !box.checked;
      box.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    var optionEl = event.target.closest(".option");
    if (!optionEl || optionEl.disabled) return;
    var value = optionEl.getAttribute("data-value");
    var group = optionEl.parentElement;

    var toggleKey = group.getAttribute("data-toggle");
    if (toggleKey === "problems") {
      var list = answers.problems;
      var at = list.indexOf(value);
      if (at === -1) list.push(value);
      else list.splice(at, 1);
      answers.drill = null;
      answers.ranked = false;
      // Update in place rather than re-rendering, so the page doesn't jump on every tap.
      var full = list.length >= quiz.maxProblems;
      group.querySelectorAll(".option").forEach(function (el) {
        var on = list.indexOf(el.getAttribute("data-value")) !== -1;
        el.setAttribute("aria-pressed", on ? "true" : "false");
        el.disabled = full && !on;
      });
      app.querySelector(".counter").textContent = list.length + " of " + quiz.maxProblems + " selected";
      app.querySelector(".step__footer .button").disabled = !list.length;
      return;
    }

    var key = group.getAttribute("data-choose");
    if (key === "style") {
      // Vibe picker: re-theme live on every tap (a colour wash from the tapped card), then Continue.
      answers.style = value;
      setVibe(value, event.clientX, event.clientY);
      group.querySelectorAll(".option").forEach(function (el) { el.setAttribute("aria-pressed", el === optionEl ? "true" : "false"); });
      var go2 = app.querySelector("[data-vibe-next]");
      if (go2) go2.disabled = false;
      return;
    }
    if (!key || advancing) return;
    advancing = true;
    if (key === "rank") {
      if (answers.problems[0] !== value) answers.drill = null;
      answers.problems = [value].concat(answers.problems.filter(function (id) { return id !== value; }));
      answers.ranked = true;
    } else {
      if (key === "severity" && value === "auto") { answers.severity = 4; answers.severityAuto = true; }
      else { answers[key] = key === "severity" ? Number(value) : value; if (key === "severity") answers.severityAuto = false; }
      if (key === "style") QROOT.setAttribute("data-vibe", value);
    }

    group.querySelectorAll(".option").forEach(function (el) { el.setAttribute("aria-pressed", el === optionEl ? "true" : "false"); });
    setTimeout(next, 220);
  });

  app.addEventListener("change", function (event) {
    var id = event.target.getAttribute("data-row-check");
    if (!id) return;
    cart.selected[id] = event.target.checked;
    updateCart();
  });

  reset();
  go("intro");
})();

